import gpl from 'graphql-tag';

export default {
  query:{
    allUsuarios: gpl `{
      allUsuarios{
        _id
        email
        nombreUsuario
        claveDeAcceso
        perfil{
          _id
          descrPerfil
        }
        estadoUsuario
        descrOficina
        _idDpto
        codigoDpto
        descrDpto
        codigoCiudad
        nombreCiudad
        numeroDocum
        descrTipoRec
        userApp
      }
    }
    `,
    allAutorizac: gpl `{
      allAutorizac{
        _id
        codigoAutorizac
        descrAutorizac
      }
    }
    `,
    allPerfiles: gpl `{
      allPerfiles{
        _id
        descrPerfil
        autorizac{
          codigoAutorizac
          descrAutorizac
        }
      }
    }
    `,
    allSequence: gpl `
      query ($_id: ID){
        allSequence(_id: $_id) {
          _id
          coleccion
          seq
        }
      }
    `,
    getParametro: gpl `
      query ($_id: ID){
        getParametro(_id: $_id) {
          _id
          contratoSequence
          mensaje
          mensajeApp
          nuevoNumeroOS
          nuevoNumeroRC
          nuevoNumeroND
          nuevoNumeroNC
          nuevoNumeroAj
          nuevoNumeroDX
          ajCero
          prefijoFact
          comoAsigCicloFact
          impRboCaja
          enPagoApp
          comoAsigCargosAlCliente
          empresaRazonSocial
          empresaNit
          empresaDir
          empresaTel
          codBarrasRdo
          pagueHastaSegunSaldo
          numMesesParaPH
          modeloFactura
          modeloFacturaPF
          modeloCodBarras
          empresaArchFE
          prefijoServ
          labelUpdApp
          numDiasAP
          valorparaPermRX
          IdentificadorOperador_CUN
          mesesUltDXImpDC
        }
      }
    `,
    allMigrarBarrio: gpl `{
      allMigrarBarrio{
        _id
        codDpto
        codCiudad
        codZonas
        zona
        codigoBarrio
        nombrearea
        descrRecursoT
        numeroDocumT
        codigoTipoDocT
        descrRecursoR
        numeroDocumR
        codigoTipoDocR
      }
    }
    `,
    allMigrarServicio: gpl `{
      allMigrarServicio{
        _id
        idClaseServ
        codigoClaseServ
        descrClaseServ
        subclase
        codServicio
        DescResServicio
        DescServicio
        conceptoFra
        consecutivo
      }
    }
    `,
    allMigrarTarifa: gpl `{
      allMigrarTarifa{
        _id
        DescServicio
        Valor
        IVA
        ParaTarifa
      }
    }
    `,
    allMigrarCliente: gpl `{
      allMigrarCliente{
        _id
        contrato
        nombreCliente
        apellidoCliente
        estadoCliente
        eMail
        descrEstrato
        codigoTipoDoc
        numeroDoc
        codigoTipoCliente
        codigoGrupoAfin
        codigoMarquilla
        observaciones
        saldoPendiente
        telefono1
        telefono2
        telefono3
        referencia1
        telefonoRef1
        referencia2
        telefonoRef2
        codigoClaseEqu
        mac
        descrTipoVia1
        numeroTipoVia1
        descrTipoVia2
        numeroTipoVia2
        numeroTipoVia2F
        codigoBarrio
        codigoTarifa
        codigoServicio
        nombreResumido
        valor
      }
    }
    `,
    allMigrarDireccion: gpl `{
      allMigrarDireccion{
        numerocontrato
        TipoVia1
        campo2dir
        TipoVia2
        campo4dir
        campo5dir
        TipoUnd1
        direccioninterna
        TipoUnd2
        Piso
        direccioninterna1
      }
    }
    `,
    allMigrarDirmayor: gpl `{
      allMigrarDirmayor{
        numerocontrato
        CODDPTO
        DPTO
        CODCIUDAD
        CIUDAD
        CODZONAS
        ZONA
        CODAR
        nombrearea
      }
    }
    `,
    allMigrarTarifaCli: gpl `{
      allMigrarTarifaCli{
        numerocontrato
        descrTarifa
        nombreResumido1
        nombreResumido2
        nombreResumido3
        DescServicio
        Valor
        IVA
      }
    }
    `,
    allMigrarMovimCli: gpl `{
      allMigrarMovimCli{
        contrato
        fechaMov
        tipo
        subTipo
        procesado
        pagueHasta
        numeroOdeDX
        codigoServicio
        nombreResumido
        descripcionServicio
        descrClaseServ
        concepto
        periodo
        origen
        saldoCliente
        valorTotal
        valorAntesImptos
        valorPagado
        agno
        mes
        numeroFra
        valorPendiente
        documento
        fechaCreate
        orden
      }
    }
    `,
    allMigrarHistCli: gpl `{
      allMigrarHistCli{
        contrato
        movimiento
        descripcion
        detalle
        relacion
        ACargar
        Pagado
        fechaCreate
        orden
      }
    }
    `,
    allMigrarEquipo: gpl `{
      allMigrarEquipo{
        contrato
        Mac
        Localizacion
      }
    }
    `,
    allCliTodos: gpl `{
      allCliTodos{
        _id
        estadoCliente
        contrato
        nombreCliente
        apellidoCliente
        saldoPendiente
      }
    }
    `,
    allCliBasico: gpl `
      query ($contrato: String, $estadoCliente: String, $nombreCliente: String, $apellidoCliente: String,
        $descrDpto: String, $nombreCiudad: String, $nombreZona: String, $nombreBarrio: String){
          allCliBasico(contrato: $contrato, estadoCliente: $estadoCliente, nombreCliente: $nombreCliente,
            apellidoCliente: $apellidoCliente, descrDpto: $descrDpto, nombreCiudad: $nombreCiudad,
            nombreZona: $nombreZona, nombreBarrio: $nombreBarrio) {
        _id
        estadoCliente
        contrato
        infAdic1
        nombreCliente
        apellidoCliente
        saldoPendiente
        cargoMensual
        diasMora
        pagueHasta
        totPagoAdelSinFrar
        porcFact
        envFraCorreo
        eMail
        fechaUltDX
        fechaCreacionSistema
        fechaPrimeraActivacion
        cicloFact
        numeroDoc
        descrNodo
        updDocApp
        dirmayor{
          codigoDpto
          descrDpto
          ciudades{
            codigoCiudad
            nombreCiudad
            codigoCiudadInterno
            codBarrasRdo          
            zonas{
              codigoZona
              nombreZona
              barrios{
                codigoBarrio
                nombreBarrio
                codigoTipoDocT
                numeroDocumT
                descrRecursoT
                codigoTipoDocR
                numeroDocumR
                descrRecursoR
              }
            }
          }
        }
        direccion{
          descrTipoVia1
          numeroTipoVia1
          descrTipoVia2
          numeroTipoVia2
          numeroTipoVia2F
          descrTipoUnd1
          numeroTipoUnd1
          descrTipoUnd2
          numeroTipoUnd2
          descrTiUndMat
          descrUndMat
        }
      }
    }
    `,
    allCliWeb: gpl `
      query ($contrato: String, $numeroDoc: String){
          allCliWeb(contrato: $contrato, numeroDoc: $numeroDoc) {
        _id
        estadoCliente
        contrato
        infAdic1
        nombreCliente
        apellidoCliente
        saldoPendiente
        cargoMensual
        numSorteos
        tag
        diasMora
        fechaUltDX
        fechaCreacionSistema
        fechaPrimeraActivacion
        numeroDoc
        dirmayor{
          codigoDpto
          descrDpto
          ciudades{
            codigoCiudad
            nombreCiudad
            codigoCiudadInterno
            codBarrasRdo          
            zonas{
              codigoZona
              nombreZona
              barrios{
                codigoBarrio
                nombreBarrio
                codigoTipoDocT
                numeroDocumT
                descrRecursoT
                codigoTipoDocR
                numeroDocumR
                descrRecursoR
              }
            }
          }
        }
        direccion{
          descrTipoVia1
          numeroTipoVia1
          descrTipoVia2
          numeroTipoVia2
          numeroTipoVia2F
          descrTipoUnd1
          numeroTipoUnd1
          descrTipoUnd2
          numeroTipoUnd2
          descrTiUndMat
          descrUndMat
        }
        tarifa{
          codigoTarifa
          descrTarifa
          fechaVence
          servicios{
            codigoServicio
            nombreResumido
            descripcionServicio
            subclaseserv{
              _id
              codigoSubclaseServ
              descrSubclaseServ
              claseserv{
                _id
                codigoClaseServ
                descrClaseServ
              }
            }
            estadoServicio
            rango1NumServValorIni
            rango1NumServValorFin
            rango1Valor
            rango2NumServValorIni
            rango2NumServValorFin
            rango2Valor
            rango3NumServValorIni
            rango3NumServValorFin
            rango3Valor
            numeroServicios
            valorServicios
            valorAntesImptos
            imptos{
              codigoImpto
              descrImpto
              porcImpto
              valorImpto
            }
          }
        }
      }
    }
    `,
    allClientes: gpl `
      query ($_id: ID, $contrato: String, $nombreCliente: String, $apellidoCliente: String,
        $descrClaseServ: String, $descrSubclaseServ: String,
        $descrDpto: String, $nombreCiudad: String, $nombreZona: String, $nombreBarrio: String,
        $descrRecursoR: String,
        $estadoCliente: String, $descrEstrato: String, $telefono1: String, $telefono2: String,
        $telefono3: String, $numeroDoc: String, $descrTipoCliente: String, $descrGrupoAfin: String,
        $diasMoraIni: Number, $diasMoraFin: Number, $telefono: String, $descrTipoVia1: String,
        $numeroTipoVia1: String, $descrTipoVia2: String, $numeroTipoVia2: String, $numeroTipoVia2F: String,
        $mac: String, $codigoMarquilla: String,
        $numDocum: Int, $tipoProc: String, $cicloFact: String, $descrNodo: String, $campos: String){
          allClientes(_id: $_id, contrato: $contrato, nombreCliente: $nombreCliente,
            apellidoCliente: $apellidoCliente, descrClaseServ: $descrClaseServ,
            descrSubclaseServ: $descrSubclaseServ, descrDpto: $descrDpto, nombreCiudad: $nombreCiudad,
            nombreZona: $nombreZona, nombreBarrio: $nombreBarrio, descrRecursoR: $descrRecursoR,
            estadoCliente: $estadoCliente,
            descrEstrato: $descrEstrato, telefono1: $telefono1, telefono2: $telefono2,
            telefono3: $telefono3, numeroDoc: $numeroDoc, descrTipoCliente: $descrTipoCliente,
            descrGrupoAfin: $descrGrupoAfin, diasMoraIni: $diasMoraIni, diasMoraFin: $diasMoraFin,
            telefono: $telefono, descrTipoVia1: $descrTipoVia1,
            numeroTipoVia1: $numeroTipoVia1, descrTipoVia2: $descrTipoVia2, numeroTipoVia2: $numeroTipoVia2,
            numeroTipoVia2F: $numeroTipoVia2F, mac: $mac, codigoMarquilla: $codigoMarquilla,
            numDocum: $numDocum, tipoProc: $tipoProc,
            cicloFact: $cicloFact, descrNodo: $descrNodo, campos: $campos) {
        _id
        contrato
        infAdic1
        nombreCliente
        apellidoCliente
        estadoCliente
        saldoPendiente
        diasMora
        pagueHasta
        totPagoAdelSinFrar
        porcFact
        envFraCorreo
        sexoCliente
        eMail
        descrEstrato
        cicloFact
        tag
        referencia1
        telefonoRef1
        referencia2
        telefonoRef2
        fechaCreacionSistema
        fechaUltOSAb
        fechaPrimeraActivacion
        fechaUltDX
        fecgaUltRX
        estadoAnterior
        fechaUltOSCe
        fechaUltPago
        valorUltPago
        cupoFinanc
        numeroOdeDX
        telefono1
        telefono2
        telefono3
        fechaCumple
        datosConfirmados
        autFraEmail
        autFraWhatsApp
        cargoMensual
        observaciones
        codigoMarquilla
        ubicacion{
          latitude
          longitude
        }
        descrNodo
        codigoSegmento
        descrSegmento
        codigoPaquete
        descrPaquete
        numSorteos
        noFactOSAb
        dirmayor{
          codigoDpto
          descrDpto
          codigoDptoDANE
          ciudades{
            codigoCiudad
            nombreCiudad
            codigoMunicipioDANE
            codigoPostalDANE
            codigoCiudadInterno
            codBarrasRdo          
            zonas{
              codigoZona
              nombreZona
              barrios{
                codigoBarrio
                nombreBarrio
                codigoTipoDocT
                numeroDocumT
                descrRecursoT
                codigoTipoDocR
                numeroDocumR
                descrRecursoR
              }
            }
          }
        }
        direccion{
          descrTipoVia1
          numeroTipoVia1
          descrTipoVia2
          numeroTipoVia2
          numeroTipoVia2F
          descrTipoUnd1
          numeroTipoUnd1
          descrTipoUnd2
          numeroTipoUnd2
          descrTiUndMat
          descrUndMat
        }
        tarifa{
          codigoTarifa
          descrTarifa
          fechaVence
          servicios{
            codigoServicio
            nombreResumido
            descripcionServicio
            subclaseserv{
              _id
              codigoSubclaseServ
              descrSubclaseServ
              claseserv{
                _id
                codigoClaseServ
                descrClaseServ
              }
            }
            velEfecDownstream
            velEfecUpstream
            codigoTipoTec
            descrTipoTec
            colorServicio
            estadoServicio
            rango1NumServValorIni
            rango1NumServValorFin
            rango1Valor
            rango2NumServValorIni
            rango2NumServValorFin
            rango2Valor
            rango3NumServValorIni
            rango3NumServValorFin
            rango3Valor
            numeroServicios
            valorServicios
            valorAntesImptos
            imptos{
              codigoImpto
              descrImpto
              porcImpto
              valorImpto
            }
          }
        }
        oferta{
          codigoOferta
          descrOferta
          servicios{
            codigoServicio
            nombreResumido
            descripcionServicio
            porcDctoOferta
            numDiasOferta
            fechaFinOferta
            subclaseserv{
              _id
              codigoSubclaseServ
              descrSubclaseServ
              claseserv{
                _id
                codigoClaseServ
                descrClaseServ
              }
            }
          }
          fechaInicioOferta
        }
        equipos{
          numeroSerie
          mac
          estadoEquipo
          claseequ{
            _id
            codigoClaseEqu
            descrClaseEqu
          }
          marcaequ{
          _id
            codigoMarcaEqu
            descrMarcaEqu
          }
          fabriequ{
            _id
            codigoFabriEqu
            descrFabriEqu
          }
          bodega{
            _id
            codigoBodega
            descrBodega
          }
        }
        tipodoc{
          _id
          codigoTipoDoc
          descrTipoDoc
        }
        numeroDoc
        updDocApp
        tipocl{
          codigoTipoCliente
          descrTipoCliente
        }
        grupoaf{
          _id
          codigoGrupoAfin
          descrGrupoAfin
        }
      }
    }
    `,
    allClientesRtesGroup: gpl `
    query ($tipoqry: String){
      allClientesRtesGroup(tipoqry: $tipoqry) {
        descrRecurso
        rango
        cuenta
      }
    }
    `,
    allClientesRtes: gpl `
      query ($contrato: String, $nombreCliente: String, $apellidoCliente: String,
        $descrClaseServ: String, $descrSubclaseServ: String,
        $descrDpto: String, $nombreCiudad: String, $nombreZona: String, $nombreBarrio: String,
        $descrRecursoR: String,
        $estadoCliente: String, $descrEstrato: String, $telefono1: String, $telefono2: String,
        $telefono3: String, $numeroDoc: String, $descrTipoCliente: String, $descrGrupoAfin: String,
        $diasMoraIni: Number, $diasMoraFin: Number, $telefono: String, $numDocum: Int, $tipoqry: String){
          allClientesRtes(contrato: $contrato, nombreCliente: $nombreCliente,
            apellidoCliente: $apellidoCliente, descrClaseServ: $descrClaseServ,
            descrSubclaseServ: $descrSubclaseServ, descrDpto: $descrDpto, nombreCiudad: $nombreCiudad,
            nombreZona: $nombreZona, nombreBarrio: $nombreBarrio, descrRecursoR: $descrRecursoR,
            estadoCliente: $estadoCliente,
            descrEstrato: $descrEstrato, telefono1: $telefono1, telefono2: $telefono2,
            telefono3: $telefono3, numeroDoc: $numeroDoc, descrTipoCliente: $descrTipoCliente,
            descrGrupoAfin: $descrGrupoAfin, diasMoraIni: $diasMoraIni, diasMoraFin: $diasMoraFin,
            telefono: $telefono, numDocum: $numDocum, tipoqry: $tipoqry) {
        _id
        contrato
        infAdic1
        nombreCliente
        apellidoCliente
        estadoCliente
        saldoPendiente
        diasMora
        pagueHasta
        totPagoAdelSinFrar
        porcFact
        envFraCorreo
        sexoCliente
        eMail
        descrEstrato
        cicloFact
        numSorteos
        tag
        referencia1
        telefonoRef1
        referencia2
        telefonoRef2
        fechaCreacionSistema
        fechaUltOSAb
        fechaPrimeraActivacion
        fechaUltDX
        fecgaUltRX
        estadoAnterior
        fechaUltOSCe
        fechaUltPago
        valorUltPago
        cupoFinanc
        numeroOdeDX
        telefono1
        telefono2
        telefono3
        fechaCumple
        datosConfirmados
        autFraEmail
        autFraWhatsApp
        cargoMensual
        observaciones
        codigoMarquilla
        dirmayor{
          codigoDpto
          descrDpto
          ciudades{
            codigoCiudad
            nombreCiudad
            codigoCiudadInterno
            codBarrasRdo          
            zonas{
              codigoZona
              nombreZona
              barrios{
                codigoBarrio
                nombreBarrio
                codigoTipoDocT
                numeroDocumT
                descrRecursoT
                codigoTipoDocR
                numeroDocumR
                descrRecursoR
              }
            }
          }
        }
        direccion{
          descrTipoVia1
          numeroTipoVia1
          descrTipoVia2
          numeroTipoVia2
          numeroTipoVia2F
          descrTipoUnd1
          numeroTipoUnd1
          descrTipoUnd2
          numeroTipoUnd2
          descrTiUndMat
          descrUndMat
        }
        tarifa{
          codigoTarifa
          descrTarifa
          fechaVence
          servicios{
            codigoServicio
            nombreResumido
            descripcionServicio
            subclaseserv{
              _id
              codigoSubclaseServ
              descrSubclaseServ
              claseserv{
                _id
                codigoClaseServ
                descrClaseServ
              }
            }
            estadoServicio
            colorServicio
            rango1NumServValorIni
            rango1NumServValorFin
            rango1Valor
            rango2NumServValorIni
            rango2NumServValorFin
            rango2Valor
            rango3NumServValorIni
            rango3NumServValorFin
            rango3Valor
            numeroServicios
            valorServicios
            valorAntesImptos
            imptos{
              codigoImpto
              descrImpto
              porcImpto
              valorImpto
            }
          }
        }
        oferta{
          codigoOferta
          descrOferta
          servicios{
            codigoServicio
            nombreResumido
            descripcionServicio
            porcDctoOferta
            numDiasOferta
            fechaFinOferta
            subclaseserv{
              _id
              codigoSubclaseServ
              descrSubclaseServ
              claseserv{
                _id
                codigoClaseServ
                descrClaseServ
              }
            }
          }
          fechaInicioOferta
        }
        equipos{
          numeroSerie
          mac
          estadoEquipo
          claseequ{
            _id
            codigoClaseEqu
            descrClaseEqu
          }
          marcaequ{
          _id
            codigoMarcaEqu
            descrMarcaEqu
          }
          fabriequ{
            _id
            codigoFabriEqu
            descrFabriEqu
          }
          bodega{
            _id
            codigoBodega
            descrBodega
          }
        }
        tipodoc{
          _id
          codigoTipoDoc
          descrTipoDoc
        }
        numeroDoc
        updDocApp
        tipocl{
          codigoTipoCliente
          descrTipoCliente
        }
        grupoaf{
          _id
          codigoGrupoAfin
          descrGrupoAfin
        }
        movimientos{
          _id
          contrato
          pagueHasta
          valorTotal
          valorPagado
          codigoServicio
          descripcionServicio
          descrClaseServ
          documento
        }
      }
    }
    `,
    allTarifa: gpl `
      query ($_id: ID, $codigoTarifa: String, $descrTarifa: String, $estadoTarifa: Boolean){
          allTarifa(_id: $_id, codigoTarifa: $codigoTarifa, descrTarifa: $descrTarifa, estadoTarifa: $estadoTarifa) {
        _id
        codigoTarifa
        descrTarifa
        cicloFact
        estadoTarifa
        servicios{
          codigoServicio
          nombreResumido
          descripcionServicio
          subclaseserv{
            _id
            codigoSubclaseServ
            descrSubclaseServ
            claseserv{
              _id
              codigoClaseServ
              descrClaseServ
            }
          }
          velEfecDownstream
          velEfecUpstream
          codigoTipoTec
          descrTipoTec
          colorServicio
          rango1NumServValorIni
          rango1NumServValorFin
          rango1Valor
          rango2NumServValorIni
          rango2NumServValorFin
          rango2Valor
          rango3NumServValorIni
          rango3NumServValorFin
          rango3Valor
          imptos{
            _id
            codigoImpto
            descrImpto
            porcImpto
          }
        }
        tipoos{
          codigoTipoOS
          descrTipoOS
          concepto1Tarifa
          valor1Tarifa
          concepto2Tarifa
          valor2Tarifa
          concepto3Tarifa
          valor3Tarifa
          imptos{
              _id
              codigoImpto
              descrImpto
              porcImpto
          }
        }
      }
    }
    `,
            allOferta: gpl `
              query ($_id: ID, $codigoOferta: String, $descrOferta: String, $estadoOferta: Boolean, $nombreResumido: String, $descripcionServicio: String, $descrClaseServ : String, $descrSubclaseServ: String){
                  allOferta(_id: $_id, codigoOferta: $codigoOferta, descrOferta: $descrOferta, estadoOferta: $estadoOferta, nombreResumido: $nombreResumido, descripcionServicio: $descripcionServicio, descrClaseServ : $descrClaseServ, descrSubclaseServ: $descrSubclaseServ) {
                      _id
                      codigoOferta
                      descrOferta
                      estadoOferta
                      servicios{
                          codigoServicio
                          nombreResumido
                          descripcionServicio
                          porcDctoOferta
                          numDiasOferta
                          subclaseserv{
                              _id
                              codigoSubclaseServ
                              descrSubclaseServ
                              claseserv{
                                  _id
                                  codigoClaseServ
                                  descrClaseServ
                              }
                          }
                      }
                  }
              }
          `,
          allDirmayor: gpl `
            query ($_id: ID, $codigoDpto: String, $descrDpto: String, $codigoCiudad: String, $nombreCiudad: String,
                  $codigoZona: String, $nombreZona: String, $codigoBarrio: String, $nombreBarrio: String){
                allDirmayor(_id: $_id, codigoDpto: $codigoDpto, descrDpto: $descrDpto, codigoCiudad: $codigoCiudad,
                  nombreCiudad: $nombreCiudad, codigoZona: $codigoZona, nombreZona: $nombreZona, codigoBarrio: $codigoBarrio, nombreBarrio: $nombreBarrio) {
                _id
                codigoDpto
                descrDpto
                codigoDptoDANE
                ciudades{
                  codigoCiudad
                  nombreCiudad
                  codigoMunicipioDANE
                  codigoPostalDANE
                  codigoCiudadInterno
                  codBarrasRdo
                  zonas{
                    codigoZona
                    nombreZona
                    barrios{
                        codigoBarrio
                        nombreBarrio
                        codigoTipoDocT
                        numeroDocumT
                        descrRecursoT
                        codigoTipoDocR
                        numeroDocumR
                        descrRecursoR
                    }
                  }
                }
            }
        }
        `,
        allDirmayorRtes: gpl `
          query ($tipoqry: String){
            allDirmayorRtes(tipoqry: $tipoqry) {
              codigoDpto
              descrDpto
              codigoDptoDANE
              codigoCiudad
              nombreCiudad
              codigoMunicipioDANE
              codigoPostalDANE
              codigoCiudadInterno
              codBarrasRdo
              codigoZona
              nombreZona
              codigoBarrio
              nombreBarrio
            }
          }
        `,
            allServicios: gpl `
            query ($codigoServicio: String, $nombreResumido: String,
                $descripcionServicio: String, $paraProcMasDX: String){
                allServicios(codigoServicio: $codigoServicio, nombreResumido: $nombreResumido,
                    descripcionServicio: $descripcionServicio, paraProcMasDX: $paraProcMasDX) {
                _id
                codigoServicio
                nombreResumido
                descripcionServicio
                conceptoEnFra
                consecEnFra
                paraProcMasDX
                subclaseserv{
                    _id
                    codigoSubclaseServ
                    descrSubclaseServ
                    claseserv{
                        _id
                        codigoClaseServ
                        descrClaseServ
                    }
                }
                velEfecDownstream
                velEfecUpstream
                codigoTipoTec
                descrTipoTec
                colorServicio
                paraProcMasDX
            }
        }
        `,
        allDetalleDX: gpl `
            query ($estadoDetDX: String, $numeroOdeDX: Number, $contrato: String, $descripcionServicio: String,
                $descrClaseServ: String){
            allDetalleDX(estadoDetDX: $estadoDetDX, numeroOdeDX: $numeroOdeDX, contrato: $contrato,
                descripcionServicio: $descripcionServicio, descrClaseServ: $descrClaseServ) {
                _id
                numeroOdeDX
                contrato
                codigoTarifa
                codigoServicio
                descripcionServicio
                descrClaseServ
                idMovim
                codigoServicioM
                descripcionServicioM
                descrClaseServM
                documento
                valorTotal
                valorPagado
                pagueHasta
                diasMora
                diasDXDesde
                numVecesDX            
                estadoDetDX
                fechaRX
            }
          }
          `,
          allDetalleDXRtes: gpl `
          query ($tipoqry: String){
            allDetalleDXRtes(tipoqry: $tipoqry) {
              contrato
              numVecesDX
              }
            }
            `,
            allMovClientes: gpl `
            query ($contrato: String, $numeroOdeDX: Number, $codigoServicio: String, $nombreResumido: String,
                $descripcionServicio: String, $descrClaseServ: String,
                $origen: String, $valorTotal: Number, $numeroFra: String, $agno: String, $mes: String, $orden: String){
                allMovClientes(contrato: $contrato, numeroOdeDX: $numeroOdeDX, codigoServicio: $codigoServicio, nombreResumido: $nombreResumido,
                    descripcionServicio: $descripcionServicio, descrClaseServ: $descrClaseServ,
                    origen: $origen, valorTotal: $valorTotal, numeroFra: $numeroFra, agno: $agno, mes: $mes, orden: $orden) {
                _id
                contrato
                fechaMov
                tipo
                subTipo
                procesado
                pagueHasta
                numeroOdeDX
                codigoServicio
                nombreResumido
                descripcionServicio
                descrClaseServ
                concepto
                periodo
                origen
                saldoCliente
                valorTotal
                valorAntesImptos
                imptos{
                  codigoImpto
                  descrImpto
                  porcImpto
                  valorImpto
                }
                agno
                mes
                numeroFra
                numeroCE
                numeroRC
                documento
                valorPagado
                fechaUltPago
                valorUltPago
            }
          }
          `,
          allMovTodos: gpl `
            query ($procesado: String, $tipo: String, $pagueHasta: Date, $numeroOdeDX: Number,
              $valorPendiente: Number, $tipoProc: String){
            allMovTodos(procesado: $procesado, tipo: $tipo, pagueHasta: $pagueHasta, numeroOdeDX: $numeroOdeDX,
              valorPendiente: $valorPendiente, tipoProc: $tipoProc) {
              _id
              contrato
              fechaMov
              tipo
              subTipo
              procesado
              pagueHasta
              numeroOdeDX
              codigoServicio
              nombreResumido
              descripcionServicio
              descrClaseServ
              concepto
              periodo
              origen
              saldoCliente
              valorTotal
              valorAntesImptos
              imptos{
                codigoImpto
                descrImpto
                porcImpto
                valorImpto
              }
              agno
              mes
              numeroFra
              numeroCE
              numeroRC
              documento
              valorPagado
              valorPendiente
              fechaUltPago
              valorUltPago
            }
          }
          `,
          allMovRtes: gpl `
            query ($procesado: String, $tipo: String, $pagueHasta: Date, $numeroOdeDX: Number,
              $valorTotal: Number, $valorPagado: Number, $valorPendiente: Number,
              $tipoqry: String, $tipoProc: String){
              allMovRtes(procesado: $procesado, tipo: $tipo, pagueHasta: $pagueHasta,
                numeroOdeDX: $numeroOdeDX, valorTotal: $valorTotal, valorPagado: $valorPagado,
                valorPendiente: $valorPendiente, tipoqry: $tipoqry, tipoProc: $tipoProc) {
              _id
              contrato
              fechaMov
              tipo
              subTipo
              procesado
              pagueHasta
              numeroOdeDX
              codigoServicio
              nombreResumido
              descripcionServicio
              descrClaseServ
              concepto
              periodo
              origen
              saldoCliente
              valorTotal
              valorAntesImptos
              imptos{
                codigoImpto
                descrImpto
                porcImpto
                valorImpto
              }
              agno
              mes
              numeroFra
              numeroCE
              numeroRC
              documento
              valorPagado
              valorPendiente
              fechaUltPago
              valorUltPago
              cliente{
                contrato
                saldoPendiente
                dirmayor{
                  codigoDpto
                  descrDpto
                  ciudades{
                    codigoCiudad
                    nombreCiudad
                    zonas{
                      codigoZona
                      nombreZona
                      barrios{
                        codigoBarrio
                        nombreBarrio
                        codigoTipoDocT
                        numeroDocumT
                        descrRecursoT
                        codigoTipoDocR
                        numeroDocumR
                        descrRecursoR
                      }
                    }
                  }
                }      
              }    
            }
          }
          `,
        allMovClientesCC: gpl `
            query ($contrato: String, $numeroOdeDX: Number, $codigoServicio: String, $nombreResumido: String,
                $descripcionServicio: String, $descrClaseServ: String, $agno: String, $mes: String, $orden: String){
                allMovClientesCC(contrato: $contrato, numeroOdeDX: $numeroOdeDX, codigoServicio: $codigoServicio, nombreResumido: $nombreResumido,
                    descripcionServicio: $descripcionServicio, descrClaseServ: $descrClaseServ,
                    agno: $agno, mes: $mes, orden: $orden) {
                _id
                contrato
                fechaMov
                tipo
                subTipo
                procesado
                pagueHasta
                numeroOdeDX
                codigoServicio
                nombreResumido
                descripcionServicio
                descrClaseServ
                velEfecDownstream
                velEfecUpstream
                codigoTipoTec
                descrTipoTec
                concepto
                periodo
                origen
                saldoCliente
                valorTotal
                valorAntesImptos
                imptos{
                  codigoImpto
                  descrImpto
                  porcImpto
                  valorImpto
                }
                agno
                mes
                numeroFra
                numeroCE
                numeroRC
                documento
                valorPagado
                fechaUltPago
                valorUltPago
            }
          }
          `,
          allMovTodosCC: gpl `
            query ($procesado: String, $agno: String, $mes: String, $tipo: String, $pagueHasta: Date, $numeroOdeDX: Number){
            allMovTodosCC(procesado: $procesado, agno: $agno, mes: $mes, tipo: $tipo, pagueHasta: $pagueHasta, numeroOdeDX: $numeroOdeDX) {
              _id
              contrato
              fechaMov
              tipo
              subTipo
              procesado
              pagueHasta
              numeroOdeDX
              codigoServicio
              nombreResumido
              descripcionServicio
              descrClaseServ
              velEfecDownstream
              velEfecUpstream
              codigoTipoTec
              descrTipoTec
              concepto
              periodo
              origen
              saldoCliente
              valorTotal
              valorAntesImptos
              imptos{
                codigoImpto
                descrImpto
                porcImpto
                valorImpto
              }
              agno
              mes
              numeroFra
              numeroCE
              numeroRC
              documento
              valorPagado
              fechaUltPago
              valorUltPago
            }
          }
          `,
          allMovRtesCC: gpl `
            query ($procesado: String, $tipo: String, $pagueHasta: Date, $numeroOdeDX: Number, $tipoqry: String){
              allMovRtesCC(procesado: $procesado, tipo: $tipo, pagueHasta: $pagueHasta, numeroOdeDX: $numeroOdeDX, tipoqry: $tipoqry) {
              _id
              contrato
              fechaMov
              tipo
              subTipo
              procesado
              pagueHasta
              numeroOdeDX
              codigoServicio
              nombreResumido
              descripcionServicio
              descrClaseServ
              velEfecDownstream
              velEfecUpstream
              codigoTipoTec
              descrTipoTec
              concepto
              periodo
              origen
              saldoCliente
              valorTotal
              valorAntesImptos
              imptos{
                codigoImpto
                descrImpto
                porcImpto
                valorImpto
              }
              agno
              mes
              numeroFra
              numeroCE
              numeroRC
              documento
              valorPagado
              fechaUltPago
              valorUltPago
              fechaNoFact
              usuarioNoFact
              usuarioCreate
              cliente{
                contrato
                estadoCliente
                saldoPendiente
                dirmayor{
                  codigoDpto
                  descrDpto
                  ciudades{
                    codigoCiudad
                    nombreCiudad
                    zonas{
                      codigoZona
                      nombreZona
                      barrios{
                        codigoBarrio
                        nombreBarrio
                        codigoTipoDocT
                        numeroDocumT
                        descrRecursoT
                        codigoTipoDocR
                        numeroDocumR
                        descrRecursoR
                      }
                    }
                  }
                }      
              }    
            }
          }
        `,
        allProgServ: gpl `
          query ($_id: ID, $contrato: String, $procesado: String){
            allProgServ(_id: $_id, contrato: $contrato, procesado: $procesado) {
            _id
            contrato
            fechaProg
            procesado
            codigoTarifa
            descrTarifa
            codigoServicio
            nombreResumido
            descripcionServicio
            valorTotal
          }
        }
        `,
          allPagoClientes: gpl `
          query ($_id: ID, $contrato: String, $fechaPago: Date, $tipo: String){
            allPagoClientes(_id: $_id, contrato: $contrato, fechaPago: $fechaPago, tipo: $tipo) {
              _id
              contrato
              saldoPendiente
              fechaPago
              tipo
              descripcionPago
              numeroFra
              numeroRC
              documento
              numeroRT
              numeroDocum
              descrRecurso
              descrOficina
              valorTotal
              valorEf
              valorCh
              numeroCh
              bancoCh
              fechaVencCh
              valorTr
              bancoTr
              fechaTr
              valorTD
              bancoTD
              valorTC
              bancoTC
              fechaCreate
              usuarioCreate
              detalle{
                idMovClientes
                codigoServicio
                nombreResumido
                descripcionServicio
                descrClaseServ
                concepto
                periodo
                valorTotal
                valorDetalle
              }
            }
          }
          `,
          allTempRdo: gpl `
          query ($fechaPago: Date, $tipoqry: String){
            allTempRdo(fechaPago: $fechaPago, tipoqry: $tipoqry) {
              totPagos
              fechaPago
              contrato
              nombreCiudad
              nombreBarrio
              descrClaseServ
              valorTotal
            }
          }
          `,
          allPagoRtesGroup: gpl `
          query ($fechaPago: Date, $documento: String, $tipoqry: String){
            allPagoRtesGroup(fechaPago: $fechaPago, documento: $documento, tipoqry: $tipoqry) {
              documento
              recaudoEn
              descrClaseServ
              nombreBarrio
              totPagos
              fechaPago
              contrato
              valorTotal
              descrRecurso
              usuarioCreate
              nombreUsuario
            }
          }
          `,
          allPagoRtes: gpl `
          query ($contrato: String, $fechaPago: Date, $documento: String, $tipo: String, $tipoqry: String){
            allPagoRtes(contrato: $contrato, fechaPago: $fechaPago, documento: $documento, tipo: $tipo, tipoqry: $tipoqry) {
              _id
              contrato
              saldoPendiente
              fechaPago
              tipo
              descripcionPago
              numeroFra
              numeroRC
              documento
              numeroRT
              numeroDocum
              descrRecurso
              descrOficina
              descrDpto
              nombreCiudad
              nombreZona
              nombreBarrio
              numeroDocumR
              descrRecursoR
              valorTotal
              valorEf
              valorCh
              numeroCh
              bancoCh
              fechaVencCh
              valorTr
              bancoTr
              fechaTr
              valorTD
              bancoTD
              valorTC
              bancoTC
              fechaCreate
              usuarioCreate
              detalle{
                idMovClientes
                codigoServicio
                nombreResumido
                descripcionServicio
                descrClaseServ
                concepto
                periodo
                valorTotal
                valorDetalle
              }
              razonap
              cliente{
                contrato
                nombreCliente
                apellidoCliente
                tipodoc{
                  codigoTipoDoc
                  descrTipoDoc
                }
                grupoaf{
                  descrGrupoAfin
                }
                numeroDoc
                updDocApp
                estadoCliente
                fechaPrimeraActivacion
                direccion{
                  descrTipoVia1
                  numeroTipoVia1
                  descrTipoVia2
                  numeroTipoVia2
                  numeroTipoVia2F
                  descrTipoUnd1
                  numeroTipoUnd1
                  descrTipoUnd2
                  numeroTipoUnd2
                  descrTiUndMat
                  descrUndMat
                }
                dirmayor{
                  codigoDpto
                  descrDpto
                  ciudades{
                    codigoCiudad
                    nombreCiudad
                    zonas{
                      codigoZona
                      nombreZona
                      barrios{
                        codigoBarrio
                        nombreBarrio
                        codigoTipoDocT
                        numeroDocumT
                        descrRecursoT
                        codigoTipoDocR
                        numeroDocumR
                        descrRecursoR
                      }
                    }
                  }
                }
                tarifa{
                    codigoTarifa
                    descrTarifa
                    servicios{
                        codigoServicio
                        nombreResumido
                        descripcionServicio
                        subclaseserv{
                            codigoSubclaseServ
                            descrSubclaseServ
                            claseserv{
                                codigoClaseServ
                                descrClaseServ
                            }
                        }
                        estadoServicio
                    }
                }    
              }
              usuario{
                nombreUsuario
              }
            }
          }
          `,
          getPagoCliente: gpl `
            query ($_id: ID, $contrato: String, $orden: String){
              getPagoCliente(_id: $_id, contrato: $contrato, orden: $orden) {
                _id
                contrato
                saldoPendiente
                fechaPago
                tipo
                descripcionPago
                numeroFra
                numeroRC
                documento
                numeroRT
                numeroDocum
                descrRecurso
                descrOficina
                valorTotal
                valorEf
                valorCh
                numeroCh
                bancoCh
                fechaVencCh
                valorTr
                bancoTr
                fechaTr
                valorTD
                bancoTD
                valorTC
                bancoTC
                fechaCreate
                usuarioCreate
                detalle{
                  idMovClientes
                  codigoServicio
                  nombreResumido
                  descripcionServicio
                  descrClaseServ
                  concepto
                  periodo
                  valorTotal
                  valorDetalle
                }
                razonap
            }
          }
          `,
        allFacturacion: gpl `
          query ($codProcFact: String, $tipoGen: String, $numeroFra: String, $fechaFact: Date, $fechaMov: Date,
            $contrato: String, $agno: String, $mes: String, $orden: String){
                allFacturacion(codProcFact: $codProcFact, tipoGen: $tipoGen, numeroFra: $numeroFra, fechaFact: $fechaFact,
                    fechaMov: $fechaMov, contrato: $contrato, agno: $agno, mes: $mes, orden: $orden) {
          _id
          codProcFact
          tipoGen
          idRangoFact
          numeroFra
          cufe
          fechaFact
          contrato
          pagueHasta
          direccion
          descrDpto
          nombreCiudad
          codigoCiudadInterno
          codBarrasRdo
          nombreZona
          nombreBarrio
          nombreCliente
          apellidoCliente
          saldoPendiente
          fechaMov
          valorAntesImptos
          valorFacturado
          valorFactura
          agno
          mes
          numeroDocum
          descrRecurso
          detalleFact{
            _idMC
            codigoServicio
            nombreResumido
            descripcionServicio
            descrClaseServ
            velEfecDownstream
            velEfecUpstream
            codigoTipoTec
            descrTipoTec
            concepto
            periodo
            tipo
            consecEnFra
            porcImpto
            valor
          }
      }
    }
    `,
    allFactRtes: gpl `
      query ($codProcFact: String, $tipoGen: String, $numeroFra: String, $fechaFact: Date,
        $fechaMov: Date, $contrato: String, $agno: String, $mes: String, $orden: String, $tipoqry: String){
          allFactRtes(codProcFact: $codProcFact, tipoGen: $tipoGen, numeroFra: $numeroFra,
            fechaFact: $fechaFact, fechaMov: $fechaMov, contrato: $contrato, agno: $agno, mes: $mes,
            orden: $orden, tipoqry: $tipoqry) {
      _id
      codProcFact
      tipoGen
      idRangoFact
      numeroFra
      cufe
      fechaFact
      contrato
      direccion
      descrDpto
      nombreCiudad
      codigoCiudadInterno
      codBarrasRdo
      nombreZona
      nombreBarrio
      nombreCliente
      apellidoCliente
      saldoPendiente
      fechaMov
      valorAntesImptos
      valorFacturado
      valorFactura
      valorNC
      agno
      mes
      numeroDocum
      descrRecurso
      detalleFact{
        _idMC
        codigoServicio
        nombreResumido
        descripcionServicio
        descrClaseServ
        concepto
        periodo
        tipo
        consecEnFra
        porcImpto
        valor
      }
      cliente{
        contrato
        nombreCliente
        apellidoCliente
        eMail
        telefono1
        saldoPendiente
        cargoMensual
        tipodoc{
          codigoTipoDoc
          descrTipoDoc
        }
        numeroDoc
        descrEstrato
        updDocApp
        direccion{
          descrTipoVia1
          numeroTipoVia1
          descrTipoVia2
          numeroTipoVia2
          numeroTipoVia2F
          descrTipoUnd1
          numeroTipoUnd1
          descrTipoUnd2
          numeroTipoUnd2
          descrTiUndMat
          descrUndMat
        }
        dirmayor{
          codigoDpto
          descrDpto
          ciudades{
            codigoCiudad
            nombreCiudad
            codigoCiudadInterno
            codBarrasRdo          
            zonas{
              codigoZona
              nombreZona
              barrios{
                codigoBarrio
                nombreBarrio
                codigoTipoDocT
                numeroDocumT
                descrRecursoT
                codigoTipoDocR
                numeroDocumR
                descrRecursoR
              }
            }
          }
        }
      }
    }
  }
  `,
  allFactRtesGroup: gpl `
    query ($fechaFact: Date, $tipoGen: String, $codProcFact: String, $tipoqry: String){
      allFactRtesGroup(fechaFact: $fechaFact, tipoGen: $tipoGen, codProcFact: $codProcFact, tipoqry: $tipoqry) {
        numeroFra
        tipoGen
        codProcFact
        fechaFact
        descrClaseServ
        descripcionServicio
        concepto
        totServ
        valorSF
        valorIF
        totFras
        descrRecurso
        valorFactura
        valorFacturado
        valorNC
      }
    }
    `,
    allCargoEsp: gpl `
      query ($codProcCE: String, $tipoGen: String, $numeroCE: String, $fechaCE: Date, $fechaMov: Date,
        $contrato: String, $agno: String, $mes: String, $orden: String){
          allCargoEsp(codProcCE: $codProcCE, tipoGen: $tipoGen, numeroCE: $numeroCE, fechaCE: $fechaCE,
            fechaMov: $fechaMov, contrato: $contrato, agno: $agno, mes: $mes, orden: $orden) {
        _id
        codProcCE
        tipoGen
        numeroCE
        fechaCE
        contrato
        fechaMov
        valorAntesImptos
        valorCargado
        valorCargo
        agno
        mes
        nombreBarrio
        numeroDocum
        descrRecurso
        detalleCE{
          _idMC
          codigoServicio
          nombreResumido
          descripcionServicio
          descrClaseServ
          concepto
          periodo
          tipo
          consecEnCE
          porcImpto
          valor
        }
      }
    }
    `,
    allNotasDebCre: gpl `
      query ($tipoNota: String, $numeroFra: String, $fechaNota: Date, $contrato: String,
        $numeroNota: String, $orden: String){
            allNotasDebCre(tipoNota: $tipoNota, numeroFra: $numeroFra, fechaNota: $fechaNota,
              contrato: $contrato, numeroNota: $numeroNota, orden: $orden) {
        _id
        tipoNota
        numeroNota
        numeroFra
        fechaNota
        contrato
        valorAntesImptos
        valorNota
        usuarioCreate
        detalleNota{
          _idMC
          codigoServicio
          nombreResumido
          descripcionServicio
          descrClaseServ
          concepto
          periodo
          tipo
          consecEnFra
          porcImpto
          valor
        }
        observacNota
      }
    }
    `,
    allNotasDCRtes: gpl `
      query ($tipoNota: String, $idRangoFact: String, $numeroFra: String, $fechaNota: Date, $contrato: String,
        $numeroNota: String, $orden: String, $tipoqry: String){
            allNotasDCRtes(tipoNota: $tipoNota, idRangoFact: $idRangoFact, numeroFra: $numeroFra, fechaNota: $fechaNota,
              contrato: $contrato, numeroNota: $numeroNota, orden: $orden, tipoqry: $tipoqry) {
        _id
        tipoNota
        numeroNota
        numeroFra
        fechaNota
        contrato
        valorAntesImptos
        valorNota
        detalleNota{
          _idMC
          codigoServicio
          nombreResumido
          descripcionServicio
          descrClaseServ
          concepto
          periodo
          tipo
          consecEnFra
          porcImpto
          valor
        }
        observacNota
        usuarioCreate
        cliente{
          contrato
          nombreCliente
          apellidoCliente
          tipodoc{
            codigoTipoDoc
            descrTipoDoc
          }
          numeroDoc
          updDocApp
          direccion{
            descrTipoVia1
            numeroTipoVia1
            descrTipoVia2
            numeroTipoVia2
            numeroTipoVia2F
            descrTipoUnd1
            numeroTipoUnd1
            descrTipoUnd2
            numeroTipoUnd2
            descrTiUndMat
            descrUndMat
          }
          dirmayor{
            codigoDpto
            descrDpto
            ciudades{
              codigoCiudad
              nombreCiudad
              zonas{
                codigoZona
                nombreZona
                barrios{
                  codigoBarrio
                  nombreBarrio
                  codigoTipoDocT
                  numeroDocumT
                  descrRecursoT
                  codigoTipoDocR
                  numeroDocumR
                  descrRecursoR
                }
              }
            }
          }  
        }
      }
    }
    `,
    allNotasDebCreRtes: gpl `
      query ($tipoNota: String, $idRangoFact: String, $numeroFra: String, $fechaNota: Date, $contrato: String,
        $numeroNota: String, $orden: String, $tipoqry: String){
            allNotasDebCreRtes(tipoNota: $tipoNota, idRangoFact: $idRangoFact, numeroFra: $numeroFra, fechaNota: $fechaNota,
              contrato: $contrato, numeroNota: $numeroNota, orden: $orden, tipoqry: $tipoqry) {
        _id
        tipoNota
        fechaNota
        numeroNota
        contrato
        numeroFra
        usuarioCreate
        nombreCliente
        apellidoCliente
        descrDpto
        nombreCiudad
        descripcionServicio
        descrClaseServ
        valorAntesImptos
        valorImptos
      }
    }
    `,
    allAjuste: gpl `
      query ($tipoAjuste: String, $fechaAjuste: Date, $contrato: String,
        $numeroAjuste: String, $orden: String){
          allAjuste(tipoAjuste: $tipoAjuste, fechaAjuste: $fechaAjuste,
              contrato: $contrato, numeroAjuste: $numeroAjuste, orden: $orden) {
        _id
        tipoAjuste
        numeroAjuste
        fechaAjuste
        contrato
        concepto
        valorAjuste
        usuarioCreate
      }
    }
    `,
    allAjusteTodo: gpl `
      query ($tipoAjuste: String, $fechaAjuste: Date, $contrato: String,
        $numeroAjuste: String, $orden: String){
          allAjusteTodo(tipoAjuste: $tipoAjuste, fechaAjuste: $fechaAjuste,
              contrato: $contrato, numeroAjuste: $numeroAjuste, orden: $orden) {
        _id
        tipoAjuste
        numeroAjuste
        fechaAjuste
        contrato
        concepto
        valorAjuste
      }
    }
    `,
    allAjusteRtes: gpl `
      query ($tipoAjuste: String, $fechaAjuste: Date, $contrato: String,
        $numeroAjuste: String, $orden: String, $tipoqry: String){
          allAjusteRtes(tipoAjuste: $tipoAjuste, fechaAjuste: $fechaAjuste,
              contrato: $contrato, numeroAjuste: $numeroAjuste, orden: $orden, tipoqry: $tipoqry) {
        _id
        tipoAjuste
        numeroAjuste
        fechaAjuste
        contrato
        concepto
        valorAjuste
        usuarioCreate
        cliente{
          contrato
          nombreCliente
          apellidoCliente
          tipodoc{
            codigoTipoDoc
            descrTipoDoc
          }
          numeroDoc
          updDocApp
          direccion{
            descrTipoVia1
            numeroTipoVia1
            descrTipoVia2
            numeroTipoVia2
            numeroTipoVia2F
            descrTipoUnd1
            numeroTipoUnd1
            descrTipoUnd2
            numeroTipoUnd2
            descrTiUndMat
            descrUndMat
          }
          dirmayor{
            codigoDpto
            descrDpto
            ciudades{
              codigoCiudad
              nombreCiudad
              zonas{
                codigoZona
                nombreZona
                barrios{
                  codigoBarrio
                  nombreBarrio
                  codigoTipoDocT
                  numeroDocumT
                  descrRecursoT
                  codigoTipoDocR
                  numeroDocumR
                  descrRecursoR
                }
              }
            }
          }  
        }
      }
    }
    `,
    allHistCliente: gpl `
        query ($contrato: String, $orden: String){
            allHistCliente(contrato: $contrato, orden: $orden) {
              _id
              fechaHistCliente
              contrato
              movimiento
              descripcion
              detalle
              relacion
              numeroRT
              valor
              usuarioCreate
              }
      }
      `,
allHistClienteRtes: gpl `
      query ($fechaHistCliente: Date, $contrato: String, $movimiento: String, $relacion: String,
              $orden: String, $tipoqry: String){
          allHistClienteRtes(fechaHistCliente: $fechaHistCliente, contrato: $contrato,
              movimiento: $movimiento, relacion: $relacion, orden: $orden, tipoqry: $tipoqry) {
        _id
        fechaHistCliente
        contrato
        movimiento
        descripcion
        detalle
        relacion
        valor
        usuarioCreate
        cliente{
          contrato
          nombreCliente
          apellidoCliente
        }
      }
    }
    `,
    allOdeS: gpl `
      query ($_id: ID, $numeroOS: Number, $contrato: String, $estadoOS: String,
        $numeroDocum: String, $descrRecurso: String, $fechaCreate: Date, $fechaEjec: Date){
          allOdeS(_id: $_id, numeroOS: $numeroOS, contrato: $contrato, estadoOS: $estadoOS,
            numeroDocum: $numeroDocum, descrRecurso: $descrRecurso, fechaCreate: $fechaCreate, fechaEjec: $fechaEjec) {
        _id
        numeroOS
        contrato
        tipoos{
          _id
          codigoTipoOS
          descrTipoOS
        }
        estadoOS
        impresa
        ptosAdic
        descrCategOST
        cun
        descrEstrato
        descrTipoRecT
        observacAB
        observacCE
        observacCA
        codigoMarquilla
        descrNodo
        codigoPaquete
        descrPaquete
        descrClasifOST
        codigoTipoDocV
        numeroDocumV
        descrRecursoV
        tag
        horaSolic
        nombreSolic
        genOSDirAnt
        osQueLaGenero
        fechaImpr
        usuarioImpr
        fechaClose
        horaClose
        usuarioClose
        fechaCanc
        usuarioCanc    
        fechaEjec
        fechaFra
        fechaCreate
        usuarioCreate
        dirmayor{
          codigoDpto
          descrDpto
          codigoDptoDANE
          ciudades{
            codigoCiudad
            nombreCiudad
            codigoMunicipioDANE
            codigoPostalDANE
            codigoCiudadInterno
            codBarrasRdo          
            zonas{
              codigoZona
              nombreZona
              barrios{
                codigoBarrio
                nombreBarrio
                codigoTipoDocT
                numeroDocumT
                descrRecursoT
                codigoTipoDocR
                numeroDocumR
                descrRecursoR
              }
            }
          }
        }
        direccion{
          descrTipoVia1
          numeroTipoVia1
          descrTipoVia2
          numeroTipoVia2
          numeroTipoVia2F
          descrTipoUnd1
          numeroTipoUnd1
          descrTipoUnd2
          numeroTipoUnd2
          descrTiUndMat
          descrUndMat
        }
        tarifa{
          codigoTarifa
          descrTarifa
          cicloFact
          fechaVence
          servicios{
            codigoServicio
            nombreResumido
            descripcionServicio
            subclaseserv{
              _id
              codigoSubclaseServ
              descrSubclaseServ
              claseserv{
                _id
                codigoClaseServ
                descrClaseServ
              }
            }
            velEfecDownstream
            velEfecUpstream
            codigoTipoTec
            descrTipoTec
            colorServicio
            estadoServicio
            rango1NumServValorIni
            rango1NumServValorFin
            rango1Valor
            rango2NumServValorIni
            rango2NumServValorFin
            rango2Valor
            rango3NumServValorIni
            rango3NumServValorFin
            rango3Valor
            numeroServicios
            valorServicios
            valorAntesImptos
            imptos{
              codigoImpto
              descrImpto
              porcImpto
              valorImpto
            }
          }
        }
        cargoFra{
          descrClaseServ
          codigoServicio
          nombreResumido
          descripcionServicio
          fechaCargo
          conceptoEnFra
          periodoFrado
          origen
          numeroServicios
          valorTotal
          valorAntesImptos
          imptos{
            codigoImpto
            descrImpto
            porcImpto
            valorImpto
          }
          agnoFra
          mesFra
        }
        oferta{
          codigoOferta
          descrOferta
          servicios{
            codigoServicio
            nombreResumido
            descripcionServicio
            porcDctoOferta
            numDiasOferta
            fechaFinOferta
            subclaseserv{
              _id
              codigoSubclaseServ
              descrSubclaseServ
              claseserv{
                _id
                codigoClaseServ
                descrClaseServ
              }
            }
          }
          fechaInicioOferta
        }
        equipos{
          numeroSerie
          mac
          accion
          estadoEquipo
          claseequ{
            _id
            codigoClaseEqu
            descrClaseEqu
          }
          marcaequ{
            _id
            codigoMarcaEqu
            descrMarcaEqu
          }
          fabriequ{
            _id
            codigoFabriEqu
            descrFabriEqu
          }
          bodega{
            _id
            codigoBodega
            descrBodega
          }
        }
        recursos{
          _id
          codigoTipoDoc
          numeroDocum
          descrRecurso
          tiporec{
            _id
            descrTipoRec
            areaAprovech
          }
        }
      }
    }
    `,
    allOdeSRtes: gpl `
      query ($numeroOS: Number, $contrato: String, $estadoOS: String, $numeroDocum: String,
        $descrRecurso: String, $fechaCreate: Date, $fechaEjec: Date, $tipoqry: String){
          allOdeSRtes(numeroOS: $numeroOS, contrato: $contrato, estadoOS: $estadoOS,
            numeroDocum: $numeroDocum, descrRecurso: $descrRecurso, fechaCreate: $fechaCreate,
            fechaEjec: $fechaEjec, tipoqry: $tipoqry) {
        _id
        numeroOS
        contrato
        tipoos{
          _id
          codigoTipoOS
          descrTipoOS
        }
        estadoOS
        impresa
        ptosAdic
        observacAB
        observacCE
        observacCA
        codigoMarquilla
        descrNodo
        codigoPaquete
        descrPaquete
        descrClasifOST
        descrCategOST
        cun
        descrEstrato
        descrTipoRecT
        codigoTipoDocV
        numeroDocumV
        descrRecursoV
        tag
        horaSolic
        nombreSolic
        genOSDirAnt
        osQueLaGenero
        usuarioCreate
        fechaImpr
        usuarioImpr
        fechaClose
        horaClose
        usuarioClose
        fechaCanc
        usuarioCanc    
        fechaEjec
        fechaFra
        permImprimir
        fechaCreate
        dirmayor{
          codigoDpto
          descrDpto
          ciudades{
            codigoCiudad
            nombreCiudad
            codigoCiudadInterno
            codBarrasRdo          
            zonas{
              codigoZona
              nombreZona
              barrios{
                codigoBarrio
                nombreBarrio
                codigoTipoDocT
                numeroDocumT
                descrRecursoT
                codigoTipoDocR
                numeroDocumR
                descrRecursoR
              }
            }
          }
        }
        direccion{
          descrTipoVia1
          numeroTipoVia1
          descrTipoVia2
          numeroTipoVia2
          numeroTipoVia2F
          descrTipoUnd1
          numeroTipoUnd1
          descrTipoUnd2
          numeroTipoUnd2
          descrTiUndMat
          descrUndMat
        }
        tarifa{
          codigoTarifa
          descrTarifa
          cicloFact
          fechaVence
          servicios{
            codigoServicio
            nombreResumido
            descripcionServicio
            subclaseserv{
              _id
              codigoSubclaseServ
              descrSubclaseServ
              claseserv{
                _id
                codigoClaseServ
                descrClaseServ
              }
            }
            estadoServicio
            rango1NumServValorIni
            rango1NumServValorFin
            rango1Valor
            rango2NumServValorIni
            rango2NumServValorFin
            rango2Valor
            rango3NumServValorIni
            rango3NumServValorFin
            rango3Valor
            numeroServicios
            valorServicios
            valorAntesImptos
            imptos{
              codigoImpto
              descrImpto
              porcImpto
              valorImpto
            }
          }
        }
        cargoFra{
          descrClaseServ
          codigoServicio
          nombreResumido
          descripcionServicio
          fechaCargo
          conceptoEnFra
          periodoFrado
          origen
          numeroServicios
          valorTotal
          valorAntesImptos
          imptos{
            codigoImpto
            descrImpto
            porcImpto
            valorImpto
          }
          agnoFra
          mesFra
        }
        oferta{
          codigoOferta
          descrOferta
          servicios{
            codigoServicio
            nombreResumido
            descripcionServicio
            porcDctoOferta
            numDiasOferta
            fechaFinOferta
            subclaseserv{
              _id
              codigoSubclaseServ
              descrSubclaseServ
              claseserv{
                _id
                codigoClaseServ
                descrClaseServ
              }
            }
          }
          fechaInicioOferta
        }
        equipos{
          numeroSerie
          mac
          accion
          estadoEquipo
          claseequ{
            _id
            codigoClaseEqu
            descrClaseEqu
          }
          marcaequ{
            _id
            codigoMarcaEqu
            descrMarcaEqu
          }
          fabriequ{
            _id
            codigoFabriEqu
            descrFabriEqu
          }
          bodega{
            _id
            codigoBodega
            descrBodega
          }
        }
        recursos{
          _id
          codigoTipoDoc
          numeroDocum
          descrRecurso
          tiporec{
            _id
            descrTipoRec
            areaAprovech
          }
        }
        cliente{
          contrato
          nombreCliente
          apellidoCliente
          estadoCliente
          numeroDoc
          telefonoRef1
          telefonoRef2
          telefono1
          telefono2
          telefono3
          saldoPendiente
          cargoMensual
          cicloFact
          codigoMarquilla
          descrNodo
          codigoPaquete
          descrPaquete
          grupoaf{
            descrGrupoAfin
          }
          direccion{
            descrTipoVia1
            numeroTipoVia1
            descrTipoVia2
            numeroTipoVia2
            numeroTipoVia2F
            descrTipoUnd1
            numeroTipoUnd1
            descrTipoUnd2
            numeroTipoUnd2
            descrTiUndMat
            descrUndMat
          }
          dirmayor{
            codigoDpto
            descrDpto
            ciudades{
              codigoCiudad
              nombreCiudad
              codigoCiudadInterno
              codBarrasRdo            
              zonas{
                codigoZona
                nombreZona
                barrios{
                  codigoBarrio
                  nombreBarrio
                  codigoTipoDocT
                  numeroDocumT
                  descrRecursoT
                  codigoTipoDocR
                  numeroDocumR
                  descrRecursoR
                }
              }
            }
          }
          tarifa{
            codigoTarifa
            descrTarifa
            servicios{
                codigoServicio
                nombreResumido
                descripcionServicio
                subclaseserv{
                    codigoSubclaseServ
                    descrSubclaseServ
                    claseserv{
                        codigoClaseServ
                        descrClaseServ
                    }
                }
                estadoServicio
            }
          }      
        }
      }
    }
    `,
    allTipoRec: gpl `{
      allTipoRec{
        _id
        descrTipoRec
        areaAprovech
      }
    }
    `,
    allRecurso: gpl `
      query ($_id: ID, $codigoTipoDoc: String, $numeroDocum: String, $descrRecurso: String){
        allRecurso(_id: $_id, codigoTipoDoc: $codigoTipoDoc, numeroDocum: $numeroDocum, descrRecurso: $descrRecurso) {
          _id
          codigoTipoDoc
          numeroDocum
          descrRecurso
          telContacto
          tiporec{
            _id
            descrTipoRec
            areaAprovech
          }
          _idDpto
          codigoDpto
          descrDpto
          codigoCiudad
          nombreCiudad  
          dirArchIn
          posIniContrato
          longContrato
          posIniNumeroDoc
          longNumeroDoc
          posIniNombre
          longNombre
          posIniApellido
          longApellido
          posIniValor
          longValor
          posIniFecha
          longFecha
          posIniCodCiudad
          longCodCiudad
          numPrimLinExcluir
        }
      }
      `,
      allRdoTerc: gpl `
        query ($_id: ID, $numeroDocum: String, $descrRecurso: String, $archivo: String, $procesado: String){
          allRdoTerc(_id: $_id, numeroDocum: $numeroDocum, descrRecurso: $descrRecurso, archivo: $archivo, procesado: $procesado) {
            _id
            numeroDocum
            descrRecurso
            archivo
            codigoCiudadInterno
            contrato
            numeroDoc
            nombreCliente
            apellidoCliente
            valorTotal
            fechaPago
            procesado
            fechaCreate
          }
        }
        `,
        allMesNoFra: gpl `
          query ($_id: ID, $contrato: String, $agno: String, $mes: String, $procesado: String){
            allMesNoFra(_id: $_id, contrato: $contrato, agno: $agno, mes: $mes, procesado: $procesado) {
              _id
              contrato
              agno
              mes
              observaciones
              procesado
              fechaCreate
              usuarioCreate
            }
          }
        `,
        allEquipo: gpl `
      query ($_id: ID, $numeroSerie: String, $mac: String, $estadoEquipo: String){
        allEquipo(_id: $_id, numeroSerie: $numeroSerie, mac: $mac, estadoEquipo: $estadoEquipo) {
          _id
          numeroSerie
          mac
          estadoEquipo
          claseequ{
            _id
            codigoClaseEqu
            descrClaseEqu
          }
          marcaequ{
            _id
            codigoMarcaEqu
            descrMarcaEqu
          }
          fabriequ{
            _id
            codigoFabriEqu
            descrFabriEqu
          }
          bodega{
            _id
            codigoBodega
            descrBodega
          }
          contrato
        }
      }
    `,
        allRangoFact: gpl `
          query ($_id: ID, $factInicial: Number, $factFinal: Number,
              $estadoRangoFact: Boolean, $cicloFact: String){
            allRangoFact(_id: $_id, factInicial: $factInicial, factFinal: $factFinal,
                estadoRangoFact: $estadoRangoFact, cicloFact: $cicloFact) {
              _id
              prefijo
              factInicial
              factFinal
              fecha
              numResolucion
              observaciones
              proxFact
              cicloFact
              estadoRangoFact
          }
        }
        `,
        allProcDX: gpl `
          query ($numeroOdeDX: Number, $estadoProcDX: String){
            allProcDX(numeroOdeDX: $numeroOdeDX, estadoProcDX: $estadoProcDX) {
                _id
                numeroOdeDX
                codProcDX
                estadoProcDX
                totCliDX
                totServDX
                fechaRef
                diasMora
                diasDXDesde
                numVecesDX
                porcMovim
                valorMovim
                servaDX
                descrDpto
                nombreCiudad
                nombreZona
                nombreBarrio
                descrClaseServ
            }
        }
        `,
        allProcFact: gpl `
          query ($_id: ID, $fechaFact: Date, $fechaCreate: Date){
            allProcFact(_id: $_id, fechaFact: $fechaFact, fechaCreate: $fechaCreate) {
              _id
              codProcFact
              mes
              fechaFact
              factInicial
              factFinal
              pagueHasta
              idRangoFact
              descrDpto
              nombreCiudad
              descrClaseServ
              cicloFact
              observaciones
              imagenLado
              imagenInf
              modeloFactura
              fechaCreate
          }
        }
        `,
        allProcCE: gpl `
          query ($_id: ID, $fechaCE: Date, $fechaCreate: Date){
            allProcCE(_id: $_id, fechaCE: $fechaCE, fechaCreate: $fechaCreate) {
              _id
              codProcCE
              mes
              fechaCE
              pagueHasta
              prefijoCE
              proxCE
              descrDpto
              nombreCiudad
              descrClaseServ
              cicloFact
              observaciones
              fechaCreate
          }
        }
        `,
        allTiUndMat: gpl `{
            allTiUndMat{
                _id
                codigoTiUndMat
                descrTiUndMat
            }
        }
        `,
        allClaseEqu: gpl `{
            allClaseEqu{
                _id
                codigoClaseEqu
                descrClaseEqu
            }
        }
        `,
        allMarcaEqu: gpl `{
            allMarcaEqu{
                _id
                codigoMarcaEqu
                descrMarcaEqu
            }
        }
        `,
        allFabriEqu: gpl `{
            allFabriEqu{
                _id
                codigoFabriEqu
                descrFabriEqu
            }
        }
        `,
        allBodega: gpl `{
            allBodega{
                _id
                codigoBodega
                descrBodega
            }
        }
        `,
        allOficina: gpl `{
            allOficina{
                _id
                descrOficina
                dirOficina
            }
        }
        `,
        allUndMat: gpl `
            query ($_id: ID, $descrUndMat: String){
                allUndMat(_id: $_id, descrUndMat: $descrUndMat) {
                _id
                descrUndMat
                tiundmat{
                  _id
                  codigoTiUndMat
                  descrTiUndMat
                }
            }
        }
        `,
        allTipoUnd: gpl `{
            allTipoUnd{
                _id
                descrTipoUnd
            }
        }
        `,
        allTipoVia: gpl `{
          allTipoVia{
            _id
            descrTipoVia
          }
        }
        `,
        allEstrato: gpl `{
          allEstrato{
            _id
            descrEstrato
          }
        }
        `,
        allNodo: gpl `{
          allNodo{
            _id
            descrNodo
          }
        }
        `,
        allCicloFact: gpl `{
            allCicloFact{
                _id
                cicloFact
                noFactRET
            }
        }
        `,
        allClasesServ: gpl `{
          allClasesServ{
            _id
            codigoClaseServ
            descrClaseServ
          }
        }
        `,
        allTipoTec: gpl `{
          allTipoTec{
            _id
            codigoTipoTec
            descrTipoTec
          }
        }
        `,
        allSegmento: gpl `{
          allSegmento{
            _id
            codigoSegmento
            descrSegmento
          }
        }
        `,
        allPaquete: gpl `{
          allPaquete{
            _id
            codigoPaquete
            descrPaquete
          }
        }
        `,
        allRteTrim_1: gpl `{
          allRteTrim_1{
            _id
            agno
            trimestre
            id_municipio
            id_segmento
            id_servicio_paquete
            velocidad_efectiva_downstream
            velocidad_efectiva_upstream
            id_tecnologia_acceso
            id_estado
            cantidad_lineas_accesos
            valor_facturado_o_cobrado
            otros_valores_fact          
          }
        }
        `,
        allTipoAju: gpl `{
          allTipoAju{
            _id
            descrTipoAju
          }
        }
        `,
        allBaseDat: gpl `{
          allBaseDat{
            _id
            basededatos
            descrBaseDat
          }
        }
        `,
        allTiposCliente: gpl `{
            allTiposCliente{
                _id
                codigoTipoCliente
                descrTipoCliente
            }
        }
        `,
        allGruposAfin: gpl `{
            allGruposAfin{
                _id
                codigoGrupoAfin
                descrGrupoAfin
            }
        }
        `,
        allTiposDoc: gpl `{
            allTiposDoc{
                _id
                codigoTipoDoc
                descrTipoDoc
            }
        }
        `,
        allImpto: gpl `{
            allImpto{
                _id
                codigoImpto
                descrImpto
                porcImpto
            }
        }
        `,
        allOtrosPagCl: gpl `{
            allOtrosPagCl{
                _id
                descrOtrosPagCl
                codigoImpto
                descrImpto
                porcImpto
                descrClaseServ
            }
        }
        `,
        allTiposOS: gpl `{
            allTiposOS{
                _id
                codigoTipoOS
                descrTipoOS
                estadoAlCrear
                permDireccion
                permTarServ
                permOfertas
                permEquipos
                paraCliNuevo
                pedirPtosAdic
                permImprimir
                estadoCrearOS
                estadoCerrarOS
                generalCliente
                genOSDirAnt
                tipoOSDirAnt
            }
        }
        `,
        allClasifOST: gpl `{
          allClasifOST{
            _id
            descrClasifOST
          }
        }
        `,
        allCategOST: gpl `{
          allCategOST{
            _id
            descrCategOST
            observCategOST
            codigoTipoOS
            descrTipoOS
          }
        }
        `,
        allBoleta: gpl `
          query ($contrato: String, $agno: String, $mes: String){
              allBoleta(contrato: $contrato, agno: $agno, mes: $mes) {
            _id
            numBoleta: String,
            contrato: String,
            agno: String,
            mes: String,
            estado: String,          
          }
        }
        `,
        allBoletaRtes: gpl `
        query ($tipoqry: String){
          allBoletaRtes(tipoqry: $tipoqry) {
            _id
            numBoleta
            contrato
            agno
            mes
            estado
            nombreCliente
            apellidoCliente
            estadoCliente
            cicloFact
            saldoPendiente
          }
        }
        `,
        allSubclasesServ: gpl `
            query ($codigoSubclaseServ: String, $descrSubclaseServ: String){
                allSubclasesServ(codigoSubclaseServ: $codigoSubclaseServ, descrSubclaseServ: $descrSubclaseServ) {
                _id
                codigoSubclaseServ
                descrSubclaseServ
                claseserv{
                  _id
                  codigoClaseServ
                  descrClaseServ
                }
            }
        }
        `,
    },

  mutation:{
    login: gpl`
      mutation($email: String!, $claveDeAcceso: String!, $bdConn: String){
        login(email: $email, claveDeAcceso: $claveDeAcceso, bdConn: $bdConn) {
        success
        token
        errors{
          path
          message
        }
        ok
        dpto
      }
    }
    `,
    enviarfrasaservidor: gpl`
      mutation($envFras: String){
        enviarfrasaservidor(envFras: $envFras) {
          success
          errors{
            path
            message
          }
        }
      }
    `,
    fecha: gpl`
      mutation($tipo: String){
        fecha(tipo: $tipo) {
          fechaFechaHoy
          fechaHoraHoy
      }
    }
    `,
    encriptar: gpl`
      mutation($valor: String, $comparar: String){
        encriptar(valor: $valor, comparar: $comparar) {
        success
        encriptado
      }
    }
    `,
    createSequence: gpl`
      mutation($coleccion: String, $seq: Number){
        createSequence(
          sequence:{
            coleccion: $coleccion,
            seq: $seq
          }
        ){
          success
          _id
          errors{
            path
            message
          }                
      }
    }
    `,
    createUsuario: gpl`
      mutation($email: String!, $nombreUsuario: String!, $claveDeAcceso: String!, $_id: ID!,
          $descrPerfil: String, $estadoUsuario: Boolean, $descrOficina: String, $_idDpto: String,
          $codigoDpto: String, $descrDpto: String, $codigoCiudad: String, $nombreCiudad: String,
          $numeroDocum: String, $descrTipoRec: String, $userApp: Boolean){
        createUsuario(
        usuario:{
          email:$email,
          nombreUsuario:$nombreUsuario,
          claveDeAcceso:$claveDeAcceso,
          perfil:{
            _id: $_id,
            descrPerfil: $descrPerfil
          }
          estadoUsuario: $estadoUsuario,
          descrOficina: $descrOficina,
          _idDpto: $_idDpto,
          codigoDpto: $codigoDpto,
          descrDpto: $descrDpto,
          codigoCiudad: $codigoCiudad,
          nombreCiudad: $nombreCiudad,
          numeroDocum: $numeroDocum,
          descrTipoRec: $descrTipoRec,
          userApp: $userApp
        }
        ){
          success
          _id
          errors{
            path
            message
          }
        }
      }
    `,
    createAutorizac: gpl`
      mutation($codigoAutorizac: String!, $descrAutorizac: String!){
        createAutorizac(
          autorizac:{
            codigoAutorizac: $codigoAutorizac,
            descrAutorizac: $descrAutorizac
            }
          ){
            success
            _id
            errors{
              path
              message
            }
          }
      }
    `,
    createPerfil: gpl`
      mutation($descrPerfil: String){
        createPerfil(
          perfil:{
            descrPerfil:$descrPerfil,
          }
        ){
          success
          _id
          errors{
            path
            message
          }
        }
      }
      `,
    createParametro: gpl`
      mutation($contratoSequence: String, $mensaje: String, $nuevoNumeroOS: Number, $nuevoNumeroRC: Number,
              $nuevoNumeroND: Number, $nuevoNumeroNC: Number, $nuevoNumeroAj: Number,
              $nuevoNumeroDX: Number, $ajCero: Number, $prefijoFact: String, $comoAsigCicloFact: String,
              $impRboCaja: String, $enPagoApp: String,
              $comoAsigCargosAlCliente: String, $empresaRazonSocial: String, $empresaNit: String,
              $empresaDir: String, $empresaTel: String, $codBarrasRdo: String,
              $pagueHastaSegunSaldo: Boolean, $numMesesParaPH: Number, $modeloFactura: String){
        createParametro(
          parametro:{
            contratoSequence: $contratoSequence,
            mensaje: $mensaje,
            nuevoNumeroOS: $nuevoNumeroOS,
            nuevoNumeroRC: $nuevoNumeroRC,
            nuevoNumeroND: $nuevoNumeroND,
            nuevoNumeroNC: $nuevoNumeroNC,
            nuevoNumeroAj: $nuevoNumeroAj,
            nuevoNumeroDX: $nuevoNumeroDX,
            ajCero: $ajCero,
            prefijoFact: $prefijoFact,
            comoAsigCicloFact: $comoAsigCicloFact,
            impRboCaja: $impRboCaja,
            enPagoApp: $enPagoApp,
            comoAsigCargosAlCliente: $comoAsigCargosAlCliente,
            empresaRazonSocial: $empresaRazonSocial,
            empresaNit: $empresaNit,
            empresaDir: $empresaDir,
            empresaTel: $empresaTel,
            codBarrasRdo: $codBarrasRdo,
            pagueHastaSegunSaldo: $pagueHastaSegunSaldo,
            numMesesParaPH: $numMesesParaPH
            modeloFactura: $modeloFactura
          }
        ){
          success
          errors{
            path
            message
          }                
        }
      }
      `,
      createClienteMany: gpl`
      mutation($cliente: [iClienteMany]){
        createClienteMany(
            cliente: $cliente
          ){
              success
              errors{
                  path
                  message
                  }                
              }
          }
      `,
            createCliente: gpl`
                mutation($contrato: String!, $infAdic1: String, $nombreCliente: String!, $apellidoCliente: String!,
                        $sexoCliente: String, $eMail: String, $descrEstrato: String,
                        $cicloFact: String, $tag: String, $referencia1: String, $telefonoRef1: String,
                        $referencia2: String, $telefonoRef2: String, $fechaCreacionSistema: Date,
                        $numeroOdeDX: Number,
                        $telefono1: String, $telefono2: String, $telefono3: String, $observaciones: String,
                        $codigoMarquilla: String, $descrNodo: String, $codigoSegmento: String, $descrSegmento: String,
                        $codigoPaquete: String, $descrPaquete: String, $numSorteos: String,
                        $_idTipoDoc: ID, $codigoTipoDoc: String, $descrTipoDoc: String, $numeroDoc: String,
                        $codigoTipoCliente: String, $descrTipoCliente: String,
                        $_idGrupoAf: ID, $codigoGrupoAfin: String, $descrGrupoAfin: String, $fechaCreate: Date,
                        $fechaCumple: Date, $datosConfirmados: String,
                        $autFraEmail: String, $autFraWhatsApp: String){
                    createCliente(
                    cliente:{
                        contrato: $contrato,
                        infAdic1: $infAdic1,
                        nombreCliente: $nombreCliente,
                        apellidoCliente: $apellidoCliente,
                        sexoCliente: $sexoCliente,
                        eMail: $eMail,
                        descrEstrato: $descrEstrato,
                        cicloFact: $cicloFact,
                        tag: $tag,
                        referencia1: $referencia1,
                        telefonoRef1: $telefonoRef1,
                        referencia2: $referencia2,
                        telefonoRef2: $telefonoRef2,
                        fechaCreacionSistema: $fechaCreacionSistema,
                        numeroOdeDX: $numeroOdeDX,
                        telefono1: $telefono1,
                        telefono2: $telefono2,
                        telefono3: $telefono3,
                        observaciones: $observaciones,
                        codigoMarquilla: $codigoMarquilla,
                        descrNodo: $descrNodo,
                        codigoSegmento: $codigoSegmento,
                        descrSegmento: $descrSegmento,
                        codigoPaquete: $codigoPaquete,
                        descrPaquete: $descrPaquete,
                        numSorteos: $numSorteos,
                        tipodoc:{
                            _id: $_idTipoDoc,
                            codigoTipoDoc: $codigoTipoDoc,
                            descrTipoDoc: $descrTipoDoc
                        },
                        numeroDoc: $numeroDoc,
                        tipocl:{
                            codigoTipoCliente: $codigoTipoCliente,
                            descrTipoCliente: $descrTipoCliente
                        },
                        grupoaf:{
                            _id: $_idGrupoAf,
                            codigoGrupoAfin: $codigoGrupoAfin,
                            descrGrupoAfin: $descrGrupoAfin
                        },
                        fechaCreate: $fechaCreate
                        fechaCumple: $fechaCumple
                        datosConfirmados: $datosConfirmados
                        autFraEmail: $autFraEmail
                        autFraWhatsApp: $autFraWhatsApp
                    }
                    ){
                      success
                      ok
                      _id
                      errors{
                        path
                        message
                      }
                    }
                }
                `,
                createTarifa: gpl`
                    mutation($codigoTarifa: String, $descrTarifa: String, $cicloFact: String, $estadoTarifa: Boolean){
                        createTarifa(
                            tarifa:{
                            codigoTarifa: $codigoTarifa,
                            descrTarifa: $descrTarifa,
                            cicloFact: $cicloFact,
                            estadoTarifa: $estadoTarifa
                        }
                        ){
                          success
                          _id
                          errors{
                            path
                            message
                          }
                        }
                    }
                    `,
                    createOferta: gpl`
                        mutation($codigoOferta: String, $descrOferta: String, $estadoOferta: Boolean){
                            createOferta(
                                oferta:{
                                codigoOferta: $codigoOferta,
                                descrOferta: $descrOferta,
                                estadoOferta: $estadoOferta
                            }
                            ){
                              success
                              _id
                              errors{
                                path
                                message
                              }
                            }
                        }
                    `,
                    createDpto: gpl`
                mutation($codigoDpto: String!, $descrDpto: String!, $codigoDptoDANE: String){
                    createDpto(
                        dirmayor:{
                            codigoDpto: $codigoDpto,
                            descrDpto: $descrDpto,
                            codigoDptoDANE: $codigoDptoDANE
                        }
                    ){
                      success
                      _id
                      errors{
                        path
                        message
                      }
                    }
                }
            `,
            createServicio: gpl`
            mutation($codigoServicio: String!, $nombreResumido: String!, $descripcionServicio: String!,
              $conceptoEnFra: String, $consecEnFra: Number, $_idSubclaseServ: ID!,
              $codigoSubclaseServ: String!, $descrSubclaseServ: String!, $_idClaseServ: ID!,
              $codigoClaseServ: String!, $descrClaseServ: String!, $velEfecDownstream: String, 
              $velEfecUpstream: String, $codigoTipoTec: String, $descrTipoTec: String,
              $colorServicio: String, $paraProcMasDX: String!){
                createServicio(
                    servicio:{
                        codigoServicio:$codigoServicio,
                        nombreResumido:$nombreResumido,
                        descripcionServicio:$descripcionServicio,
                        conceptoEnFra: $conceptoEnFra,
                        consecEnFra: $consecEnFra,
                        subclaseserv:{
                            _id: $_idSubclaseServ,
                            codigoSubclaseServ: $codigoSubclaseServ,
                            descrSubclaseServ: $descrSubclaseServ
                            claseserv:{
                                _id: $_idClaseServ,
                                codigoClaseServ: $codigoClaseServ,
                                descrClaseServ: $descrClaseServ
                            },
                        },
                        velEfecDownstream: $velEfecDownstream,
                        velEfecUpstream: $velEfecUpstream,
                        codigoTipoTec: $codigoTipoTec,
                        descrTipoTec: $descrTipoTec,
                        colorServicio: $colorServicio,
                        paraProcMasDX: $paraProcMasDX
                    }
                ){
                  success
                  _id
                  errors{
                    path
                    message
                  }
                }
            }
            `,
            createDetalleDXMany: gpl`
            mutation($detalledx: [iDetalleDXMany]){
                createDetalleDXMany(
                    detalledx: $detalledx
                ){
                    success
                    errors{
                        path
                        message
                        }                
                    }
                }
            `,
            createMovCliCCMany: gpl`
            mutation($movcliente: [iMovCliCCMany]){
                createMovCliCCMany(
                    movcliente: $movcliente
                ){
                    success
                    errors{
                        path
                        message
                        }                
                    }
                }
            `,
            createMovCliCC: gpl`
            mutation($contrato: String, $fechaMov: Date, $tipo: String, $subTipo: String,
                $procesado: String, $pagueHasta: Date, $numeroOdeDX: Number,
                $codigoServicio: String, $nombreResumido: String,
                $descripcionServicio: String, $descrClaseServ: String, $concepto: String,
                $periodo: String, $origen: String, $saldoCliente: Number, $valorTotal: Number,
                $valorAntesImptos: Number, $agno: String, $mes: String, $numeroFra: String,
                $numeroCE: String,
                $numeroRC: String, $documento: String, $valorPagado: Number, $fechaUltPago: Date,
                $valorUltPago: Number){
                    createMovCliCC(
                        movcliente:{
                        contrato: $contrato
                        fechaMov: $fechaMov
                        tipo: $tipo
                        subTipo: $subTipo
                        procesado: $procesado
                        pagueHasta: $pagueHasta
                        numeroOdeDX: $numeroOdeDX
                        codigoServicio: $codigoServicio
                        nombreResumido: $nombreResumido
                        descripcionServicio: $descripcionServicio
                        descrClaseServ: $descrClaseServ
                        concepto: $concepto
                        periodo: $periodo
                        origen: $origen
                        saldoCliente: $saldoCliente
                        valorTotal: $valorTotal
                        valorAntesImptos: $valorAntesImptos
                        agno: $agno
                        mes: $mes
                        numeroFra: $numeroFra
                        numeroCE: $numeroCE
                        numeroRC: $numeroRC
                        documento: $documento
                        valorPagado: $valorPagado
                        fechaUltPago: $fechaUltPago
                        valorUltPago: $valorUltPago
                    }
                ){
                  success
                  _id
                  errors{
                    path
                    message
                  }
                }
            }
            `,
            createMovClientesMany: gpl`
            mutation($movcliente: [iMovClientesMany]){
                createMovClientesMany(
                    movcliente: $movcliente
                ){
                    success
                    errors{
                        path
                        message
                        }                
                    }
                }
            `,
            createMovClientes: gpl`
            mutation($contrato: String, $fechaMov: Date, $tipo: String, $subTipo: String,
                $procesado: String, $pagueHasta: Date, $numeroOdeDX: Number,
                $codigoServicio: String, $nombreResumido: String,
                $descripcionServicio: String, $descrClaseServ: String, $concepto: String,
                $periodo: String, $origen: String, $saldoCliente: Number, $valorTotal: Number,
                $valorAntesImptos: Number, $agno: String, $mes: String, $numeroFra: String,
                $numeroCE: String,
                $numeroRC: String, $documento: String, $valorPagado: Number, $valorPendiente: Number,
                $fechaUltPago: Date, $valorUltPago: Number, $fechaCreate: String){
                    createMovClientes(
                        movcliente:{
                        contrato: $contrato
                        fechaMov: $fechaMov
                        tipo: $tipo
                        subTipo: $subTipo
                        procesado: $procesado
                        pagueHasta: $pagueHasta
                        numeroOdeDX: $numeroOdeDX
                        codigoServicio: $codigoServicio
                        nombreResumido: $nombreResumido
                        descripcionServicio: $descripcionServicio
                        descrClaseServ: $descrClaseServ
                        concepto: $concepto
                        periodo: $periodo
                        origen: $origen
                        saldoCliente: $saldoCliente
                        valorTotal: $valorTotal
                        valorAntesImptos: $valorAntesImptos
                        agno: $agno
                        mes: $mes
                        numeroFra: $numeroFra
                        numeroCE: $numeroCE
                        numeroRC: $numeroRC
                        documento: $documento
                        valorPagado: $valorPagado
                        valorPendiente: $valorPendiente
                        fechaUltPago: $fechaUltPago
                        valorUltPago: $valorUltPago
                        fechaCreate: $fechaCreate
                    }
                ){
                  success
                  _id
                  errors{
                    path
                    message
                  }
                }
            }
            `,
            createProgServ: gpl`
              mutation($contrato: String, $fechaProg: Date, $procesado: String, $codigoTarifa: String,
                $descrTarifa: String, $codigoServicio: String, $nombreResumido: String, $descripcionServicio: String,
                $valorTotal: Number, $fechaCreate: Date){
                    createProgServ(
                      progserv:{
                        contrato: $contrato
                        fechaProg: $fechaProg
                        procesado: $procesado
                        codigoTarifa: $codigoTarifa
                        descrTarifa: $descrTarifa
                        codigoServicio: $codigoServicio
                        nombreResumido: $nombreResumido
                        descripcionServicio: $descripcionServicio
                        valorTotal: $valorTotal
                        fechaCreate: $fechaCreate
                    }
                ){
                  success
                  _id
                  errors{
                    path
                    message
                  }
                }
            }
            `,
            createPagoClientes: gpl`
              mutation($contrato: String, $saldoPendiente: Number, $fechaPago: Date, $tipo: String,
                $descripcionPago: String, $numeroFra: String,
                $numeroRC: String, $documento: String, $numeroRT: String, $numeroDocum: String,
                $descrRecurso: String, $descrOficina: String,
                $descrDpto: String, $nombreCiudad: String, $nombreZona: String, $nombreBarrio: String,
                $numeroDocumR: String, $descrRecursoR: String,
                $valorTotal: Number, $valorEf: Number, $valorCh: Number,
                $numeroCh: String, $bancoCh: String, $fechaVencCh: Date, $valorTr: Number,
                $bancoTr: String, $fechaTr: Date, $valorTD: Number, $bancoTD: String, $valorTC: Number,
                $bancoTC: String, $fechaCreate: String, $usuarioCreate: String){
                  createPagoClientes(
                    pagocliente:{
                      contrato: $contrato
                      saldoPendiente: $saldoPendiente
                      fechaPago: $fechaPago
                      tipo: $tipo
                      descripcionPago: $descripcionPago
                      numeroFra: $numeroFra
                      numeroRC: $numeroRC,
                      documento: $documento,
                      numeroRT: $numeroRT,
                      numeroDocum: $numeroDocum,
                      descrRecurso: $descrRecurso,
                      descrOficina: $descrOficina,
                      descrDpto: $descrDpto,
                    nombreCiudad: $nombreCiudad,
                    nombreZona: $nombreZona,
                    nombreBarrio: $nombreBarrio,
                    numeroDocumR: $numeroDocumR,
                    descrRecursoR: $descrRecursoR,
                      valorTotal: $valorTotal
                      valorEf: $valorEf
                      valorCh: $valorCh
                      numeroCh: $numeroCh
                      bancoCh: $bancoCh
                      fechaVencCh: $fechaVencCh
                      valorTr: $valorTr
                      bancoTr: $bancoTr
                      fechaTr: $fechaTr
                      valorTD: $valorTD
                      bancoTD: $bancoTD
                      valorTC: $valorTC
                      bancoTC: $bancoTC
                      fechaCreate: $fechaCreate
                      usuarioCreate: $usuarioCreate
                  }
                ){
                  success
                  _id
                  errors{
                    path
                    message
                  }
                }
            }
            `,
            createFacturacionMany: gpl`
            mutation($facturacion: [iFacturacionMany]){
                createFacturacionMany(
                    facturacion: $facturacion
                ){
                    success
                    errors{
                        path
                        message
                        }                
                    }
                }
            `,
            createFacturacion: gpl`
            mutation($codProcFact: String, $tipoGen: String, $idRangoFact: String, $numeroFra: String,
                $fechaFact: Date, $contrato: String, $pagueHasta: Date, 
                $direccion: String, $descrDpto: String, $codigoDptoDANE: String,
                $nombreCiudad: String, $codigoMunicipioDANE: String, $codigoPostalDANE: String,
                $codigoCiudadInterno: String, $codBarrasRdo: String,
                $nombreZona: String, $nombreBarrio: String, $nombreCliente: String, $apellidoCliente: String,
                $numeroDoc: String, $eMail: String, $saldoPendiente: Number,
                $fechaMov: Date, $valorAntesImptos: Number, $valorFacturado: Number,
                $valorFactura: Number, $agno: String, $mes: String,
                $numeroDocum: String, $descrRecurso: String){
                  createFacturacion(
                    facturacion:{
                      codProcFact: $codProcFact
                      tipoGen: $tipoGen
                      idRangoFact: $idRangoFact
                      numeroFra: $numeroFra
                      fechaFact: $fechaFact
                      contrato: $contrato
                      pagueHasta: $pagueHasta
                      direccion: $direccion
                      descrDpto: $descrDpto
                      codigoDptoDANE: $codigoDptoDANE
                      nombreCiudad: $nombreCiudad
                      codigoMunicipioDANE: $codigoMunicipioDANE
                      codigoPostalDANE: $codigoPostalDANE
                      codigoCiudadInterno: $codigoCiudadInterno
                      codBarrasRdo: $codBarrasRdo
                      nombreZona: $nombreZona
                      nombreBarrio: $nombreBarrio
                      nombreCliente: $nombreCliente
                      apellidoCliente: $apellidoCliente
                      numeroDoc: $numeroDoc
                      eMail: $eMail
                      saldoPendiente: $saldoPendiente                    
                      fechaMov: $fechaMov
                      valorAntesImptos: $valorAntesImptos
                      valorFacturado: $valorFacturado
                      valorFactura: $valorFactura
                      agno: $agno
                      mes: $mes
                      numeroDocum: $numeroDocum
                      descrRecurso: $descrRecurso                    
                    }
                ){
                  success
                  _id
                  errors{
                    path
                    message
                  }
                }
            }
            `,
            enviarCorreoFact: gpl`
            mutation($facturacion: [envCorreoMany]){
                enviarCorreoFact(
                    facturacion: $facturacion
                ){
                    success
                    errors{
                        path
                        message
                        }                
                    }
                }
            `,
          createHistClienteMany: gpl`
            mutation($histcliente: [iHistClienteMany]){
              createHistClienteMany(
                histcliente: $histcliente
              ){
                success
                errors{
                  path
                  message
                }                
              }
            }
          `,
          createCargoEspMany: gpl`
            mutation($cargoesp: [iCargoEspMany]){
                createCargoEspMany(
                    cargoesp: $cargoesp
                ){
                    success
                    errors{
                        path
                        message
                        }                
                    }
                }
            `,
            createCargoEsp: gpl`
            mutation($codProcCE: String, $tipoGen: String, $numeroCE: String, $fechaCE: Date, $contrato: String,
              $fechaMov: Date, $valorAntesImptos: Number, $valorCargado: Number,
                $valorCargo: Number, $agno: String, $mes: String, $nombreBarrio: String,
                $numeroDocum: String, $descrRecurso: String){
                  createCargoEsp(
                    cargoesp:{
                      codProcCE: $codProcCE
                      tipoGen: $tipoGen
                      numeroCE: $numeroCE
                      fechaCE: $fechaCE
                      contrato: $contrato
                      fechaMov: $fechaMov
                      valorAntesImptos: $valorAntesImptos
                      valorCargado: $valorCargado
                      valorCargo: $valorCargo
                      agno: $agno
                      mes: $mes
                      nombreBarrio: $nombreBarrio
                      numeroDocum: $numeroDocum
                      descrRecurso: $descrRecurso                    
                    }
                ){
                  success
                  _id
                  errors{
                    path
                    message
                  }
                }
            }
            `,
            createNotasDebCre: gpl`
            mutation($tipoNota: String, $numeroNota: String, $idRangoFact: String, $numeroFra: String, $fechaNota: Date,
              $contrato: String, $valorAntesImptos: Number, $valorNota: Number, $valorNotaFact: Number, $observacNota: String, $fechaCreate: String){
                  createNotasDebCre(
                    notasdebcre:{
                      tipoNota: $tipoNota
                      numeroNota: $numeroNota
                      idRangoFact: $idRangoFact
                      numeroFra: $numeroFra
                      fechaNota: $fechaNota
                      contrato: $contrato
                      valorAntesImptos: $valorAntesImptos
                      valorNota: $valorNota
                      valorNotaFact: $valorNotaFact
                      observacNota: $observacNota
                      fechaCreate: $fechaCreate
                    }
                ){
                  success
                  _id
                  errors{
                    path
                    message
                  }
                }
            }
            `,
            createAjuste: gpl`
            mutation($tipoAjuste: String, $numeroAjuste: String, $fechaAjuste: Date,
              $contrato: String, $concepto: String, $valorAjuste: Number){
                createAjuste(
                    ajuste:{
                      tipoAjuste: $tipoAjuste
                      numeroAjuste: $numeroAjuste
                      fechaAjuste: $fechaAjuste
                      contrato: $contrato
                      concepto: $concepto
                      valorAjuste: $valorAjuste
                    }
                ){
                  success
                  _id
                  errors{
                    path
                    message
                  }
                }
            }
            `,
            createOdeS: gpl`
                mutation($numeroOS: Number, $contrato: String, $estadoOS: String,
                        $_idTipoOS: ID, $codigoTipoOS: String,
                        $descrTipoOS: String, $ptosAdic: Number, $descrCategOST: String, $cun: String,
                        $descrEstrato: String, $observacAB: String,
                        $codigoMarquilla: String, $descrNodo: String,
                        $codigoPaquete: String, $descrPaquete: String,
                        $descrClasifOST: String, $codigoTipoDocV: String,
                        $numeroDocumV: String, $descrRecursoV: String, $horaSolic: String,
                        $nombreSolic: String, $genOSDirAnt: String, $osQueLaGenero: Number,
                        $fechaEjec: Date, $fechaFra: Date, $fechaCreate: Date,
                        $fechaClose: Date, $horaClose: String, $usuarioClose: String,
                        $observacCE: String){
                    createOdeS(
                        odes:{
                            numeroOS: $numeroOS,
                            contrato: $contrato,
                            estadoOS: $estadoOS,
                            tipoos:{
                                _id: $_idTipoOS,
                                codigoTipoOS: $codigoTipoOS,
                                descrTipoOS: $descrTipoOS
                            },
                            ptosAdic: $ptosAdic,
                            descrCategOST: $descrCategOST
                            cun: $cun
                            descrEstrato: $descrEstrato
                            observacAB: $observacAB,
                            codigoMarquilla: $codigoMarquilla,
                            descrNodo: $descrNodo,
                            codigoPaquete: $codigoPaquete,
                            descrPaquete: $descrPaquete,
                            descrClasifOST: $descrClasifOST,
                            codigoTipoDocV: $codigoTipoDocV,
                            numeroDocumV: $numeroDocumV,
                            descrRecursoV: $descrRecursoV,
                            horaSolic: $horaSolic,
                            nombreSolic: $nombreSolic,
                            genOSDirAnt: $genOSDirAnt,
                            osQueLaGenero: $osQueLaGenero,
                            fechaEjec: $fechaEjec,
                            fechaFra: $fechaFra,
                            fechaCreate: $fechaCreate,
                            fechaClose: $fechaClose,
                            horaClose: $horaClose,
                            usuarioClose: $usuarioClose,
                            observacCE: $observacCE,
                        }
                    ){
                      success
                      _id
                      errors{
                        path
                        message
                      }
                    }
                }
                `,
            createTipoRec: gpl`
                mutation($descrTipoRec: String!, $areaAprovech: String!){
                    createTipoRec(
                        tiporec:{
                            descrTipoRec: $descrTipoRec,
                            areaAprovech: $areaAprovech
                        }
                    ){
                      success
                      _id
                      errors{
                        path
                        message
                      }
                    }
                }
                `,
                createRecurso: gpl`
                  mutation($codigoTipoDoc: String, $numeroDocum: String, $descrRecurso: String,
                    $telContacto: String,
                    $_idTipoRec: ID, $descrTipoRec: String!, $_idDpto: String,
                    $codigoDpto: String, $descrDpto: String, $codigoCiudad: String, $nombreCiudad: String,
                    $areaAprovech: String, $dirArchIn: String,
                    $posIniContrato: String,
                    $longContrato: String,
                    $posIniNumeroDoc: String,
                    $longNumeroDoc: String,
                    $posIniNombre: String,
                    $longNombre: String,
                    $posIniApellido: String,
                    $longApellido: String,
                    $posIniValor: String,
                    $longValor: String,
                    $posIniFecha: String,
                    $longFecha: String,
                    $posIniCodCiudad: String,
                    $longCodCiudad: String,
                    $numPrimLinExcluir: Number,
                  ){
                    createRecurso(
                      recurso:{
                        codigoTipoDoc: $codigoTipoDoc,
                        numeroDocum: $numeroDocum,
                        descrRecurso: $descrRecurso,
                        telContacto: $telContacto,
                        tiporec:{
                          _id: $_idTipoRec,
                          descrTipoRec: $descrTipoRec,
                          areaAprovech: $areaAprovech
                        },
                        _idDpto: $_idDpto,
                        codigoDpto: $codigoDpto,
                        descrDpto: $descrDpto,
                        codigoCiudad: $codigoCiudad,
                        nombreCiudad: $nombreCiudad,        
                        dirArchIn: $dirArchIn,
                        posIniContrato: $posIniContrato,
                        longContrato: $longContrato,
                        posIniNumeroDoc: $posIniNumeroDoc,
                        longNumeroDoc: $longNumeroDoc,
                        posIniNombre: $posIniNombre,
                        longNombre: $longNombre,
                        posIniApellido: $posIniApellido,
                        longApellido: $longApellido,
                        posIniValor: $posIniValor,
                        longValor: $longValor,
                        posIniFecha: $posIniFecha,
                        longFecha: $longFecha,
                        posIniCodCiudad: $posIniCodCiudad,
                        longCodCiudad: $longCodCiudad,
                        numPrimLinExcluir: $numPrimLinExcluir,
                      }
                    ){
                      success
                      _id
                      errors{
                        path
                        message
                      }
                    }
                  }
                  `,
                  createRdoTerc: gpl`
                    mutation($numeroDocum: String, $descrRecurso: String, $archivo: String, $contrato: String,
                      $codigoCiudadInterno: String, $numeroDoc: String, $nombreCliente: String, $apellidoCliente: String,
                      $valorTotal: Number, $fechaPago: String, $procesado: String, $fechaCreate: Date){
                      createRdoTerc(
                        rdoterc:{
                          numeroDocum: $numeroDocum,
                          descrRecurso: $descrRecurso,
                          archivo: $archivo,
                          codigoCiudadInterno: $codigoCiudadInterno,
                          contrato: $contrato,
                          numeroDoc: $numeroDoc,
                          nombreCliente: $nombreCliente,
                          apellidoCliente: $apellidoCliente,
                          valorTotal: $valorTotal,
                          fechaPago: $fechaPago,
                          procesado: $procesado,
                          fechaCreate: $fechaCreate
                        }
                      ){
                        success
                        _id
                        errors{
                          path
                          message
                        }
                      }
                    }
                    `,
                    createMesNoFra: gpl`
                      mutation($contrato: String, $agno: String, $mes: String, $observaciones: String,
                        $procesado: String, $fechaCreate: Date){
                        createMesNoFra(
                          mesnofra:{
                            contrato: $contrato
                            agno: $agno,
                            mes: $mes,
                            observaciones: $observaciones,
                            procesado: $procesado,
                            fechaCreate: $fechaCreate
                          }
                        ){
                          success
                          _id
                          errors{
                            path
                            message
                          }
                        }
                      }
                    `,
                      createEquipo: gpl`
                        mutation($tipoAct: String, $numeroSerie: String, $mac: String, $estadoEquipo: String,
                            $_idClaseEqu: ID, $codigoClaseEqu: String, $descrClaseEqu: String,
                            $_idMarcaEqu: ID, $codigoMarcaEqu: String, $descrMarcaEqu: String,
                            $_idFabriEqu: ID, $codigoFabriEqu: String, $descrFabriEqu: String,
                            $_idBodega: ID, $codigoBodega: String, $descrBodega: String){
                            createEquipo(
                                equipo:{
                                    tipoAct: $tipoAct,
                                    numeroSerie: $numeroSerie,
                                    mac: $mac,
                                    estadoEquipo: $estadoEquipo,
                                    claseequ:{
                                        _id: $_idClaseEqu,
                                        codigoClaseEqu: $codigoClaseEqu,
                                        descrClaseEqu: $descrClaseEqu
                                    },
                                    marcaequ:{
                                        _id: $_idMarcaEqu,
                                        codigoMarcaEqu: $codigoMarcaEqu,
                                        descrMarcaEqu: $descrMarcaEqu
                                    },
                                    fabriequ:{
                                        _id: $_idFabriEqu,
                                        codigoFabriEqu: $codigoFabriEqu,
                                        descrFabriEqu: $descrFabriEqu
                                    },
                                    bodega:{
                                        _id: $_idBodega,
                                        codigoBodega: $codigoBodega,
                                        descrBodega: $descrBodega
                                    },
                                }
                            ){
                              success
                              _id
                              errors{
                                path
                                message
                              }
                            }
                        }
                        `,
                        createRangoFact: gpl`
                            mutation($prefijo: String, $factInicial: Number, $factFinal: Number, $fecha: Date,
                                $numResolucion: String, $observaciones: String, $proxFact: Number, $cicloFact: String,
                                $estadoRangoFact: Boolean){
                                  createRangoFact(
                                    rangoFact:{
                                      prefijo: $prefijo,
                                      factInicial: $factInicial,
                                      factFinal: $factFinal,
                                      fecha: $fecha,
                                      numResolucion: $numResolucion,
                                      observaciones: $observaciones,
                                      proxFact: $proxFact,
                                      cicloFact: $cicloFact,
                                      estadoRangoFact: $estadoRangoFact,
                                    }
                                ){
                                  success
                                  _id
                                  errors{
                                    path
                                    message
                                  }
                                }
                            }
                            `,
                            createProcDX: gpl`
                              mutation($numeroOdeDX: Number, $totCliDX: Number, $totServDX: Number,
                                $codProcDX: String, $estadoProcDX: String,
                                $fechaRef: Date, $diasMora: Number, $diasDXDesde: Number, $numVecesDX: Number,
                                $porcMovim: Number, $valorMovim: Number, $servaDX: String, $descrDpto: String,
                                $nombreCiudad: String, $nombreZona: String, $nombreBarrio: String,
                                $descrClaseServ: String){
                                    createProcDX(
                                        procdx:{
                                            numeroOdeDX: $numeroOdeDX,
                                            codProcDX: $codProcDX,
                                            estadoProcDX: $estadoProcDX,
                                            totCliDX: $totCliDX,
                                            totServDX: $totServDX,
                                            fechaRef: $fechaRef,
                                            diasMora: $diasMora,
                                            diasDXDesde: $diasDXDesde,
                                            numVecesDX: $numVecesDX,
                                            porcMovim: $porcMovim,
                                            valorMovim: $valorMovim,
                                            servaDX: $servaDX,
                                            descrDpto: $descrDpto,
                                            nombreCiudad: $nombreCiudad,
                                            nombreZona: $nombreZona,
                                            nombreBarrio: $nombreBarrio,
                                            descrClaseServ: $descrClaseServ
                                    }
                                  ){
                                    success
                                    _id
                                    errors{
                                      path
                                      message
                                    }
                                  }
                              }
                              `,
                            createProcFact: gpl`
                              mutation($codProcFact: String, $mes: String, $fechaFact: Date, $factInicial: String, $factFinal: String,
                                  $pagueHasta: Date, $idRangoFact: String, $descrDpto: String,
                                  $nombreCiudad: String, $nombreZona: String, $descrClaseServ: String, $cicloFact: String, 
                                  $observaciones: String, $imagenLado: String, $imagenInf: String, $modeloFactura: String,
                                  $fechaCreate: Date){
                                    createProcFact(
                                      procFact:{
                                      codProcFact: $codProcFact,
                                      mes: $mes,
                                      fechaFact: $fechaFact,
                                      factInicial: $factInicial,
                                      factFinal: $factFinal,
                                      pagueHasta: $pagueHasta,
                                      idRangoFact: $idRangoFact,
                                      descrDpto: $descrDpto,
                                      nombreCiudad: $nombreCiudad,
                                      nombreZona: $nombreZona,
                                      descrClaseServ: $descrClaseServ,
                                      cicloFact: $cicloFact,
                                      observaciones: $observaciones,
                                      imagenLado: $imagenLado,
                                      imagenInf: $imagenInf,
                                      modeloFactura: $modeloFactura,
                                      fechaCreate: $fechaCreate
                                    }
                                  ){
                                    success
                                    _id
                                    errors{
                                      path
                                      message
                                    }
                                  }
                              }
                              `,
                              createProcCE: gpl`
                                mutation($codProcCE: String, $mes: String, $fechaCE: Date,
                                    $pagueHasta: Date,
                                  $prefijoCE: String, $proxCE: String, $descrDpto: String,
                                  $nombreCiudad: String, $descrClaseServ: String, $cicloFact: String,
                                  $observaciones: String, $fechaCreate: Date){
                                    createProcCE(
                                      procCE:{
                                        codProcCE: $codProcCE,
                                        mes: $mes,
                                        fechaCE: $fechaCE,
                                        pagueHasta: $pagueHasta,
                                        prefijoCE: $prefijoCE,
                                        proxCE: $proxCE,
                                        descrDpto: $descrDpto,
                                        nombreCiudad: $nombreCiudad,
                                        descrClaseServ: $descrClaseServ,
                                        cicloFact: $cicloFact,
                                        observaciones: $observaciones,
                                        fechaCreate: $fechaCreate
                                      }
                                    ){
                                      success
                                      _id
                                      errors{
                                        path
                                        message
                                      }
                                    }
                                }
                                `,
              createTiUndMat: gpl`
                mutation($codigoTiUndMat: String!, $descrTiUndMat: String!){
                    createTiUndMat(
                        tiundmat:{
                            codigoTiUndMat: $codigoTiUndMat,
                            descrTiUndMat: $descrTiUndMat
                        }
                    ){
                      success
                      _id
                      errors{
                        path
                        message
                      }
                    }
                }
                `,
                createClaseEqu: gpl`
                    mutation($codigoClaseEqu: String!, $descrClaseEqu: String!){
                        createClaseEqu(
                            claseequ:{
                                codigoClaseEqu: $codigoClaseEqu,
                                descrClaseEqu: $descrClaseEqu
                            }
                        ){
                          success
                          _id
                          errors{
                            path
                            message
                          }
                        }
                    }
                    `,
                    createMarcaEqu: gpl`
                        mutation($codigoMarcaEqu: String!, $descrMarcaEqu: String!){
                            createMarcaEqu(
                                marcaequ:{
                                    codigoMarcaEqu: $codigoMarcaEqu,
                                    descrMarcaEqu: $descrMarcaEqu
                                }
                            ){
                              success
                              _id
                              errors{
                                path
                                message
                              }
                            }
                        }
                        `,
                        createFabriEqu: gpl`
                            mutation($codigoFabriEqu: String!, $descrFabriEqu: String!){
                                createFabriEqu(
                                    fabriequ:{
                                        codigoFabriEqu: $codigoFabriEqu,
                                        descrFabriEqu: $descrFabriEqu
                                    }
                                ){
                                  success
                                  _id
                                  errors{
                                    path
                                    message
                                  }
                                }
                            }
                            `,
                            createBodega: gpl`
                                mutation($codigoBodega: String!, $descrBodega: String!){
                                    createBodega(
                                        bodega:{
                                            codigoBodega: $codigoBodega,
                                            descrBodega: $descrBodega
                                        }
                                    ){
                                      success
                                      _id
                                      errors{
                                        path
                                        message
                                      }
                                    }
                                }
                                `,
                                createOficina: gpl`
                                    mutation($descrOficina: String!, $dirOficina: String, $fechaCreate: Date){
                                        createOficina(
                                            oficina:{
                                                descrOficina: $descrOficina,
                                                dirOficina: $dirOficina,
                                                fechaCreate: $fechaCreate, 
                                            }
                                        ){
                                          success
                                          _id
                                          errors{
                                            path
                                            message
                                          }
                                        }
                                    }
                                    `,
                      createUndMat: gpl`
                    mutation($descrUndMat: String!, $_idTiUndMat: ID!, $codigoTiUndMat: String!, $descrTiUndMat: String!){
                        createUndMat(
                            undmat:{
                                descrUndMat: $descrUndMat,
                                tiundmat:{
                                  _id: $_idTiUndMat,
                                  codigoTiUndMat: $codigoTiUndMat,
                                  descrTiUndMat: $descrTiUndMat
                                },
                            }
                        ){
                          success
                          _id
                          errors{
                            path
                            message
                          }
                        }
                    }
                    `,
                    createTipoUnd: gpl`
                        mutation($descrTipoUnd: String!){
                            createTipoUnd(
                                tipound:{
                                    descrTipoUnd: $descrTipoUnd
                                }
                            ){
                              success
                              _id
                              errors{
                                path
                                message
                              }
                            }
                        }
                        `,
                        createTipoVia: gpl`
                            mutation($descrTipoVia: String!){
                                createTipoVia(
                                    tipovia:{
                                        descrTipoVia: $descrTipoVia
                                    }
                                ){
                                  success
                                  _id
                                  errors{
                                    path
                                    message
                                  }
                                }
                            }
                            `,
                            createEstrato: gpl`
                              mutation($descrEstrato: String!){
                                createEstrato(
                                  estrato:{
                                    descrEstrato: $descrEstrato
                                  }
                                ){
                                  success
                                  _id
                                  errors{
                                    path
                                    message
                                  }
                                }
                              }
                            `,
                            createNodo: gpl`
                              mutation($descrNodo: String!){
                                createNodo(
                                  nodo:{
                                    descrNodo: $descrNodo
                                  }
                                ){
                                  success
                                  _id
                                  errors{
                                    path
                                    message
                                  }
                                }
                              }
                            `,
                            createCicloFact: gpl`
                                mutation($cicloFact: String!, $noFactRET: Boolean){
                                    createCicloFact(
                                        ciclofact:{
                                            cicloFact: $cicloFact,
                                            noFactRET: $noFactRET
                                        }
                                    ){
                                      success
                                      _id
                                      errors{
                                        path
                                        message
                                      }
                                    }
                          }
              `,
              createClaseServ: gpl`
                mutation($codigoClaseServ: String!, $descrClaseServ: String!){
                  createClaseServ(
                    claseserv:{
                        codigoClaseServ: $codigoClaseServ,
                        descrClaseServ: $descrClaseServ
                    }
                  ){
                    success
                    _id
                    errors{
                      path
                      message
                    }
                  }
              }
              `,
              createTipoTec: gpl`
                mutation($codigoTipoTec: String!, $descrTipoTec: String!){
                  createTipoTec(
                    tipotec:{
                        codigoTipoTec: $codigoTipoTec,
                        descrTipoTec: $descrTipoTec
                    }
                  ){
                    success
                    _id
                    errors{
                      path
                      message
                    }
                  }
              }
              `,
              createSegmento: gpl`
                mutation($codigoSegmento: String!, $descrSegmento: String!){
                  createSegmento(
                    segmento:{
                        codigoSegmento: $codigoSegmento,
                        descrSegmento: $descrSegmento
                    }
                  ){
                    success
                    _id
                    errors{
                      path
                      message
                    }
                  }
              }
              `,
              createPaquete: gpl`
                mutation($codigoPaquete: String!, $descrPaquete: String!){
                  createPaquete(
                    paquete:{
                        codigoPaquete: $codigoPaquete,
                        descrPaquete: $descrPaquete
                    }
                  ){
                    success
                    _id
                    errors{
                      path
                      message
                    }
                  }
              }
              `,
              createRteTrim_1: gpl`
                mutation($agno: String, $trimestre: String, $id_municipio: String,
                    $id_segmento: String, $id_servicio_paquete: String,
                    $velocidad_efectiva_downstream: String, $velocidad_efectiva_upstream: String,
                    $id_tecnologia_acceso: String, $id_estado: String,
                    $cantidad_lineas_accesos: String, $valor_facturado_o_cobrado: String,
                    $otros_valores_fact: String, $fechaCreate: String, $usuarioCreate: String){
                  createRteTrim_1(
                    rtetrim_1:{
                      agno: $agno
                      trimestre: $trimestre
                      id_municipio: $id_municipio
                      id_segmento: $id_segmento
                      id_servicio_paquete: $id_servicio_paquete
                      velocidad_efectiva_downstream: $velocidad_efectiva_downstream
                      velocidad_efectiva_upstream: $velocidad_efectiva_upstream
                      id_tecnologia_acceso: $id_tecnologia_acceso
                      id_estado: $id_estado
                      cantidad_lineas_accesos: $cantidad_lineas_accesos
                      valor_facturado_o_cobrado: $valor_facturado_o_cobrado
                      otros_valores_fact: $otros_valores_fact
                      fechaCreate: $fechaCreate
                      usuarioCreate: $usuarioCreate
                    }
                  ){
                    success
                    _id
                    errors{
                      path
                      message
                    }
                  }
              }
              `,
              createTipoAju: gpl`
                mutation($fechaCreate: Date, $descrTipoAju: String!){
                  createTipoAju(
                    tipoaju:{
                      descrTipoAju: $descrTipoAju
                      fechaCreate: $fechaCreate
                    }
                  ){
                    success
                    _id
                    errors{
                      path
                      message
                    }
                  }
              }
              `,
              createBaseDat: gpl`
                mutation($fechaCreate: Date, $descrBaseDat: String, $basededatos: String!){
                  createBaseDat(
                    basedat:{
                      basededatos: $basededatos
                      descrBaseDat: $descrBaseDat
                      fechaCreate: $fechaCreate
                    }
                  ){
                    success
                    _id
                    errors{
                      path
                      message
                    }
                  }
              }
              `,
              createTipoCliente: gpl`
                mutation($codigoTipoCliente: String!, $descrTipoCliente: String!){
                    createTipoCliente(
                        tipocliente:{
                            codigoTipoCliente: $codigoTipoCliente,
                            descrTipoCliente: $descrTipoCliente
                        }
                        ){
                          success
                          _id
                          errors{
                            path
                            message
                          }
                        }
                      }
                    `,
            createGrupoAfin: gpl`
                mutation($codigoGrupoAfin: String!, $descrGrupoAfin: String!){
                    createGrupoAfin(
                        grupoafin:{
                            codigoGrupoAfin: $codigoGrupoAfin,
                            descrGrupoAfin: $descrGrupoAfin
                        }
                    ){
                      success
                      _id
                      errors{
                        path
                        message
                      }
                    }
                }
            `,
            createTipoDoc: gpl`
                mutation($codigoTipoDoc: String!, $descrTipoDoc: String!){
                    createTipoDoc(
                        tipodoc:{
                            codigoTipoDoc: $codigoTipoDoc,
                            descrTipoDoc: $descrTipoDoc
                        }
                    ){
                      success
                      _id
                      errors{
                        path
                        message
                      }
                    }
                }
                `,
                createImpto: gpl`
                    mutation($codigoImpto: String, $descrImpto: String, $porcImpto: Number){
                        createImpto(
                            impto:{
                                codigoImpto: $codigoImpto,
                                descrImpto: $descrImpto,
                                porcImpto: $porcImpto
                            }
                        ){
                          success
                          _id
                          errors{
                            path
                            message
                          }
                        }
                    }
                    `,
                    createOtrosPagCl: gpl`
                        mutation($descrOtrosPagCl: String, $codigoImpto: String, $descrImpto: String,
                                $porcImpto: Number, $descrClaseServ: String){
                            createOtrosPagCl(
                                otrospagcl:{
                                    descrOtrosPagCl: $descrOtrosPagCl,
                                    codigoImpto: $codigoImpto,
                                    descrImpto: $descrImpto,
                                    porcImpto: $porcImpto,
                                    descrClaseServ: $descrClaseServ
                                }
                            ){
                              success
                              _id
                              errors{
                                path
                                message
                              }
                            }
                        }
                    `,
                    createSubclaseServ: gpl`
                mutation($codigoSubclaseServ: String!, $descrSubclaseServ: String!, $_idClaseserv: ID!, $codigoClaseServ: String!, $descrClaseServ: String!){
                    createSubclaseServ(
                        subclaseserv:{
                            codigoSubclaseServ: $codigoSubclaseServ,
                            descrSubclaseServ: $descrSubclaseServ,
                            claseserv:{
                                _id: $_idClaseserv,
                                codigoClaseServ: $codigoClaseServ,
                                descrClaseServ: $descrClaseServ
                            },
                        }
                    ){
                      success
                      _id
                      errors{
                        path
                        message
                      }
                    }
                }
                `,
                createTipoOS: gpl`
                    mutation($codigoTipoOS: String!, $descrTipoOS: String!, $estadoAlCrear: String,
                        $permDireccion: String!, $permTarServ: String!, $permOfertas: String!,
                        $permEquipos: String!, $paraCliNuevo: String!, $pedirPtosAdic: String,
                        $permImprimir: String, $estadoCrearOS: String!, $estadoCerrarOS: String!,
                        $generalCliente: String, $genOSDirAnt: String, $tipoOSDirAnt: String
                    ){
                        createTipoOS(
                            tipoos:{
                                codigoTipoOS: $codigoTipoOS
                                descrTipoOS: $descrTipoOS
                                estadoAlCrear: $estadoAlCrear
                                permDireccion: $permDireccion
                                permTarServ: $permTarServ
                                permOfertas: $permOfertas
                                permEquipos: $permEquipos
                                paraCliNuevo: $paraCliNuevo
                                pedirPtosAdic: $pedirPtosAdic
                                permImprimir: $permImprimir
                                estadoCrearOS: $estadoCrearOS
                                estadoCerrarOS: $estadoCerrarOS
                                generalCliente: $generalCliente
                                genOSDirAnt: $genOSDirAnt
                                tipoOSDirAnt: $tipoOSDirAnt
                            }
                        ){
                          success
                          _id
                          errors{
                            path
                            message
                          }
                        }
                    }
                    `,
                    createClasifOST: gpl`
                      mutation($descrClasifOST: String, $fechaCreate: Date
                      ){
                          createClasifOST(
                            clasifost:{
                              descrClasifOST: $descrClasifOST
                              fechaCreate: $fechaCreate
                            }
                          ){
                            success
                            _id
                            errors{
                              path
                              message
                            }
                          }
                        }
                        `,
                        createCategOST: gpl`
                          mutation($descrCategOST: String, $observCategOST: String,
                            $codigoTipoOS: String, $descrTipoOS: String, $fechaCreate: Date
                          ){
                              createCategOST(
                                categost:{
                                  descrCategOST: $descrCategOST
                                  observCategOST: $observCategOST
                                  codigoTipoOS: $codigoTipoOS
                                  descrTipoOS: $descrTipoOS
                                  fechaCreate: $fechaCreate
                                }
                              ){
                                success
                                _id
                                errors{
                                  path
                                  message
                                }
                              }
                            }
                            `,
                            createBoleta: gpl`
                              mutation($numBoleta: String, $contrato: String,
                                $agno: String, $mes: String, $estado: String, $fechaCreate: Date
                              ){
                                  createBoleta(
                                    boleta:{
                                      numBoleta: $numBoleta
                                      contrato: $contrato
                                      agno: $agno
                                      mes: $mes
                                      estado: $estado
                                      fechaCreate: $fechaCreate
                                    }
                                  ){
                                    success
                                    _id
                                    errors{
                                      path
                                      message
                                    }
                                  }
                                }
                              `,
                        editSeqFrafindOneAndUpdate: gpl`
                      mutation($_id: ID, $proxFact: Number){
                        editSeqFrafindOneAndUpdate(
                          sequence:{
                              _id: $_id,
                              proxFact: $proxFact,
                          }
                        ){
                            success
                            errors{
                              path
                              message
                            }
                            proxFact              
                          }
                      }
                    `,
                    editSeqfindOneAndUpdate: gpl`
      mutation($coleccion: String, $seq: Number){
        editSeqfindOneAndUpdate(
          sequence:{
              coleccion: $coleccion,
              seq: $seq,
          }
        ){
            success
            errors{
              path
              message
            }
            seq              
          }
      }
    `,
    editSequence: gpl`
      mutation($coleccion: String, $seq: Number){
        editSequence(
          sequence:{
            coleccion: $coleccion,
            seq: $seq,
          }
        ){
          success
          errors{
            path
            message
          }
        }
      }
    `,
    editParametro: gpl`
      mutation($contratoSequence: String, $_id: ID, $mensaje: String, $nuevoNumeroOS: Number, $nuevoNumeroRC: Number,
        $nuevoNumeroND: Number, $nuevoNumeroNC: Number, $nuevoNumeroAj: Number, $nuevoNumeroDX: Number,
        $ajCero: Number, $prefijoFact: String, $comoAsigCicloFact: String,
        $impRboCaja: String, $enPagoApp: String,
        $comoAsigCargosAlCliente: String,
        $empresaRazonSocial: String, $empresaNit: String,  $empresaDir: String, $empresaTel: String,
        $codBarrasRdo: String, $pagueHastaSegunSaldo: Boolean, $numMesesParaPH: Number, $modeloFactura: String){
        editParametro(
          parametro:{
            _id: $_id,
            contratoSequence: $contratoSequence
            mensaje: $mensaje
            nuevoNumeroOS: $nuevoNumeroOS
            nuevoNumeroRC: $nuevoNumeroRC
            nuevoNumeroND: $nuevoNumeroND
            nuevoNumeroNC: $nuevoNumeroNC
            nuevoNumeroAj: $nuevoNumeroAj
            nuevoNumeroDX: $nuevoNumeroDX
            ajCero: $ajCero,
            prefijoFact: $prefijoFact
            comoAsigCicloFact: $comoAsigCicloFact
            impRboCaja: $impRboCaja
            enPagoApp: $enPagoApp
            comoAsigCargosAlCliente: $comoAsigCargosAlCliente
            empresaRazonSocial: $empresaRazonSocial
            empresaNit: $empresaNit
            empresaDir: $empresaDir
            empresaTel: $empresaTel
            codBarrasRdo: $codBarrasRdo
            pagueHastaSegunSaldo: $pagueHastaSegunSaldo
            numMesesParaPH: $numMesesParaPH
            modeloFactura: $modeloFactura
          }
        ){
          success
          errors{
            path
            message
          }                
        }
      }
      `,
      editAutorizac: gpl`
      mutation($_id: ID!, $descrAutorizac: String!){
        editAutorizac(
          autorizac:{
              _id: $_id,
              descrAutorizac: $descrAutorizac
          }
      ){
          success
          errors{
              path
              message
          }                
        }
      }
    `,
    editPerfil: gpl`
      mutation($_id: ID!, $descrPerfil: String!){
        editPerfil(
          perfil:{
            _id: $_id,
            descrPerfil: $descrPerfil
          }
      ){
        success
        errors{
          path
          message
        }                
      }
    }
    `,
    editPerfilUpdDoc: gpl`
      mutation($_id: ID, $tipoAct: String, $codigoAutorizac: String, $descrAutorizac: String
      ){
        editPerfilUpdDoc(perfil:{
          _id: $_id,
          tipoAct: $tipoAct,
          autorizac:{
            codigoAutorizac: $codigoAutorizac,
            descrAutorizac: $descrAutorizac,
          },
        }){
        success
        errors{
          path
          message
        }
      }
    }
  `,
  editTipoRec: gpl`
                mutation($_id: ID!, $descrTipoRec: String!, $areaAprovech: String){
                    editTipoRec(
                    tiporec:{
                        _id: $_id,
                        descrTipoRec: $descrTipoRec
                        areaAprovech: $areaAprovech
                    }
                ){
                    success
                    errors{
                        path
                        message
                    }                
                }
            }
            `,
            editRecurso: gpl`
              mutation($_id: ID, $numeroDocum: String, $descrRecurso: String, $telContacto: String,
                     $idTipoRec: ID,
                     $descrTipoRec: String,
                     $_idDpto: String,
                     $codigoDpto: String, $descrDpto: String, $codigoCiudad: String, $nombreCiudad: String,
                     $areaAprovech: String,
                     $_idAnterior: ID,
                     $dirArchIn: String,
                     $posIniContrato: String,
                     $longContrato: String,
                     $posIniNumeroDoc: String,
                     $longNumeroDoc: String,
                     $posIniNombre: String,
                     $longNombre: String,
                     $posIniApellido: String,
                     $longApellido: String,
                     $posIniValor: String,
                     $longValor: String,
                     $posIniFecha: String,
                     $longFecha: String,
                     $posIniCodCiudad: String,
                     $longCodCiudad: String,
                     $numPrimLinExcluir: Number,
              ){
                editRecurso(recurso:{
                        _id: $_id,
                        descrRecurso: $descrRecurso,
                        telContacto: $telContacto,
                        numeroDocum: $numeroDocum,
                        tiporec:{
                            _id: $idTipoRec,
                            descrTipoRec: $descrTipoRec,
                            areaAprovech: $areaAprovech
                        },
                        _idDpto: $_idDpto,
                        codigoDpto: $codigoDpto,
                        descrDpto: $descrDpto,
                        codigoCiudad: $codigoCiudad,
                        nombreCiudad: $nombreCiudad,        
                        dirArchIn: $dirArchIn,
                        posIniContrato: $posIniContrato,
                        longContrato: $longContrato,
                        posIniNumeroDoc: $posIniNumeroDoc,
                        longNumeroDoc: $longNumeroDoc,
                        posIniNombre: $posIniNombre,
                        longNombre: $longNombre,
                        posIniApellido: $posIniApellido,
                        longApellido: $longApellido,
                        posIniValor: $posIniValor,
                        longValor: $longValor,
                        posIniFecha: $posIniFecha,
                        longFecha: $longFecha,
                        posIniCodCiudad: $posIniCodCiudad,
                        longCodCiudad: $longCodCiudad,
                        numPrimLinExcluir: $numPrimLinExcluir,
                    },
                    _idAnterior: $_idAnterior
                ){
                    success
                    errors{
                        path
                        message
                    }                
                }
            }
            `,
            editRdoTerc: gpl`
            mutation($_id: ID, $procesado: String
            ){
                editRdoTerc(rdoterc:{
                        _id: $_id,
                        procesado: $procesado
                    }
                ){
                    success
                    errors{
                        path
                        message
                    }                
                }
            }
            `,
            editMesNoFra: gpl`
              mutation($_id: ID, $contrato: String, $agno: String, $mes: String, $observaciones: String, $procesado: String
              ){
                editMesNoFra(mesnofra:{
                        _id: $_id
                        contrato: $contrato
                        agno: $agno
                        mes: $mes
                        observaciones: $observaciones
                        procesado: $procesado
                    }
                ){
                    success
                    errors{
                        path
                        message
                    }                
                }
            }
            `,
            editMesNoFraMany: gpl`
                mutation($mesnofra: [iMesNoFraUpd]){
                    editMesNoFraMany(
                      mesnofra: $mesnofra
                    ){
                        success
                        errors{
                            path
                            message
                            }                
                        }
                    }
                    `,
            editEquipo: gpl`
            mutation($tipoAct: String, $numeroSerie: String, $mac: String, $estadoEquipo: String,
                $contrato: String, $contratoNvo: String, $_idBodega: ID, $codigoBodega: String, $descrBodega: String){
                editEquipo(equipo:{
                    tipoAct: $tipoAct,
                    numeroSerie: $numeroSerie,
                    mac: $mac,
                    estadoEquipo: $estadoEquipo,
                    contrato: $contrato,
                    contratoNvo: $contratoNvo,
                    bodega:{
                        _id: $_idBodega,
                        codigoBodega: $codigoBodega,
                        descrBodega: $descrBodega
                    },
                }
                ){
                    success
                    errors{
                        path
                        message
                    }                
                }
            }
            `,
            editRangoFact: gpl`
            mutation($_id: ID, $tipoAct: String, $prefijo: String, $fecha: Date, $numResolucion: String,
                $observaciones: String, $proxFact: Number, $cicloFact: String, $estadoRangoFact: Boolean){
                  editRangoFact(rangoFact:{
                    _id: $_id,
                    prefijo: $prefijo,
                    tipoAct: $tipoAct,
                    fecha: $fecha,
                    numResolucion: $numResolucion,
                    observaciones: $observaciones,
                    proxFact: $proxFact,
                    cicloFact: $cicloFact,
                    estadoRangoFact: $estadoRangoFact
                }
                ){
                    success
                    errors{
                        path
                        message
                    }                
                }
            }
            `,
            editProcFact: gpl`
            mutation($codProcFact: String, $factInicial: String, $factFinal: String){
              editProcFact(procFact:{
                codProcFact: $codProcFact
                factInicial: $factInicial,
                factFinal: $factFinal
              }
              ){
                success
                errors{
                    path
                    message
                }
              }
            }
            `,
            editProcCE: gpl`
            mutation($_id: ID, $observaciones: String){
              editProcCE(procCE:{
                _id: $_id,
                observaciones: $observaciones
              }
              ){
                success
                errors{
                    path
                    message
                }                
              }
            }
            `,
            editTiUndMat: gpl`
                mutation($_id: ID!, $descrTiUndMat: String!){
                    editTiUndMat(
                    tiundmat:{
                        _id: $_id,
                        descrTiUndMat: $descrTiUndMat
                    }
                ){
                    success
                    errors{
                        path
                        message
                    }                
                }
            }
            `,
            editClaseEqu: gpl`
                mutation($_id: ID!, $descrClaseEqu: String!){
                    editClaseEqu(
                    claseequ:{
                        _id: $_id,
                        descrClaseEqu: $descrClaseEqu
                    }
                ){
                    success
                    errors{
                        path
                        message
                    }                
                }
            }
            `,
            editMarcaEqu: gpl`
                mutation($_id: ID!, $descrMarcaEqu: String!){
                    editMarcaEqu(
                    marcaequ:{
                        _id: $_id,
                        descrMarcaEqu: $descrMarcaEqu
                    }
                ){
                    success
                    errors{
                        path
                        message
                    }                
                }
            }
            `,
            editFabriEqu: gpl`
                mutation($_id: ID!, $descrFabriEqu: String!){
                    editFabriEqu(
                    fabriequ:{
                        _id: $_id,
                        descrFabriEqu: $descrFabriEqu
                    }
                ){
                    success
                    errors{
                        path
                        message
                    }                
                }
            }
            `,
            editBodega: gpl`
                mutation($_id: ID!, $descrBodega: String!){
                    editBodega(
                    bodega:{
                        _id: $_id,
                        descrBodega: $descrBodega
                    }
                ){
                    success
                    errors{
                        path
                        message
                    }                
                }
            }
            `,
            editOficina: gpl`
                mutation($_id: ID!, $descrOficina: String!, $descrOficinaAnt: String, $dirOficina: String){
                    editOficina(
                    oficina:{
                        _id: $_id,
                        descrOficina: $descrOficina
                        descrOficinaAnt: $descrOficinaAnt
                        dirOficina: $dirOficina
                    }
                ){
                    success
                    errors{
                        path
                        message
                    }                
                }
            }
            `,
            editUndMat: gpl`
            mutation($_id: ID!, $descrUndMat: String!){
                editUndMat(
                    undmat:{
                        _id: $_id,
                        descrUndMat: $descrUndMat
                    }
                ){
                    success
                    errors{
                        path
                        message
                    }                
                }
            }
            `,
            editTipoUnd: gpl`
                mutation($_id: ID!, $descrTipoUnd: String!){
                    editTipoUnd(
                    tipound:{
                        _id: $_id,
                        descrTipoUnd: $descrTipoUnd
                    }
                ){
                    success
                    errors{
                        path
                        message
                    }                
                }
            }
            `,
            editTipoVia: gpl`
                mutation($_id: ID!, $descrTipoVia: String!){
                    editTipoVia(
                    tipovia:{
                        _id: $_id,
                        descrTipoVia: $descrTipoVia
                    }
                ){
                    success
                    errors{
                        path
                        message
                    }                
                }
            }
            `,
            editEstrato: gpl`
              mutation($_id: ID!, $descrEstrato: String!){
                editEstrato(
                  estrato:{
                    _id: $_id,
                    descrEstrato: $descrEstrato
                  }
                ){
                  success
                  errors{
                    path
                    message
                  }                
                }
              }
              `,
              editNodo: gpl`
                mutation($_id: ID!, $descrNodo: String!, $descrNodoAnt: String){
                  editNodo(
                    nodo:{
                      _id: $_id,
                      descrNodo: $descrNodo,
                      descrNodoAnt: $descrNodoAnt
                    }
                  ){
                    success
                    errors{
                      path
                      message
                    }                
                  }
                }
              `,
              editCicloFact: gpl`
                mutation($_id: ID!, $cicloFact: String!, $noFactRET: Boolean){
                    editCicloFact(
                    ciclofact:{
                        _id: $_id,
                        cicloFact: $cicloFact,
                        noFactRET: $noFactRET
                    }
                ){
                    success
                    errors{
                        path
                        message
                    }                
                }
            }
            `,
              editClaseServ: gpl`
                mutation($_id: ID!, $descrClaseServ: String!){
                  editClaseServ(
                  claseserv:{
                      _id: $_id,
                      descrClaseServ: $descrClaseServ
                  }
                ){
                  success
                  errors{
                    path
                    message
                  }                
                }
              }
              `,
              editTipoTec: gpl`
                mutation($_id: ID!, $codigoTipoTec: String, $descrTipoTec: String!){
                  editTipoTec(
                  tipotec:{
                      _id: $_id,
                      codigoTipoTec: $codigoTipoTec,
                      descrTipoTec: $descrTipoTec
                  }
                ){
                  success
                  errors{
                    path
                    message
                  }                
                }
              }
              `,
              editSegmento: gpl`
                mutation($_id: ID!, $codigoSegmento: String, $descrSegmento: String!){
                  editSegmento(
                  segmento:{
                      _id: $_id,
                      codigoSegmento: $codigoSegmento,
                      descrSegmento: $descrSegmento
                  }
                ){
                  success
                  errors{
                    path
                    message
                  }                
                }
              }
              `,
              editPaquete: gpl`
                mutation($_id: ID!, $codigoPaquete: String, $descrPaquete: String!){
                  editPaquete(
                  paquete:{
                      _id: $_id,
                      codigoPaquete: $codigoPaquete,
                      descrPaquete: $descrPaquete
                  }
                ){
                  success
                  errors{
                    path
                    message
                  }                
                }
              }
              `,
              editRteTrim_1: gpl`
                mutation($_id: ID, $agno: String, $trimestre: String, $id_municipio: String,
                    $id_segmento: String, $id_servicio_paquete: String,
                    $velocidad_efectiva_downstream: String, $velocidad_efectiva_upstream: String,
                    $id_tecnologia_acceso: String, $id_estado: String,
                    $cantidad_lineas_accesos: String, $valor_facturado_o_cobrado: String,
                    $otros_valores_fact: String){
                  editRteTrim_1(
                  rtetrim_1:{
                    _id: $_id,
                    agno: $agno,
                    trimestre: $trimestre,
                    id_municipio: $id_municipio,
                    id_segmento: $id_segmento,
                    id_servicio_paquete: $id_servicio_paquete,
                    velocidad_efectiva_downstream: $velocidad_efectiva_downstream,
                    velocidad_efectiva_upstream: $velocidad_efectiva_upstream,
                    id_tecnologia_acceso: $id_tecnologia_acceso,
                    id_estado: $id_estado,
                    cantidad_lineas_accesos: $cantidad_lineas_accesos,
                    valor_facturado_o_cobrado: $valor_facturado_o_cobrado,
                    otros_valores_fact: $otros_valores_fact
                }
                ){
                  success
                  errors{
                    path
                    message
                  }                
                }
              }
              `,
              editTipoAju: gpl`
                mutation($_id: ID!, $descrTipoAju: String!){
                  editTipoAju(
                  tipoaju:{
                      _id: $_id,
                      descrTipoAju: $descrTipoAju
                  }
                ){
                  success
                  errors{
                    path
                    message
                  }                
                }
              }
            `,
            editSubclaseServ: gpl`
              mutation($_id: ID!, $descrSubclaseServ: String!){
                editSubclaseServ(
                  subclaseserv:{
                    _id: $_id,
                    descrSubclaseServ: $descrSubclaseServ
                }
            ){
                success
                errors{
                    path
                    message
                }
            }
        }
    `,
        editServicio: gpl`
                mutation($_id: ID!, $codigoServicio: String, $nombreResumido: String!, $descripcionServicio: String!,
                  $conceptoEnFra: String, $consecEnFra: Number, $velEfecDownstream: String, 
                  $velEfecUpstream: String, $codigoTipoTec: String, $descrTipoTec: String,
                  $colorServicio: String, $paraProcMasDX: String!){
                    editServicio(
                        servicio:{
                            _id: $_id
                            codigoServicio: $codigoServicio
                            nombreResumido: $nombreResumido
                            descripcionServicio: $descripcionServicio
                            conceptoEnFra: $conceptoEnFra
                            consecEnFra: $consecEnFra
                            velEfecDownstream: $velEfecDownstream
                            velEfecUpstream: $velEfecUpstream
                            codigoTipoTec: $codigoTipoTec
                            descrTipoTec: $descrTipoTec
                            colorServicio: $colorServicio
                            paraProcMasDX: $paraProcMasDX
                        }
                    ){
                        success
                        errors{
                            path
                            message
                        }                
                    }
                }
                `,
                editDetalleDXMany: gpl`
                mutation($detalledx: [iDetalleDXUpdMany]){
                    editDetalleDXMany(
                        detalledx: $detalledx
                    ){
                        success
                        errors{
                            path
                            message
                            }                
                        }
                    }
                    `,
                    editDetalleDX: gpl`
                    mutation($_id: ID, $tipoAct: String, $contrato: String, $contratoNvo: String){
                        editDetalleDX(
                            detalledx:{
                                _id: $_id,
                                tipoAct: $tipoAct
                                contrato: $contrato
                                contratoNvo: $contratoNvo
                            }
                        ){
                            success
                            errors{
                                path
                                message
                            }                
                        }
                    }
                    `,
                editMovClientesDXMany: gpl`
                mutation($movcliente: [iMovClientesUpdDX]){
                    editMovClientesDXMany(
                        movcliente: $movcliente
                    ){
                        success
                        errors{
                            path
                            message
                            }                
                        }
                    }
                `,
                editMovClientesMany: gpl`
                mutation($movcliente: [iMovClientesUpd]){
                    editMovClientesMany(
                        movcliente: $movcliente
                    ){
                        success
                        errors{
                            path
                            message
                            }                
                        }
                    }
                `,
                editMovClientes: gpl`
                  mutation($_id: ID, $tipoAct: String, $contrato: String, $contratoNvo: String,
                          $procesado: String,
                          $numeroOdeDX: Number, $concepto: String, $numeroFra: String,
                          $numeroRC: String, $numeroCE: String, $documento: String, $valorPagado: Number,
                          $valorPendiente: Number, $fechaUltPago: Date, $valorUltPago: Number){
                      editMovClientes(
                        movcliente:{
                              _id: $_id,
                              tipoAct: $tipoAct,
                              contrato: $contrato,
                              contratoNvo: $contratoNvo,
                              procesado: $procesado,
                              numeroOdeDX: $numeroOdeDX,
                              concepto: $concepto,
                              numeroFra: $numeroFra,
                              numeroRC: $numeroRC,
                              numeroCE: $numeroCE,
                              documento: $documento,
                              valorPagado: $valorPagado,
                              valorPendiente: $valorPendiente
                              fechaUltPago: $fechaUltPago,
                              valorUltPago: $valorUltPago,
                          }
                      ){
                          success
                          errors{
                              path
                              message
                          }                
                      }
                  }
                  `,
                  editMovCliCCMany: gpl`
                  mutation($movcliente: [iMovCliCCUpd]){
                      editMovCliCCMany(
                          movcliente: $movcliente
                      ){
                          success
                          errors{
                              path
                              message
                              }                
                          }
                      }
                  `,
                  editMovCliCC: gpl`
                    mutation($_id: ID, $tipoAct: String, $contrato: String, $contratoNvo: String,
                            $procesado: String,
                            $numeroOdeDX: Number, $concepto: String, $numeroFra: String,
                            $numeroRC: String, $numeroCE: String, $documento: String, $valorPagado: Number,
                            $fechaUltPago: Date, $valorUltPago: Number, $fechaNoFact: Date, $usuarioNoFact: String
                          ){
                        editMovCliCC(
                          movcliente:{
                                _id: $_id,
                                tipoAct: $tipoAct,
                                contrato: $contrato,
                                contratoNvo: $contratoNvo,
                                procesado: $procesado,
                                numeroOdeDX: $numeroOdeDX,
                                concepto: $concepto,
                                numeroFra: $numeroFra,
                                numeroRC: $numeroRC,
                                numeroCE: $numeroCE,
                                documento: $documento,
                                valorPagado: $valorPagado,
                                fechaUltPago: $fechaUltPago,
                                valorUltPago: $valorUltPago,
                                fechaNoFact: $fechaNoFact,
                                usuarioNoFact: $usuarioNoFact,                              
                            }
                        ){
                            success
                            errors{
                                path
                                message
                            }                
                        }
                    }
                  `,
                  editProgServ: gpl`
                    mutation($_id: ID, $contrato: String, $fechaProg: Date, $procesado: String,
                            $codigoTarifa: String, $descrTarifa: String,
                            $codigoServicio: String, $descripcionServicio: String, $nombreResumido: String,
                            $valorTotal: Number
                          ){
                        editProgServ(
                          progserv:{
                                _id: $_id,
                                contrato: $contrato,
                                fechaProg: $fechaProg,
                                procesado: $procesado,
                                codigoTarifa: $codigoTarifa,
                                descrTarifa: $descrTarifa,
                                codigoServicio: $codigoServicio,
                                nombreResumido: $nombreResumido,
                                descripcionServicio: $descripcionServicio,
                                valorTotal: $valorTotal,
                            }
                        ){
                            success
                            errors{
                                path
                                message
                            }                
                        }
                    }
                    `,
                    editPagoClientes: gpl`
                    mutation($_id: ID, $tipoAct: String, $contrato: String, $contratoNvo: String,
                      $descripcionPago: String, $fechaPago: Date, $numeroFra: String, $numeroRC: String,
                      $documento: String, $numeroRT: String, $numeroDocum: String,
                      $descrRecurso: String, $descrOficina: String,
                      $valorTotal: Number, $valorEf: Number, $valorCh: Number, $numeroCh: String,
                      $bancoCh: String, $fechaVencCh: Date, $valorTr: Number, $bancoTr: String,
                      $fechaTr: Date, $valorTD: Number, $bancoTD: String, $valorTC: Number,
                      $bancoTC: String, $razonap: String, $fechaCreate: String){
                      editPagoClientes(
                        pagocliente:{
                            _id: $_id,
                            tipoAct: $tipoAct,
                            contrato: $contrato,
                            contratoNvo: $contratoNvo,
                            descripcionPago: $descripcionPago
                            fechaPago: $fechaPago
                            numeroFra: $numeroFra
                            numeroRC: $numeroRC
                            documento: $documento
                            numeroRT: $numeroRT
                            numeroDocum: $numeroDocum
                            descrRecurso: $descrRecurso
                            descrOficina: $descrOficina
                            valorTotal: $valorTotal
                            valorEf: $valorEf
                            valorCh: $valorCh
                            numeroCh: $numeroCh
                            bancoCh: $bancoCh
                            fechaVencCh: $fechaVencCh
                            valorTr: $valorTr
                            bancoTr: $bancoTr
                            fechaTr: $fechaTr
                            valorTD: $valorTD
                            bancoTD: $bancoTD
                            valorTC: $valorTC
                            bancoTC: $bancoTC
                            razonap: $razonap
                            fechaCreate: $fechaCreate
                        }
                      ){
                        success
                        errors{
                          path
                          message
                        }                
                      }
                    }
                    `,
                    editFacturacion: gpl`
                    mutation($tipoAct: String, $contrato: String, $contratoNvo: String,
                        $codProcFact: String, $numeroFra: String, $fechaFact: Date){
                      editFacturacion(
                        facturacion:{
                                tipoAct: $tipoAct,
                                contrato: $contrato,
                                contratoNvo: $contratoNvo,
                                codProcFact: $codProcFact,
                                numeroFra: $numeroFra,
                                fechaFact: $fechaFact,
                            }
                        ){
                            success
                            errors{
                                path
                                message
                            }                
                        }
                    }
                    `,
                    editHistCliente: gpl`
                    mutation($tipoAct: String, $contrato: String, $contratoNvo: String){
                      editHistCliente(
                        histcliente:{
                                tipoAct: $tipoAct,
                                contrato: $contrato,
                                contratoNvo: $contratoNvo,
                            }
                        ){
                            success
                            errors{
                                path
                                message
                            }                
                        }
                    }
                    `,
                    editCargoEsp: gpl`
                    mutation($_id: ID, $tipoAct: String, $contrato: String, $contratoNvo: String,
                        $numeroCE: String, $fechaCE: Date){
                      editCargoEsp(
                        cargoesp:{
                            _id: $_id,
                            tipoAct: $tipoAct
                            contrato: $contrato
                            contratoNvo: $contratoNvo
                            numeroCE: $numeroCE,
                            fechaCE: $fechaCE,
                          }
                        ){
                          success
                          errors{
                            path
                            message
                          }                
                        }
                    }
                    `,
                    editNotasDebCre: gpl`
                    mutation($tipoAct: String, $contrato: String, $contratoNvo: String,
                        $numeroFra: String, $fechaNota: Date){
                      editNotasDebCre(
                        notasdebcre:{
                            tipoAct: $tipoAct
                            contrato: $contrato
                            contratoNvo: $contratoNvo
                            numeroFra: $numeroFra,
                            fechaNota: $fechaNota,
                            }
                        ){
                            success
                            errors{
                                path
                                message
                            }                
                        }
                    }
                    `,
                    editAjuste: gpl`
                    mutation($tipoAct: String, $contrato: String, $contratoNvo: String){
                        editAjuste(
                            ajuste:{
                                tipoAct: $tipoAct
                                contrato: $contrato     
                                contratoNvo: $contratoNvo   
                            }
                        ){
                            success
                            errors{
                                path
                                message
                            }                
                        }
                    }
                    `,
                    editFacturacionUpdDoc: gpl`
                      mutation($_id: ID, $tipoAct: String, $numeroFra: String,
                        $codigoServicio: String, $nombreResumido: String,
                        $descripcionServicio: String, $descrClaseServ: String,
                        $velEfecDownstream: String, $velEfecUpstream: String,
                        $codigoTipoTec: String, $descrTipoTec: String,
                        $concepto: String, $periodo: String, $tipo: String, $consecEnFra: Number,
                        $porcImpto: Number, $valor: Number){
                          editFacturacionUpdDoc(
                            facturacion:{
                              _id: $_id
                              tipoAct: $tipoAct
                              numeroFra: $numeroFra
                              detalleFact:{
                                codigoServicio: $codigoServicio
                                nombreResumido: $nombreResumido
                                descripcionServicio: $descripcionServicio
                                descrClaseServ: $descrClaseServ
                                velEfecDownstream: $velEfecDownstream,
                                velEfecUpstream: $velEfecUpstream,
                                codigoTipoTec: $codigoTipoTec,
                                descrTipoTec: $descrTipoTec,
                                concepto: $concepto
                                periodo: $periodo
                                tipo: $tipo
                                consecEnFra: $consecEnFra
                                porcImpto: $porcImpto
                                valor: $valor
                              },
                            }
                          ){
                            success
                            errors{
                                path
                                message
                            }                
                        }
                      }
                      `,
                      editCargoEspUpdDoc: gpl`
                        mutation($_id: ID, $tipoAct: String, $numeroCE: String,
                          $_idMC: String, $codigoServicio: String, $nombreResumido: String,
                          $descripcionServicio: String, $descrClaseServ: String, $concepto: String,
                          $periodo: String, $tipo: String, $consecEnCE: Number,
                          $porcImpto: Number, $valor: Number){
                            editCargoEspUpdDoc(
                              cargoesp:{
                                _id: $_id
                                tipoAct: $tipoAct
                                numeroCE: $numeroCE
                                detalleCE:{
                                  _idMC: $_idMC
                                  codigoServicio: $codigoServicio
                                  nombreResumido: $nombreResumido
                                  descripcionServicio: $descripcionServicio
                                  descrClaseServ: $descrClaseServ
                                  concepto: $concepto
                                  periodo: $periodo
                                  tipo: $tipo
                                  consecEnCE: $consecEnCE
                                  porcImpto: $porcImpto
                                  valor: $valor
                                },
                              }
                            ){
                              success
                              errors{
                                  path
                                  message
                              }                
                          }
                        }
                        `,
                        editNotasDebCreUpdDoc: gpl`
                        mutation($_id: ID, $tipoAct: String, $numeroFra: String,
                          $_idMC: String, $codigoServicio: String, $nombreResumido: String,
                          $descripcionServicio: String, $descrClaseServ: String, $concepto: String,
                          $periodo: String, $tipo: String, $consecEnFra: Number,
                          $porcImpto: Number, $valor: Number){
                            editNotasDebCreUpdDoc(
                              notasdebcre:{
                                _id: $_id
                                tipoAct: $tipoAct
                                numeroFra: $numeroFra
                                detalleNota:{
                                  _idMC: $_idMC
                                  codigoServicio: $codigoServicio
                                  nombreResumido: $nombreResumido
                                  descripcionServicio: $descripcionServicio
                                  descrClaseServ: $descrClaseServ
                                  concepto: $concepto
                                  periodo: $periodo
                                  tipo: $tipo
                                  consecEnFra: $consecEnFra
                                  porcImpto: $porcImpto
                                  valor: $valor
                                },
                              }
                            ){
                              success
                              errors{
                                  path
                                  message
                              }                
                          }
                        }
                        `,
                          editMovClientesUpdDoc: gpl`
                            mutation($_id: ID, $tipoAct: String, $origen: String,
                                $codigoServicio: String, $codigoImpto: String,
                                $descrImpto: String, $porcImpto: Number, $valorImpto: Number){
                                editMovClientesUpdDoc(
                                    movcliente:{
                                        _id: $_id,
                                        tipoAct: $tipoAct,
                                        origen: $origen,
                                        codigoServicio: $codigoServicio,
                                        imptos:{
                                            codigoImpto: $codigoImpto,
                                            descrImpto: $descrImpto,
                                            porcImpto: $porcImpto,
                                            valorImpto: $valorImpto,
                                        }
                                                    }
                                ){
                                    success
                                    errors{
                                        path
                                        message
                                    }                
                                }
                            }
                            `,
                            editMovCliCCUpdDoc: gpl`
                              mutation($_id: ID, $tipoAct: String, $origen: String,
                                  $codigoServicio: String, $codigoImpto: String,
                                  $descrImpto: String, $porcImpto: Number, $valorImpto: Number){
                                  editMovCliCCUpdDoc(
                                      movcliente:{
                                          _id: $_id,
                                          tipoAct: $tipoAct,
                                          origen: $origen,
                                          codigoServicio: $codigoServicio,
                                          imptos:{
                                              codigoImpto: $codigoImpto,
                                              descrImpto: $descrImpto,
                                              porcImpto: $porcImpto,
                                              valorImpto: $valorImpto,
                                          }
                                                      }
                                  ){
                                      success
                                      errors{
                                          path
                                          message
                                      }                
                                  }
                              }
                              `,
                              editMovClientesPHMany: gpl`
                                mutation($movcliente: [iMovClientesUpdPH]){
                                    editMovClientesPHMany(
                                        movcliente: $movcliente
                                    ){
                                        success
                                        errors{
                                            path
                                            message
                                            }                
                                        }
                                    }
                                    `,
                            editPagoClientesUpdDoc: gpl`
                            mutation($_id: ID, $tipoAct: String, $contrato: String,
                                $idMovClientes: String, $codigoServicio: String,
                                $nombreResumido: String, $descripcionServicio: String,
                                $descrClaseServ: String, $concepto: String,
                                $periodo: String, $valorTotal: Number, $valorDetalle: Number){
                                  editPagoClientesUpdDoc(
                                    pagocliente:{
                                      _id: $_id,
                                      tipoAct: $tipoAct,
                                      contrato: $contrato,
                                      detalle:{
                                        idMovClientes: $idMovClientes,
                                        codigoServicio: $codigoServicio,
                                        nombreResumido: $nombreResumido,
                                        descripcionServicio: $descripcionServicio,
                                        descrClaseServ: $descrClaseServ,
                                        concepto: $concepto,
                                        periodo: $periodo,
                                        valorTotal: $valorTotal,
                                        valorDetalle: $valorDetalle
                                      }
                                    }
                                ){
                                  success
                                  errors{
                                    path
                                    message
                                  }                
                                }
                            }
                            `,
                        editOdeS: gpl`
                        mutation($numeroOS: Number, $estadoOS: String, $impresa: Boolean,
                            $ptosAdic: Number, $descrCategOST: String, $cun: String,
                            $descrEstrato: String, $observacAB: String, $observacCE: String,
                            $observacCA: String, $codigoMarquilla: String, $descrNodo: String,
                            $codigoPaquete: String, $descrPaquete: String,
                            $descrClasifOST: String, $codigoTipoDocV: String, $numeroDocumV: String,
                            $descrRecursoV: String, $tag: String, $horaSolic: String, $nombreSolic: String,
                            $genOSDirAnt: String, $osQueLaGenero: Number,
                            $fechaImpr: Date, $usuarioImpr: String, $fechaClose: Date, $horaClose: String,
                            $usuarioClose: String, $fechaCanc: Date, $usuarioCanc: String, $fechaEjec: Date, $fechaFra: Date){
                            editOdeS(odes:{
                                numeroOS: $numeroOS
                                estadoOS: $estadoOS
                                impresa: $impresa
                                ptosAdic: $ptosAdic
                                descrCategOST: $descrCategOST
                                cun: $cun
                                descrEstrato: $descrEstrato
                                observacAB: $observacAB
                                observacCE: $observacCE
                                observacCA: $observacCA
                                codigoMarquilla: $codigoMarquilla
                                descrNodo: $descrNodo
                                codigoPaquete: $codigoPaquete
                                descrPaquete: $descrPaquete
                                descrClasifOST: $descrClasifOST
                                codigoTipoDocV: $codigoTipoDocV
                                numeroDocumV: $numeroDocumV
                                descrRecursoV: $descrRecursoV
                                tag: $tag
                                horaSolic: $horaSolic
                                nombreSolic: $nombreSolic
                                genOSDirAnt: $genOSDirAnt
                                osQueLaGenero: $osQueLaGenero
                                fechaImpr: $fechaImpr
                                usuarioImpr: $usuarioImpr
                                fechaClose: $fechaClose
                                horaClose: $horaClose
                                usuarioClose: $usuarioClose
                                fechaCanc: $fechaCanc
                                usuarioCanc: $usuarioCanc
                                fechaEjec: $fechaEjec
                                fechaFra: $fechaFra
                            }
                            ){
                                success
                                errors{
                                    path
                                    message
                                }
                            }
                        }
                        `,
            editOdeSUpdDoc: gpl`
                mutation($_id: ID, $tipoAct: String, $numeroOS: Number, $ptosAdic: Number,
                    $descrCategOST: String, $cun: String, $descrEstrato: String, $descrTipoRecT: String,
                    $observacAB: String, $observacCE: String, $observacCA: String,
                    $codigoMarquilla: String, $descrNodo: String,
                    $codigoPaquete: String, $descrPaquete: String,
                    $descrClasifOST: String, $codigoDpto: String,
                    $descrDpto: String, $codigoDptoDANE: String,
                    $codigoCiudad: String, $nombreCiudad: String, $codigoMunicipioDANE: String,
                    $codigoPostalDANE: String, $codigoCiudadInterno: String,
                    $codBarrasRdo: String, $codigoZona: String,
                    $nombreZona: String, $codigoBarrio: String, $nombreBarrio: String,
                    $codigoTipoDocT: String, $numeroDocumT: String, $descrRecursoT: String,
                    $codigoTipoDocR: String, $numeroDocumR: String, $descrRecursoR: String,
                    $descrTipoVia1: String, $numeroTipoVia1: String, $descrTipoVia2: String,
                    $numeroTipoVia2:String, $numeroTipoVia2F: String, $descrTipoUnd1: String,
                    $numeroTipoUnd1: String, $descrTipoUnd2: String, $numeroTipoUnd2: String,
                    $descrTiUndMat: String, $descrUndMat: String,
                    $codigoTarifa: String, $descrTarifa: String, $cicloFact: String, $fechaVence: Date,
                    $codigoServicioT: String, $nombreResumidoT: String, $descripcionServicioT: String,
                    $_idSubclaseServT: ID, $codigoSubclaseServT: String, $descrSubclaseServT: String,
                    $_idClaseServT: ID, $codigoClaseServT: String, $descrClaseServT: String,
                    $velEfecDownstream: String, $velEfecUpstream: String,
                    $codigoTipoTec: String, $descrTipoTec: String, $colorServicio: String, $estadoServicio: String,
                    $rango1NumServValorIni: Number, $rango1NumServValorFin: Number, $rango1Valor: Number,
                    $rango2NumServValorIni: Number, $rango2NumServValorFin: Number, $rango2Valor: Number,
                    $rango3NumServValorIni: Number, $rango3NumServValorFin: Number, $rango3Valor: Number,
                    $numeroServicios: Number, $valorServicios: Number, $valorAntesImptos: Number,
                    $codigoImpto: String, $descrImpto: String, $porcImpto: Number, $valorImpto: Number,
                    $descrClaseServ: String, $codigoServicio: String, $nombreResumido: String,
                    $descripcionServicio: String, $fechaCargo: Date, $conceptoEnFra: String,
                    $periodoFrado: String, $origen: String, $numeroServiciosCF: Number,
                    $valorTotal: Number, $valorAntesImptosCF: Number, $codigoImptoCF: String,
                    $descrImptoCF: String, $porcImptoCF: Number, $valorImptoCF: Number,
                    $agnoFra: String, $mesFra: String,
                    $codigoOferta: String, $descrOferta: String,
                    $codigoServicioO: String, $nombreResumidoO: String, $descripcionServicioO: String,
                    $_idSubclaseServO: ID, $codigoSubclaseServO: String, $descrSubclaseServO: String,
                    $_idClaseServO: ID, $codigoClaseServO: String, $descrClaseServO: String,
                    $porcDctoOferta: Number, $numDiasOferta: Number, $fechaFinOferta: Date,
                    $fechaInicioOferta: Date, $numeroSerie: String, $mac: String, $accion: String,
                    $_idClaseEqu: ID, $codigoClaseEqu: String, $descrClaseEqu: String,
                    $_idMarcaEqu: ID, $codigoMarcaEqu: String, $descrMarcaEqu: String,
                    $_idFabriEqu: ID, $codigoFabriEqu: String, $descrFabriEqu: String,
                    $_idBodega: ID, $codigoBodega: String, $descrBodega: String,
                    $_idRecurso: ID, $codigoTipoDoc: String, $numeroDocum: String, $descrRecurso: String,
                    $_idTipoRec: ID, $descrTipoRec: String, $areaAprovech: String
                ){
                    editOdeSUpdDoc(odes:{
                        _id: $_id,
                        tipoAct: $tipoAct,
                        numeroOS: $numeroOS,
                        ptosAdic: $ptosAdic,
                        descrCategOST: $descrCategOST,
                        cun: $cun
                        descrEstrato: $descrEstrato
                        descrTipoRecT: $descrTipoRecT,
                        observacAB: $observacAB,
                        observacCE: $observacCE,
                        observacCA: $observacCA,
                        codigoMarquilla: $codigoMarquilla,
                        descrNodo: $descrNodo,
                        codigoPaquete: $codigoPaquete,
                        descrPaquete: $descrPaquete,
                        descrClasifOST: $descrClasifOST,
                        dirmayor:{
                            codigoDpto: $codigoDpto,
                            descrDpto: $descrDpto,
                            codigoDptoDANE: $codigoDptoDANE,
                            ciudades:{
                                codigoCiudad: $codigoCiudad,
                                nombreCiudad: $nombreCiudad,
                                codigoMunicipioDANE: $codigoMunicipioDANE,
                                codigoPostalDANE: $codigoPostalDANE,
                                codigoCiudadInterno: $codigoCiudadInterno,
                                codBarrasRdo: $codBarrasRdo,                              
                                zonas:{
                                    codigoZona: $codigoZona,
                                    nombreZona: $nombreZona,
                                    barrios:{
                                        codigoBarrio: $codigoBarrio,
                                        nombreBarrio: $nombreBarrio,
                                        codigoTipoDocT: $codigoTipoDocT,
                                        numeroDocumT: $numeroDocumT,
                                        descrRecursoT: $descrRecursoT,
                                        codigoTipoDocR: $codigoTipoDocR,
                                        numeroDocumR: $numeroDocumR,
                                        descrRecursoR: $descrRecursoR
                                    }
                                }
                            }
                        },
                        direccion:{
                            descrTipoVia1: $descrTipoVia1,
                            numeroTipoVia1: $numeroTipoVia1,
                            descrTipoVia2: $descrTipoVia2,
                            numeroTipoVia2: $numeroTipoVia2,
                            numeroTipoVia2F: $numeroTipoVia2F,
                            descrTipoUnd1: $descrTipoUnd1,
                            numeroTipoUnd1: $numeroTipoUnd1,
                            descrTipoUnd2: $descrTipoUnd2,
                            numeroTipoUnd2: $numeroTipoUnd2,
                            descrTiUndMat: $descrTiUndMat,
                            descrUndMat: $descrUndMat
                        },
                        tarifa:{
                            codigoTarifa: $codigoTarifa,
                            descrTarifa: $descrTarifa,
                            cicloFact: $cicloFact,
                            fechaVence: $fechaVence,
                            servicios:{
                                codigoServicio: $codigoServicioT,
                                nombreResumido: $nombreResumidoT,
                                descripcionServicio: $descripcionServicioT,
                                subclaseserv:{
                                    _id: $_idSubclaseServT,
                                    codigoSubclaseServ: $codigoSubclaseServT,
                                    descrSubclaseServ: $descrSubclaseServT
                                    claseserv:{
                                        _id: $_idClaseServT,
                                        codigoClaseServ: $codigoClaseServT,
                                        descrClaseServ: $descrClaseServT
                                    },
                                },
                                velEfecDownstream: $velEfecDownstream, velEfecUpstream: $velEfecUpstream,
                                codigoTipoTec: $codigoTipoTec, descrTipoTec: $descrTipoTec,
                                colorServicio: $colorServicio,
                                estadoServicio: $estadoServicio,
                                rango1NumServValorIni: $rango1NumServValorIni,
                                rango1NumServValorFin: $rango1NumServValorFin,
                                rango1Valor: $rango1Valor,
                                rango2NumServValorIni: $rango2NumServValorIni,
                                rango2NumServValorFin: $rango2NumServValorFin,
                                rango2Valor: $rango2Valor,
                                rango3NumServValorIni: $rango3NumServValorIni,
                                rango3NumServValorFin: $rango3NumServValorFin,
                                rango3Valor: $rango3Valor,
                                numeroServicios: $numeroServicios,
                                valorServicios: $valorServicios,
                                valorAntesImptos: $valorAntesImptos,
                                imptos:{
                                    codigoImpto: $codigoImpto,
                                    descrImpto: $descrImpto,
                                    porcImpto: $porcImpto,
                                    valorImpto: $valorImpto,
                                }
                            }
                        },
                        cargoFra:{
                            descrClaseServ: $descrClaseServ,
                            codigoServicio: $codigoServicio,
                            nombreResumido: $nombreResumido,
                            descripcionServicio: $descripcionServicio,
                            fechaCargo: $fechaCargo,
                            conceptoEnFra: $conceptoEnFra,
                            periodoFrado: $periodoFrado,
                            origen: $origen,
                            numeroServicios: $numeroServiciosCF,
                            valorTotal: $valorTotal,
                            valorAntesImptos: $valorAntesImptosCF,
                            imptos:{
                                codigoImpto: $codigoImptoCF,
                                descrImpto: $descrImptoCF,
                                porcImpto: $porcImptoCF,
                                valorImpto: $valorImptoCF,
                            }
                            agnoFra: $agnoFra,
                            mesFra: $mesFra,
                        },
                        oferta:{
                            codigoOferta: $codigoOferta,
                            descrOferta: $descrOferta,
                            servicios:{
                                codigoServicio: $codigoServicioO,
                                nombreResumido: $nombreResumidoO,
                                descripcionServicio: $descripcionServicioO,
                                subclaseserv:{
                                    _id: $_idSubclaseServO,
                                    codigoSubclaseServ: $codigoSubclaseServO,
                                    descrSubclaseServ: $descrSubclaseServO
                                    claseserv:{
                                        _id: $_idClaseServO,
                                        codigoClaseServ: $codigoClaseServO,
                                        descrClaseServ: $descrClaseServO
                                    }
                                },
                                porcDctoOferta: $porcDctoOferta,
                                numDiasOferta: $numDiasOferta,
                                fechaFinOferta: $fechaFinOferta,
                            },
                            fechaInicioOferta: $fechaInicioOferta
                        },
                        equipos:{
                            numeroSerie: $numeroSerie,
                            mac: $mac,
                            accion: $accion,
                            claseequ:{
                                _id: $_idClaseEqu,
                                codigoClaseEqu: $codigoClaseEqu,
                                descrClaseEqu: $descrClaseEqu
                            },
                            marcaequ:{
                                _id: $_idMarcaEqu,
                                codigoMarcaEqu: $codigoMarcaEqu,
                                descrMarcaEqu: $descrMarcaEqu
                            },
                            fabriequ:{
                                _id: $_idFabriEqu,
                                codigoFabriEqu: $codigoFabriEqu,
                                descrFabriEqu: $descrFabriEqu
                            },
                            bodega:{
                                _id: $_idBodega,
                                codigoBodega: $codigoBodega,
                                descrBodega: $descrBodega
                            },
                        },
                        recursos:{
                            _id: $_idRecurso,
                            codigoTipoDoc: $codigoTipoDoc,
                            numeroDocum: $numeroDocum,
                            descrRecurso: $descrRecurso,
                            tiporec:{
                                _id: $_idTipoRec,
                                descrTipoRec: $descrTipoRec,
                                areaAprovech: $areaAprovech
                            }
                        }
                        }
                    ){
                        success
                        errors{
                            path
                            message
                        }                
                    }
                }
                `,
                editOdeSContr: gpl`
                mutation($tipoAct: String, $contrato: String, $contratoNvo: String){
                    editOdeSContr(
                      odes:{
                            tipoAct: $tipoAct
                            contrato: $contrato
                            contratoNvo: $contratoNvo
                        }
                    ){
                        success
                        errors{
                            path
                            message
                        }                
                    }
                }
                `,
                updDocumMany: gpl`
                mutation($docum: [iUpdDocum]){
                  updDocumMany(
                    docum: $docum
                  ){
                        success
                        errors{
                            path
                            message
                            }                
                        }
                    }
                    `,
            editClienteMany: gpl`
                mutation($cliente: [iClienteUpd]){
                    editClienteMany(
                      cliente: $cliente
                    ){
                        success
                        errors{
                            path
                            message
                            }                
                        }
                    }
                    `,
                    editClienteUpdDocMany: gpl`
                    mutation($cliente: [iClienteUpdDoc]){
                        editClienteUpdDocMany(
                          cliente: $cliente
                        ){
                            success
                            errors{
                                path
                                message
                                }                
                            }
                        }
                    `,
                editCliente: gpl`
                mutation($_id: ID, $tipoAct: String, $contrato: String, $infAdic1: String, $contratoNvo: String,
                        $estadoCliente: String, $cargoMensual: Number,
                        $saldoPendiente: Number, $diasMora: Number, $pagueHasta: Date,
                        $totPagoAdelSinFrar: Number, $porcFact:  Number, $envFraCorreo: String,
                        $nombreCliente: String, $apellidoCliente: String, $sexoCliente: String,
                        $eMail: String, $observaciones: String, $codigoMarquilla: String,
                        $descrNodo: String, $codigoSegmento: String, $descrSegmento: String,
                        $codigoPaquete: String, $descrPaquete: String, $numSorteos: String,
                        $noFactOSAb: Boolean, $descrEstrato: String,
                        $cicloFact: String, $tag: String, $referencia1: String, $telefonoRef1: String, 
                        $referencia2: String, $telefonoRef2: String, 
                        $fechaUltOSAb: Date, $fechaPrimeraActivacion: Date, $fechaUltDX: Date, 
                        $fecgaUltRX: Date, $estadoAnterior: String, $fechaUltOSCe: Date, 
                        $fechaUltPago: Date, $valorUltPago: Number, $cupoFinanc: Number, 
                        $numeroOdeDX: Number, $numeroDoc: String, $updDocApp: Boolean,
                        $telefono1: String, $telefono2: String, $telefono3: String,
                        $codigoTipoCliente: String, $descrTipoCliente: String,
                        $idTipoDoc: ID, $codigoTipoDoc: String, $descrTipoDoc: String,
                        $idGrupoAf: ID, $codigoGrupoAfin: String, $descrGrupoAfin: String,
                        $fechaCumple: Date, $datosConfirmados: String,
                        $autFraEmail: String, $autFraWhatsApp: String,
                        $_idAnteriorTC: ID){
                    editCliente(
                    cliente:{
                        _id: $_id,
                        tipoAct: $tipoAct
                        contrato: $contrato
                        infAdic1: $infAdic1
                        contratoNvo: $contratoNvo
                        estadoCliente: $estadoCliente
                        cargoMensual: $cargoMensual
                        saldoPendiente: $saldoPendiente
                        diasMora: $diasMora
                        pagueHasta: $pagueHasta
                        totPagoAdelSinFrar: $totPagoAdelSinFrar
                        porcFact: $porcFact
                        envFraCorreo: $envFraCorreo
                        nombreCliente: $nombreCliente,
                        apellidoCliente: $apellidoCliente,
                        sexoCliente: $sexoCliente,
                        eMail: $eMail,
                        descrEstrato: $descrEstrato,
                        cicloFact: $cicloFact,
                        tag: $tag,
                        referencia1: $referencia1,
                        telefonoRef1: $telefonoRef1,
                        referencia2: $referencia2,
                        telefonoRef2: $telefonoRef2,
                        fechaUltOSAb: $fechaUltOSAb,
                        fechaPrimeraActivacion: $fechaPrimeraActivacion,
                        fechaUltDX: $fechaUltDX,
                        fecgaUltRX: $fecgaUltRX,
                        estadoAnterior: $estadoAnterior,
                        fechaUltOSCe: $fechaUltOSCe,
                        fechaUltPago: $fechaUltPago,
                        valorUltPago: $valorUltPago,
                        cupoFinanc: $cupoFinanc,
                        numeroOdeDX: $numeroOdeDX,
                        telefono1: $telefono1,
                        telefono2: $telefono2,
                        telefono3: $telefono3,
                        numeroDoc: $numeroDoc,
                        updDocApp: $updDocApp,
                        observaciones: $observaciones,
                        codigoMarquilla: $codigoMarquilla,
                        descrNodo: $descrNodo,
                        codigoSegmento: $codigoSegmento,
                        descrSegmento: $descrSegmento,
                        codigoPaquete: $codigoPaquete,
                        descrPaquete: $descrPaquete,
                        numSorteos: $numSorteos,
                        noFactOSAb: $noFactOSAb,
                        fechaCumple: $fechaCumple,
                        datosConfirmados: $datosConfirmados,
                        autFraEmail: $autFraEmail,
                        autFraWhatsApp: $autFraWhatsApp,
                        tipocl:{
                            codigoTipoCliente: $codigoTipoCliente,
                            descrTipoCliente: $descrTipoCliente
                        },
                        tipodoc:{
                            _id: $idTipoDoc,
                            codigoTipoDoc: $codigoTipoDoc,
                            descrTipoDoc: $descrTipoDoc
                        },
                        grupoaf:{
                            _id: $idGrupoAf,
                            codigoGrupoAfin: $codigoGrupoAfin,
                            descrGrupoAfin: $descrGrupoAfin
                        }
                    },
                    _idAnteriorTC: $_idAnteriorTC
                ){
                    success
                    errors{
                        path
                        message
                        }                
                    }
                }
                `,
                editTarifa: gpl`
                    mutation($_id: ID, $descrTarifa: String, $cicloFact: String, $estadoTarifa: Boolean){
                        editTarifa(
                            tarifa:{
                            _id: $_id,
                            descrTarifa: $descrTarifa,
                            cicloFact: $cicloFact,
                            estadoTarifa: $estadoTarifa,
                        }
                        ){
                        success
                        errors{
                            path
                            message
                            }                
                        }
                    }
                `,
            editTarifaUpdServ: gpl`
                mutation($_id: ID, $descrTarifa: String, $estadoTarifa: Boolean,
                        $codigoServicio: String, $nombreResumido: String, $descripcionServicio: String,
                        $_idSubclaseServ: ID, $codigoSubclaseServ: String, $descrSubclaseServ: String,
                        $_idClaseServ: ID, $codigoClaseServ: String, $descrClaseServ: String,
                        $velEfecDownstream: String, $velEfecUpstream: String,
                        $codigoTipoTec: String, $descrTipoTec: String,
                        $rango1NumServValorIni: Number, $rango1NumServValorFin: Number, $rango1Valor: Number,
                        $rango2NumServValorIni: Number, $rango2NumServValorFin: Number, $rango2Valor: Number,
                        $rango3NumServValorIni: Number, $rango3NumServValorFin: Number, $rango3Valor: Number,
                        $_idImpto: ID, $codigoImpto: String, $descrImpto: String, $porcImpto: Number,
                        $codigoTipoOS: String, $descrTipoOS: String,
                        $concepto1Tarifa: String, $valor1Tarifa: Number, $concepto2Tarifa: String, $valor2Tarifa: Number,
                        $concepto3Tarifa: String, $valor3Tarifa: Number,
                        $_idImptoTipoOS: ID, $codigoImptoTipoOS: String, $descrImptoTipoOS: String, $porcImptoTipoOS: Number,
                        $tipoAct: String){
                            editTarifaUpdServ(tarifa:{
                                _id: $_id,
                                descrTarifa: $descrTarifa,
                                estadoTarifa: $estadoTarifa,
                                tipoAct: $tipoAct,
                                servicios:{
                                    codigoServicio: $codigoServicio,
                                    nombreResumido: $nombreResumido,
                                    descripcionServicio: $descripcionServicio,
                                    subclaseserv:{
                                        _id: $_idSubclaseServ,
                                        codigoSubclaseServ: $codigoSubclaseServ,
                                        descrSubclaseServ: $descrSubclaseServ
                                        claseserv:{
                                            _id: $_idClaseServ,
                                            codigoClaseServ: $codigoClaseServ,
                                            descrClaseServ: $descrClaseServ
                                        },
                                    },
                                    velEfecDownstream: $velEfecDownstream,
                                    velEfecUpstream: $velEfecUpstream,
                                    codigoTipoTec: $codigoTipoTec,
                                    descrTipoTec: $descrTipoTec,
                                    rango1NumServValorIni: $rango1NumServValorIni,
                                    rango1NumServValorFin: $rango1NumServValorFin,
                                    rango1Valor: $rango1Valor,
                                    rango2NumServValorIni: $rango2NumServValorIni,
                                    rango2NumServValorFin: $rango2NumServValorFin,
                                    rango2Valor: $rango2Valor,
                                    rango3NumServValorIni: $rango3NumServValorIni,
                                    rango3NumServValorFin: $rango3NumServValorFin,
                                    rango3Valor: $rango3Valor,
                                    imptos:{
                                        _id: $_idImpto,
                                        codigoImpto: $codigoImpto,
                                        descrImpto: $descrImpto,
                                        porcImpto: $porcImpto,
                                    }
                                },
                                tipoos:{
                                    codigoTipoOS: $codigoTipoOS,
                                    descrTipoOS: $descrTipoOS,
                                    concepto1Tarifa: $concepto1Tarifa,
                                    valor1Tarifa: $valor1Tarifa,
                                    concepto2Tarifa: $concepto2Tarifa,
                                    valor2Tarifa: $valor2Tarifa,
                                    concepto3Tarifa: $concepto3Tarifa,
                                    valor3Tarifa: $valor3Tarifa,
                                    imptos:{
                                        _id: $_idImptoTipoOS,
                                        codigoImpto: $codigoImptoTipoOS,
                                        descrImpto: $descrImptoTipoOS,
                                        porcImpto: $porcImptoTipoOS,
                                    }
                                }
                            }){
                            success
                            errors{
                                path
                                message
                                }                
                            }
                        }
                        `,
                        editOferta: gpl`
                            mutation($_id: ID, $descrOferta: String, $estadoOferta: Boolean){
                                editOferta(
                                    oferta:{
                                    _id: $_id,
                                    descrOferta: $descrOferta,
                                    estadoOferta: $estadoOferta,
                                }
                                ){
                                success
                                errors{
                                    path
                                    message
                                    }                
                                }
                            }
                        `,
                    editOfertaUpdServ: gpl`
                        mutation($_id: ID, $descrOferta: String, $estadoOferta: Boolean,
                                $codigoServicio: String, $nombreResumido: String, $descripcionServicio: String,
                                $_idSubclaseServ: ID, $codigoSubclaseServ: String, $descrSubclaseServ: String,
                                $_idClaseServ: ID, $codigoClaseServ: String, $descrClaseServ: String,
                                $porcDctoOferta: Number, $numDiasOferta: Number,
                                $tipoAct: String){
                                    editOfertaUpdServ(oferta:{
                                        _id: $_id,
                                        descrOferta: $descrOferta,
                                        estadoOferta: $estadoOferta,
                                        tipoAct: $tipoAct,
                                        servicios:{
                                            codigoServicio: $codigoServicio,
                                            nombreResumido: $nombreResumido,
                                            descripcionServicio: $descripcionServicio,
                                            subclaseserv:{
                                                _id: $_idSubclaseServ,
                                                codigoSubclaseServ: $codigoSubclaseServ,
                                                descrSubclaseServ: $descrSubclaseServ
                                                claseserv:{
                                                    _id: $_idClaseServ,
                                                    codigoClaseServ: $codigoClaseServ,
                                                    descrClaseServ: $descrClaseServ
                                                },
                                            },
                                            porcDctoOferta: $porcDctoOferta,
                                            numDiasOferta: $numDiasOferta,
                                        },
                                    }){
                                    success
                                    errors{
                                        path
                                        message
                                        }                
                                    }
                                }
                            `,
                    editDpto: gpl`
                mutation($_id: ID!, $descrDpto: String!, $codigoDptoDANE: String){
                    editDpto(
                        dirmayor:{
                            _id: $_id,
                            descrDpto: $descrDpto,
                            codigoDptoDANE: $codigoDptoDANE
                        }
                    ){
                    success
                    errors{
                        path
                        message
                        }                
                    }
                }
            `,
            editClienteUpdDoc: gpl`
                mutation($_id: ID, $tipoAct: String, $contrato: String, $nombreCliente: String,
                    $apellidoCliente: String,
                    $descrEstrato: String,
                    $codigoDpto: String, $descrDpto: String, $codigoDptoDANE: String,
                    $codigoCiudad: String, $nombreCiudad: String, $codigoMunicipioDANE: String,
                    $codigoPostalDANE: String, $codigoCiudadInterno: String, $codBarrasRdo: String, 
                    $codigoZona: String, $nombreZona: String, $codigoBarrio: String, $nombreBarrio: String,
                    $codigoTipoDocT: String, $numeroDocumT: String, $descrRecursoT: String,
                    $codigoTipoDocR: String, $numeroDocumR: String, $descrRecursoR: String,
                    $descrTipoVia1: String, $numeroTipoVia1: String, $descrTipoVia2: String,
                    $numeroTipoVia2:String, $numeroTipoVia2F: String, $descrTipoUnd1: String,
                    $numeroTipoUnd1: String, $descrTipoUnd2: String, $numeroTipoUnd2: String,
                    $descrTiUndMat: String, $descrUndMat: String,
                    $codigoTarifa: String, $descrTarifa: String, $fechaVence: Date,
                    $codigoServicioT: String, $nombreResumidoT: String, $descripcionServicioT: String,
                    $_idSubclaseServT: ID, $codigoSubclaseServT: String, $descrSubclaseServT: String,
                    $_idClaseServT: ID, $codigoClaseServT: String, $descrClaseServT: String,
                    $velEfecDownstream: String, $velEfecUpstream: String,
                    $codigoTipoTec: String, $descrTipoTec: String, $colorServicio: String,
                    $estadoServicio: String,
                    $rango1NumServValorIni: Number, $rango1NumServValorFin: Number, $rango1Valor: Number,
                    $rango2NumServValorIni: Number, $rango2NumServValorFin: Number, $rango2Valor: Number,
                    $rango3NumServValorIni: Number, $rango3NumServValorFin: Number, $rango3Valor: Number,
                    $numeroServicios: Number, $valorServicios: Number, $valorAntesImptos: Number,
                    $codigoImpto: String, $descrImpto: String, $porcImpto: Number, $valorImpto: Number,
                    $codigoOferta: String, $descrOferta: String,
                    $codigoServicioO: String, $nombreResumidoO: String, $descripcionServicioO: String,
                    $_idSubclaseServO: ID, $codigoSubclaseServO: String, $descrSubclaseServO: String,
                    $_idClaseServO: ID, $codigoClaseServO: String, $descrClaseServO: String,
                    $porcDctoOferta: Number, $numDiasOferta: Number, $fechaFinOferta: Date,
                    $fechaInicioOferta: Date, $numeroSerie: String, $mac: String,
                    $_idClaseEqu: ID, $codigoClaseEqu: String, $descrClaseEqu: String,
                    $_idMarcaEqu: ID, $codigoMarcaEqu: String, $descrMarcaEqu: String,
                    $_idFabriEqu: ID, $codigoFabriEqu: String, $descrFabriEqu: String,
                    $_idBodega: ID, $codigoBodega: String, $descrBodega: String
                ){
                    editClienteUpdDoc(cliente:{
                        _id: $_id,
                        tipoAct: $tipoAct,
                        contrato: $contrato,
                        nombreCliente: $nombreCliente,
                        apellidoCliente: $apellidoCliente,
                        descrEstrato: $descrEstrato,
                        dirmayor:{
                            codigoDpto: $codigoDpto,
                            descrDpto: $descrDpto,
                            codigoDptoDANE: $codigoDptoDANE,
                            ciudades:{
                                codigoCiudad: $codigoCiudad,
                                nombreCiudad: $nombreCiudad,
                                codigoMunicipioDANE: $codigoMunicipioDANE,
                                codigoPostalDANE: $codigoPostalDANE,
                                codigoCiudadInterno: $codigoCiudadInterno,
                                codBarrasRdo: $codBarrasRdo,
                                zonas:{
                                    codigoZona: $codigoZona,
                                    nombreZona: $nombreZona,
                                    barrios:{
                                        codigoBarrio: $codigoBarrio,
                                        nombreBarrio: $nombreBarrio,
                                        codigoTipoDocT: $codigoTipoDocT,
                                        numeroDocumT: $numeroDocumT,
                                        descrRecursoT: $descrRecursoT,
                                        codigoTipoDocR: $codigoTipoDocR,
                                        numeroDocumR: $numeroDocumR,
                                        descrRecursoR: $descrRecursoR,
                                    }
                                }
                            }
                        },
                        direccion:{
                            descrTipoVia1: $descrTipoVia1,
                            numeroTipoVia1: $numeroTipoVia1,
                            descrTipoVia2: $descrTipoVia2,
                            numeroTipoVia2: $numeroTipoVia2,
                            numeroTipoVia2F: $numeroTipoVia2F,
                            descrTipoUnd1: $descrTipoUnd1,
                            numeroTipoUnd1: $numeroTipoUnd1,
                            descrTipoUnd2: $descrTipoUnd2,
                            numeroTipoUnd2: $numeroTipoUnd2,
                            descrTiUndMat: $descrTiUndMat,
                            descrUndMat: $descrUndMat
                        },
                        tarifa:{
                            codigoTarifa: $codigoTarifa,
                            descrTarifa: $descrTarifa,
                            fechaVence: $fechaVence,
                            servicios:{
                                codigoServicio: $codigoServicioT,
                                nombreResumido: $nombreResumidoT,
                                descripcionServicio: $descripcionServicioT,
                                subclaseserv:{
                                    _id: $_idSubclaseServT,
                                    codigoSubclaseServ: $codigoSubclaseServT,
                                    descrSubclaseServ: $descrSubclaseServT
                                    claseserv:{
                                        _id: $_idClaseServT,
                                        codigoClaseServ: $codigoClaseServT,
                                        descrClaseServ: $descrClaseServT
                                    },
                                },
                                velEfecDownstream: $velEfecDownstream,
                                velEfecUpstream: $velEfecUpstream,
                                codigoTipoTec: $codigoTipoTec,
                                descrTipoTec: $descrTipoTec,
                                colorServicio: $colorServicio,
                                estadoServicio: $estadoServicio,
                                rango1NumServValorIni: $rango1NumServValorIni,
                                rango1NumServValorFin: $rango1NumServValorFin,
                                rango1Valor: $rango1Valor,
                                rango2NumServValorIni: $rango2NumServValorIni,
                                rango2NumServValorFin: $rango2NumServValorFin,
                                rango2Valor: $rango2Valor,
                                rango3NumServValorIni: $rango3NumServValorIni,
                                rango3NumServValorFin: $rango3NumServValorFin,
                                rango3Valor: $rango3Valor,
                                numeroServicios: $numeroServicios,
                                valorServicios: $valorServicios,
                                valorAntesImptos: $valorAntesImptos,
                                imptos:{
                                    codigoImpto: $codigoImpto,
                                    descrImpto: $descrImpto,
                                    porcImpto: $porcImpto,
                                    valorImpto: $valorImpto,
                                }
                            }
                        },
                        oferta:{
                            codigoOferta: $codigoOferta,
                            descrOferta: $descrOferta,
                            servicios:{
                                codigoServicio: $codigoServicioO,
                                nombreResumido: $nombreResumidoO,
                                descripcionServicio: $descripcionServicioO,
                                subclaseserv:{
                                    _id: $_idSubclaseServO,
                                    codigoSubclaseServ: $codigoSubclaseServO,
                                    descrSubclaseServ: $descrSubclaseServO
                                    claseserv:{
                                        _id: $_idClaseServO,
                                        codigoClaseServ: $codigoClaseServO,
                                        descrClaseServ: $descrClaseServO
                                    }
                                },
                                porcDctoOferta: $porcDctoOferta,
                                numDiasOferta: $numDiasOferta,
                                fechaFinOferta: $fechaFinOferta,
                            },
                            fechaInicioOferta: $fechaInicioOferta
                        },
                        equipos:{
                            numeroSerie: $numeroSerie,
                            mac: $mac,
                            claseequ:{
                                _id: $_idClaseEqu,
                                codigoClaseEqu: $codigoClaseEqu,
                                descrClaseEqu: $descrClaseEqu
                            },
                            marcaequ:{
                                _id: $_idMarcaEqu,
                                codigoMarcaEqu: $codigoMarcaEqu,
                                descrMarcaEqu: $descrMarcaEqu
                            },
                            fabriequ:{
                                _id: $_idFabriEqu,
                                codigoFabriEqu: $codigoFabriEqu,
                                descrFabriEqu: $descrFabriEqu
                            },
                            bodega:{
                                _id: $_idBodega,
                                codigoBodega: $codigoBodega,
                                descrBodega: $descrBodega
                            }
                        },
                    }){
                    success
                    errors{
                        path
                        message
                        }                
                    }
                }
            `,
            editDptoUpdCiu: gpl`
                mutation($_id: ID!, $codigoDpto: String, $descrDpto: String,
                    $codigoCiudad: String, $nombreCiudad: String,
                    $codigoMunicipioDANE: String, $codigoPostalDANE: String,
                    $codigoCiudadInterno: String, $codBarrasRdo: String,
                    $fechaCreateCiu: Date, $usuarioCreateCiu: String,
                    $codigoZona: String, $nombreZona: String, $fechaCreateZon: Date, $usuarioCreateZon: String,
                    $codigoBarrio: String, $nombreBarrio: String,
                    $codigoTipoDocT: String, $numeroDocumT: String, $descrRecursoT: String,
                    $codigoTipoDocR: String, $numeroDocumR: String, $descrRecursoR: String,
                    $fechaCreateBarr: Date, $usuarioCreateBarr: String,
                    $tipoAct: String){
                    editDptoUpdCiu(dirmayor:{
                        _id: $_id,
                        codigoDpto: $codigoDpto,
                        descrDpto: $descrDpto,
                        tipoAct: $tipoAct,
                        ciudades:{
                            codigoCiudad: $codigoCiudad,
                            nombreCiudad: $nombreCiudad,
                            codigoMunicipioDANE: $codigoMunicipioDANE,
                            codigoPostalDANE: $codigoPostalDANE,
                            codigoCiudadInterno: $codigoCiudadInterno,
                            codBarrasRdo: $codBarrasRdo,
                            fechaCreate: $fechaCreateCiu,
                            usuarioCreate: $usuarioCreateCiu,
                            zonas:{
                                codigoZona: $codigoZona,
                                nombreZona: $nombreZona,
                                fechaCreate: $fechaCreateZon,
                                usuarioCreate: $usuarioCreateZon,
                                barrios:{
                                    codigoBarrio: $codigoBarrio,
                                    nombreBarrio: $nombreBarrio,
                                    codigoTipoDocT: $codigoTipoDocT,
                                    numeroDocumT: $numeroDocumT,
                                    descrRecursoT: $descrRecursoT,
                                    codigoTipoDocR: $codigoTipoDocR,
                                    numeroDocumR: $numeroDocumR,
                                    descrRecursoR: $descrRecursoR,
                                    fechaCreate: $fechaCreateBarr,
                                    usuarioCreate: $usuarioCreateBarr,
                                }
                            }
                        }
                    }){
                    success
                    errors{
                        path
                        message
                        }                
                    }
                }
            `,
            editUsuario: gpl`
              mutation($_id: ID, $tipoAct: String, $nombreUsuario: String, $claveDeAcceso: String,
                $idPerfil: ID, $descrPerfil: String,  $estadoUsuario: Boolean,
                $descrOficina: String, $_idDpto: String,
                $codigoDpto: String, $descrDpto: String, $codigoCiudad: String, $nombreCiudad: String,
                $numeroDocum: String, $descrTipoRec: String, $userApp: Boolean){
                  editUsuario(
                    usuario:{
                      _id: $_id,
                      tipoAct: $tipoAct,
                      nombreUsuario: $nombreUsuario,
                      claveDeAcceso: $claveDeAcceso,
                      perfil:{
                        _id: $idPerfil,
                        descrPerfil: $descrPerfil
                    },
                    estadoUsuario: $estadoUsuario,
                    descrOficina: $descrOficina,
                    _idDpto: $_idDpto,
                    codigoDpto: $codigoDpto,
                    descrDpto: $descrDpto,
                    codigoCiudad: $codigoCiudad,
                    nombreCiudad: $nombreCiudad,
                    numeroDocum: $numeroDocum,
                    descrTipoRec: $descrTipoRec,
                    userApp: $userApp
                  }
                ){
                  success
                  errors{
                    path
                    message
                  }                
                }
              }
              `,
              editProcDX: gpl`
                  mutation($_id: ID, $estadoProcDX: String){
                    editProcDX(
                        procdx:{
                              _id: $_id,
                              estadoProcDX: $estadoProcDX
                          }
                      ){
                          success
                          errors{
                              path
                              message
                          }                
                      }
                  }
              `,
              editTipoCliente: gpl`
                mutation($_id: ID!, $descrTipoCliente: String!, $descrTipoClienteAnt: String){
                    editTipoCliente(
                        tipocliente:{
                            _id: $_id,
                            descrTipoCliente: $descrTipoCliente
                            descrTipoClienteAnt: $descrTipoClienteAnt
                        }
                    ){
                        success
                        errors{
                            path
                            message
                        }                
                    }
                }
            `,
            editGrupoAfin: gpl`
                mutation($_id: ID!, $descrGrupoAfin: String!, $descrGrupoAfinAnt: String){
                    editGrupoAfin(
                        grupoafin:{
                            _id: $_id,
                            descrGrupoAfin: $descrGrupoAfin
                            descrGrupoAfinAnt: $descrGrupoAfinAnt
                        }
                    ){
                        success
                        errors{
                            path
                            message
                        }                
                    }
                }
            `,
            editTipoDoc: gpl`
                mutation($_id: ID!, $descrTipoDoc: String!){
                    editTipoDoc(
                        tipodoc:{
                            _id: $_id,
                            descrTipoDoc: $descrTipoDoc
                        }
                    ){
                        success
                        errors{
                            path
                            message
                        }                
                    }
                }
                `,
                editImpto: gpl`
                    mutation($_id: ID, $descrImpto: String, $porcImpto: Number){
                        editImpto(
                            impto:{
                                _id: $_id,
                                descrImpto: $descrImpto,
                                porcImpto: $porcImpto
                            }
                        ){
                            success
                            errors{
                                path
                                message
                            }                
                        }
                    }
                `,
                editOtrosPagCl: gpl`
                    mutation($_id: ID, $descrOtrosPagCl: String, $codigoImpto: String, $descrImpto: String,
                            $porcImpto: Number, $descrClaseServ: String){
                        editOtrosPagCl(
                            otrospagcl:{
                                _id: $_id,
                                descrOtrosPagCl: $descrOtrosPagCl,
                                codigoImpto: $codigoImpto,
                                descrImpto: $descrImpto,
                                porcImpto: $porcImpto,
                                descrClaseServ: $descrClaseServ
                            }
                        ){
                            success
                            errors{
                                path
                                message
                            }                
                        }
                    }
                `,
                editTipoOS: gpl`
                mutation($_id: ID, $descrTipoOS: String, $estadoAlCrear: String,
                    $permDireccion: String!, $permTarServ: String!, $permOfertas: String!,
                    $permEquipos: String!, $paraCliNuevo: String!, $pedirPtosAdic: String,
                    $permImprimir: String, $estadoCrearOS: String!, $estadoCerrarOS: String!,
                    $generalCliente: String, $genOSDirAnt: String, $tipoOSDirAnt: String
                ){
                        editTipoOS(
                            tipoos:{
                                _id: $_id,
                                descrTipoOS: $descrTipoOS
                                estadoAlCrear: $estadoAlCrear
                                permDireccion: $permDireccion
                                permTarServ: $permTarServ
                                permOfertas: $permOfertas
                                permEquipos: $permEquipos
                                paraCliNuevo: $paraCliNuevo
                                pedirPtosAdic: $pedirPtosAdic
                                permImprimir: $permImprimir
                                estadoCrearOS: $estadoCrearOS
                                estadoCerrarOS: $estadoCerrarOS
                                generalCliente: $generalCliente
                                genOSDirAnt: $genOSDirAnt
                                tipoOSDirAnt: $tipoOSDirAnt
                            }
                        ){
                            success
                            errors{
                                path
                                message
                            }                
                        }
                    }
                    `,
                    editClasifOST: gpl`
                      mutation($_id: ID, $descrClasifOST: String
                      ){
                        editClasifOST(
                          clasifost:{
                            _id: $_id,
                            descrClasifOST: $descrClasifOST
                          }
                        ){
                          success
                          errors{
                            path
                            message
                          }                
                        }
                      }
                      `,
                      editCategOST: gpl`
                        mutation($_id: ID, $descrCategOST: String, $observCategOST: String,
                            $codigoTipoOS: String, $descrTipoOS: String
                        ){
                          editCategOST(
                            categost:{
                              _id: $_id,
                              descrCategOST: $descrCategOST
                              observCategOST: $observCategOST
                              codigoTipoOS: $codigoTipoOS
                              descrTipoOS: $descrTipoOS
                            }
                          ){
                            success
                            errors{
                              path
                              message
                            }                
                          }
                        }
                        `,
                        editBoleta: gpl`
                          mutation($_id: ID, $numBoleta: String, $contrato: String,
                              $agno: String, $mes: String
                          ){
                            editBoleta(
                              boleta:{
                                _id: $_id,
                                numBoleta: $numBoleta
                                contrato: $contrato
                                agno: $agno
                                mes: $mes
                              }
                            ){
                              success
                              errors{
                                path
                                message
                              }                
                            }
                          }
                        `,
                        editBaseDat: gpl`
                      mutation($_id: ID, $basededatos: String, $descrBaseDat: String){
                        editBaseDat(
                          basedat:{
                            _id: $_id,
                            basededatos: $basededatos
                            descrBaseDat: $descrBaseDat
                          }
                        ){
                          success
                          errors{
                            path
                            message
                          }                
                        }
                      }
                    `,
              deleteAutorizac: gpl`
                mutation($_id: ID!){
                  deleteAutorizac(
                        _id: $_id
                    ){
                    success
                    errors{
                        path
                        message
                        }                
                    }
                }
                `,
                deletePerfil: gpl`
            mutation($_id: ID!){
              deletePerfil(
                    _id: $_id
                ){
                success
                errors{
                    path
                    message
                    }                
                }
            }
        `,
                deleteOdeS: gpl`
                    mutation($_id: ID!){
                        deleteOdeS(
                            _id: $_id
                        ){
                        success
                        errors{
                            path
                            message
                            }                
                        }
                    }
                    `,
                    deleteTipoRec: gpl`
                mutation($_id: ID!, $descrTipoRec: String){
                    deleteTipoRec(
                        _id: $_id
                        descrTipoRec: $descrTipoRec
                    ){
                      success
                      errors{
                          path
                          message
                          }                
                      }
                    }
                `,
                deleteRecurso: gpl`
                    mutation($_id: ID!){
                        deleteRecurso(
                            _id: $_id
                        ){
                        success
                        errors{
                            path
                            message
                            }                
                        }
                    }
                    `,
                    deleteRdoTerc: gpl`
                      mutation($archivo: String){
                        deleteRdoTerc(
                          archivo: $archivo
                        ){
                          success
                          errors{
                            path
                            message
                          }                
                        }
                      }
                        `,
                        deleteMesNoFra: gpl`
                            mutation($_id: ID!){
                              deleteMesNoFra(
                                    _id: $_id
                                ){
                                success
                                errors{
                                    path
                                    message
                                    }                
                                }
                            }
                            `,
                      deleteEquipo: gpl`
                mutation($_id: ID!){
                  deleteEquipo(
                    _id: $_id
                  ){
                    success
                    errors{
                    path
                    message
                  }
                }
              }
              `,
              deleteDetalleDX: gpl`
                mutation($_id: ID!){
                    deleteDetalleDX(
                    _id: $_id
                  ){
                    success
                    errors{
                    path
                    message
                  }
                }
              }
              `,
              deleteDetalleDXMany: gpl`
            mutation($detalledx: [idetalledxDel]){
                deleteDetalleDXMany(
                    detalledx: $detalledx
                ){
                    success
                    errors{
                        path
                        message
                        }                
                    }
                }
            `,
          deleteMovClientes: gpl`
                mutation($_id: ID!){
                  deleteMovClientes(
                    _id: $_id
                  ){
                    success
                    errors{
                    path
                    message
                  }
                }
              }
            `,
          deleteProgServ: gpl`
                mutation($_id: ID!){
                  deleteProgServ(
                    _id: $_id
                  ){
                    success
                    errors{
                    path
                    message
                  }
                }
              }
              `,
              deletePagoClientes: gpl`
                mutation($_id: ID!){
                  deletePagoClientes(
                    _id: $_id
                  ){
                    success
                    errors{
                    path
                    message
                  }
                }
              }
              `,
              deleteFacturacion: gpl`
                mutation($_id: ID!){
                  deleteFacturacion(
                    _id: $_id
                  ){
                    success
                    errors{
                    path
                    message
                  }
                }
              }
              `,
              deleteCargoEsp: gpl`
                mutation($_id: ID!){
                  deleteCargoEsp(
                    _id: $_id
                  ){
                    success
                    errors{
                    path
                    message
                  }
                }
              }
              `,
              deleteNotasDebCre: gpl`
                mutation($_id: ID!){
                  deleteNotasDebCre(
                    _id: $_id
                  ){
                    success
                    errors{
                    path
                    message
                  }
                }
              }
              `,
              deleteAjuste: gpl`
                mutation($_id: ID!){
                    deleteAjuste(
                    _id: $_id
                  ){
                    success
                    errors{
                    path
                    message
                  }
                }
              }
              `,
              deleteRangoFact: gpl`
                mutation($_id: ID!){
                  deleteRangoFact(
                    _id: $_id
                  ){
                    success
                    errors{
                    path
                    message
                  }
                }
              }
              `,
              deleteProcFact: gpl`
                mutation($_id: ID!){
                  deleteProcFact(
                    _id: $_id
                  ){
                    success
                    errors{
                    path
                    message
                  }
                }
              }
              `,
              deleteProcCE: gpl`
                mutation($_id: ID!){
                  deleteProcCE(
                    _id: $_id
                  ){
                    success
                    errors{
                    path
                    message
                  }
                }
              }
              `,
                deleteTiUndMat: gpl`
                mutation($_id: ID!){
                    deleteTiUndMat(
                        _id: $_id
                    ){
                    success
                    errors{
                        path
                        message
                        }                
                    }
                }
                `,
                deleteClaseEqu: gpl`
                    mutation($_id: ID!){
                        deleteClaseEqu(
                            _id: $_id
                        ){
                        success
                        errors{
                            path
                            message
                            }                
                        }
                    }
                    `,
                    deleteMarcaEqu: gpl`
                        mutation($_id: ID!){
                            deleteMarcaEqu(
                                _id: $_id
                            ){
                            success
                            errors{
                                path
                                message
                                }                
                            }
                        }
                        `,
                        deleteFabriEqu: gpl`
                            mutation($_id: ID!){
                                deleteFabriEqu(
                                    _id: $_id
                                ){
                                success
                                errors{
                                    path
                                    message
                                    }                
                                }
                            }
                            `,
                            deleteBodega: gpl`
                                mutation($_id: ID!){
                                    deleteBodega(
                                        _id: $_id
                                    ){
                                    success
                                    errors{
                                        path
                                        message
                                        }                
                                    }
                                }
                                `,
                                deleteOficina: gpl`
                                    mutation($_id: ID!, $descrOficina: String){
                                        deleteOficina(
                                            _id: $_id
                                            descrOficina: $descrOficina
                                        ){
                                        success
                                        errors{
                                            path
                                            message
                                            }                
                                        }
                                    }
                                    `,
                                    deleteUndMat: gpl`
                    mutation($_id: ID!){
                        deleteUndMat(
                            _id: $_id
                        ){
                        success
                        errors{
                            path
                            message
                            }                
                        }
                    }
                    `,
                    deleteTipoUnd: gpl`
                        mutation($_id: ID!){
                            deleteTipoUnd(
                                _id: $_id
                            ){
                            success
                            errors{
                                path
                                message
                                }                
                            }
                        }
                        `,
                        deleteTipoVia: gpl`
                            mutation($_id: ID!){
                                deleteTipoVia(
                                    _id: $_id
                                ){
                                success
                                errors{
                                    path
                                    message
                                    }                
                                }
                            }
                        `,
                        deleteEstrato: gpl`
                          mutation($_id: ID!){
                            deleteEstrato(
                              _id: $_id
                            ){
                              success
                              errors{
                                path
                                message
                              }                
                            }
                          }
                        `,
                        deleteNodo: gpl`
                          mutation($_id: ID!, $descrNodo: String){
                            deleteNodo(
                              _id: $_id
                              descrNodo: $descrNodo
                            ){
                              success
                              errors{
                                path
                                message
                              }                
                            }
                          }
                        `,
                        deleteCicloFact: gpl`
                        mutation($_id: ID!, $cicloFact: String){
                          deleteCicloFact(
                            _id: $_id
                            cicloFact: $cicloFact
                          ){
                            success
                            errors{
                                path
                                message
                                }                
                            }
                          }
              `,
              deleteClaseServ: gpl`
                mutation($_id: ID!, $codigoClaseServ: String){
                  deleteClaseServ(
                    _id: $_id
                    codigoClaseServ: $codigoClaseServ
                  ){
                    success
                    errors{
                        path
                        message
                        }                
                    }
                  }
                `,
                deleteTipoTec: gpl`
                  mutation($_id: ID!, $codigoTipoTec: String){
                    deleteTipoTec(
                      _id: $_id
                      codigoTipoTec: $codigoTipoTec
                    ){
                      success
                      errors{
                          path
                          message
                          }                
                      }
                    }
                  `,
                  deleteSegmento: gpl`
                    mutation($_id: ID!, $codigoSegmento: String){
                      deleteSegmento(
                        _id: $_id
                        codigoSegmento: $codigoSegmento
                      ){
                        success
                        errors{
                            path
                            message
                            }                
                        }
                      }
                    `,
                    deletePaquete: gpl`
                      mutation($_id: ID!, $codigoPaquete: String){
                        deletePaquete(
                          _id: $_id
                          codigoPaquete: $codigoPaquete
                        ){
                          success
                          errors{
                              path
                              message
                              }                
                          }
                        }
                        `,
                        deleteRteTrim_1: gpl`
                          mutation($_id: ID){
                            deleteRteTrim_1(
                              _id: $_id
                            ){
                              success
                              errors{
                                  path
                                  message
                                  }                
                              }
                            }
                        `,
                  deleteTipoAju: gpl`
                mutation($_id: ID!){
                  deleteTipoAju(
                    _id: $_id
                  ){
                  success
                  errors{
                    path
                    message
                  }                
                }
              }
              `,
              deleteBaseDat: gpl`
                mutation($_id: ID!){
                  deleteBaseDat(
                    _id: $_id
                  ){
                  success
                  errors{
                    path
                    message
                    }                
                  }
              }
            `,
            deleteTipoCliente: gpl`
                mutation($_id: ID!, $descrTipoCliente: String){
                    deleteTipoCliente(
                        _id: $_id
                        descrTipoCliente: $descrTipoCliente
                    ){
                    success
                    errors{
                        path
                        message
                        }                
                    }
                }
            `,
            deleteGrupoAfin: gpl`
                mutation($_id: ID!, $descrGrupoAfin: String){
                    deleteGrupoAfin(
                        _id: $_id
                        descrGrupoAfin: $descrGrupoAfin
                    ){
                    success
                    errors{
                        path
                        message
                        }                
                    }
                }
            `,
            deleteTipoDoc: gpl`
                mutation($_id: ID!){
                    deleteTipoDoc(
                        _id: $_id
                    ){
                    success
                    errors{
                        path
                        message
                        }                
                    }
                }
                `,
                deleteImpto: gpl`
                    mutation($_id: ID!){
                        deleteImpto(
                            _id: $_id
                        ){
                        success
                        errors{
                            path
                            message
                            }                
                        }
                    }
                    `,
                    deleteOtrosPagCl: gpl`
                        mutation($_id: ID!){
                            deleteOtrosPagCl(
                                _id: $_id
                            ){
                            success
                            errors{
                                path
                                message
                                }                
                            }
                        }
                    `,
                    deleteSubclaseServ: gpl`
                      mutation($_id: ID!, $codigoSubclaseServ: String){
                        deleteSubclaseServ(
                          _id: $_id
                          codigoSubclaseServ: $codigoSubclaseServ
                        ){
                          success
                          errors{
                              path
                              message
                              }                
                          }
                        }
                  `,
                  deleteTipoOS: gpl`
                    mutation($_id: ID!){
                        deleteTipoOS(
                            _id: $_id
                        ){
                        success
                        errors{
                            path
                            message
                            }                
                        }
                    }
                    `,
                    deleteClasifOST: gpl`
                      mutation($_id: ID!){
                          deleteClasifOST(
                              _id: $_id
                          ){
                          success
                          errors{
                              path
                              message
                              }                
                          }
                      }
                      `,
                      deleteCategOST: gpl`
                        mutation($_id: ID!){
                            deleteCategOST(
                                _id: $_id
                            ){
                            success
                            errors{
                                path
                                message
                                }                
                            }
                        }
                        `,
                        deleteBoleta: gpl`
                          mutation($_id: ID!){
                              deleteBoleta(
                                  _id: $_id
                              ){
                              success
                              errors{
                                  path
                                  message
                                  }                
                              }
                          }
                        `,
                        deleteTarifa: gpl`
                      mutation($_id: ID!, $codigoTarifa: String){
                        deleteTarifa(
                          _id: $_id
                          codigoTarifa: $codigoTarifa
                        ){
                          success
                          errors{
                              path
                              message
                              }                
                          }
                        }
                      `,
                            deleteOferta: gpl`
                            mutation($_id: ID!){
                                deleteOferta(
                                    _id: $_id
                                ){
                                success
                                errors{
                                    path
                                    message
                                    }                
                                }
                            }
                            `,
                        deleteCliente: gpl`
                mutation($_id: ID!, $contrato: String, $paraLog: String){
                    deleteCliente(
                        _id: $_id
                        contrato: $contrato
                        paraLog: $paraLog
                    ){
                    success
                    errors{
                        path
                        message
                        }                
                    }
                }
            `,
        deleteClienteUpdDoc: gpl`
            mutation($_id: ID!, $nombreCliente: String, $apellidoCliente: String, $_idServicio: String, $codigoServicio: String, $nombreResumido: String, $descripcionServicio: String, $_idSubclaseServ: ID, $codigoSubclaseServ: String, $descrSubclaseServ: String, $_idClaseServ: ID, $codigoClaseServ: String, $descrClaseServ: String){
                deleteClienteUpdDoc(cliente:{
                    _id: $_id,
                    nombreCliente: $nombreCliente,
                    apellidoCliente: $apellidoCliente,
                    servicios:{
                        _id: $_idServicio,
                        codigoServicio: $codigoServicio,
                        nombreResumido: $nombreResumido,
                        descripcionServicio: $descripcionServicio,
                        subclaseserv:{
                            _id: $_idSubclaseServ,
                            codigoSubclaseServ: $codigoSubclaseServ,
                            descrSubclaseServ: $descrSubclaseServ
                            claseserv:{
                                _id: $_idClaseServ,
                                codigoClaseServ: $codigoClaseServ,
                                descrClaseServ: $descrClaseServ
                            },
                        },
                    }
                }){
                success
                errors{
                    path
                    message
                    }                
                }
            }
        `,
        deleteDptoUpdCiu: gpl`
            mutation($_id: ID!, $codigoDpto: String, $descrDpto: String,
                $codigoCiudad: String, $nombreCiudad: String, $codigoCiudadInterno: String, $codBarrasRdo: String,
                $codigoZona: String, $nombreZona: String,
                $codigoBarrio: String, $nombreBarrio: String,
                $tipoAct: String){
                    deleteDptoUpdCiu(dirmayor:{
                        _id: $_id,
                        codigoDpto: $codigoDpto,
                        descrDpto: $descrDpto,
                        tipoAct: $tipoAct,
                        ciudades:{
                            codigoCiudad: $codigoCiudad,
                            nombreCiudad: $nombreCiudad,
                            codigoCiudadInterno: $codigoCiudadInterno,
                            codBarrasRdo: $codBarrasRdo,
                            zonas:{
                                codigoZona: $codigoZona,
                                nombreZona: $nombreZona,
                                barrios:{
                                    codigoBarrio: $codigoBarrio,
                                    nombreBarrio: $nombreBarrio,
                                }
                            }
                        }
                    }){
                    success
                    errors{
                        path
                        message
                        }                
                    }
                }
        `,
        deleteDpto: gpl`
          mutation($_id: ID!, $codigoDpto: String){
            deleteDpto(
              _id: $_id
              codigoDpto: $codigoDpto
            ){
              success
              errors{
                  path
                  message
                  }                
              }
            }
          `,
            deleteServicio: gpl`
              mutation($_id: ID!, $codigoServicio: String){
                deleteServicio(
                  _id: $_id
                  codigoServicio: $codigoServicio
                ){
                  success
                  errors{
                      path
                      message
                      }                
                  }
                }
                `,
                deleteCargoFras: gpl`
                    mutation($_id: ID!){
                        deleteCargoFras(
                            _id: $_id
                        ){
                        success
                        errors{
                            path
                            message
                            }                
                        }
                    }
                    `,
                    deleteUsuario: gpl`
                      mutation($_id: ID!, $email: String){
                        deleteUsuario(
                              _id: $_id
                              email: $email
                          ){
                            success
                            errors{
                                path
                                message
                                }                
                            }
                          }
                      `,
          },
    // subscription:{},
}